require('./opal');

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/normalize"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'Normalize');

      var $nesting = [self].concat($parent_nesting), $Normalize_comparison_operator$1, $Normalize_target_number$2;

      
      self.$module_function();
      
      Opal.def(self, '$comparison_operator', $Normalize_comparison_operator$1 = function $$comparison_operator(op) {
        var self = this, $case = nil;

        return (function() {$case = op;
        if (/<=|=</['$===']($case)) {return "<="}
        else if (/>=|=>/['$===']($case)) {return ">="}
        else if (/<>|!=|=!/['$===']($case)) {return "!="}
        else if (/</['$===']($case)) {return "<"}
        else if (/>/['$===']($case)) {return ">"}
        else if (/=/['$===']($case)) {return "=="}
        else { return nil }})()
      }, $Normalize_comparison_operator$1.$$arity = 1);
      
      Opal.def(self, '$target_number', $Normalize_target_number$2 = function $$target_number(val) {
        var self = this;

        if (val['$==']("?")) {
          return val
        } else {
          return val.$to_i()
        }
      }, $Normalize_target_number$2.$$arity = 1);
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["racc/parser"] = function(Opal) {
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  var $a, self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $truthy = Opal.truthy, $gvars = Opal.gvars, $send = Opal.send;

  
  (function($base, $parent_nesting) {
    var self = $module($base, 'Racc');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $super, $parent_nesting) {
      var self = $klass($base, $super, 'ParseError');

      var $nesting = [self].concat($parent_nesting);

      return nil
    })($nesting[0], $$($nesting, 'StandardError'), $nesting)
  })($nesting[0], $nesting);
  if ($truthy((($a = $$$('::', 'ParseError', 'skip_raise')) ? 'constant' : nil))) {
  } else {
    Opal.const_set($nesting[0], 'ParseError', $$$($$($nesting, 'Racc'), 'ParseError'))
  };
  return (function($base, $parent_nesting) {
    var self = $module($base, 'Racc');

    var $nesting = [self].concat($parent_nesting), $a;

    
    if ($truthy((($a = $$($nesting, 'Racc_No_Extensions', 'skip_raise')) ? 'constant' : nil))) {
    } else {
      Opal.const_set($nesting[0], 'Racc_No_Extensions', false)
    };
    (function($base, $super, $parent_nesting) {
      var self = $klass($base, $super, 'Parser');

      var $nesting = [self].concat($parent_nesting), $Parser_racc_runtime_type$1, $Parser__racc_setup$2, $Parser__racc_init_sysvars$3, $Parser_do_parse$4, $Parser_next_token$5, $Parser__racc_do_parse_rb$6, $Parser_yyparse$8, $Parser__racc_yyparse_rb$9, $Parser__racc_evalact$12, $Parser__racc_do_reduce$14, $Parser_on_error$15, $Parser_yyerror$16, $Parser_yyaccept$17, $Parser_yyerrok$18, $Parser_racc_read_token$19, $Parser_racc_shift$20, $Parser_racc_reduce$21, $Parser_racc_accept$23, $Parser_racc_e_pop$24, $Parser_racc_next_state$25, $Parser_racc_print_stacks$26, $Parser_racc_print_states$28, $Parser_racc_token2str$30, $Parser_token_to_str$31;

      self.$$prototype.yydebug = self.$$prototype.racc_debug_out = self.$$prototype.racc_error_status = self.$$prototype.racc_t = self.$$prototype.racc_vstack = self.$$prototype.racc_val = self.$$prototype.racc_state = self.$$prototype.racc_tstack = nil;
      
      Opal.const_set($nesting[0], 'Racc_Runtime_Version', "1.4.6");
      Opal.const_set($nesting[0], 'Racc_Runtime_Revision', ["originalRevision:", "1.8"]['$[]'](1));
      Opal.const_set($nesting[0], 'Racc_Runtime_Core_Version_R', "1.4.6");
      Opal.const_set($nesting[0], 'Racc_Runtime_Core_Revision_R', ["originalRevision:", "1.8"]['$[]'](1));
      Opal.const_set($nesting[0], 'Racc_Main_Parsing_Routine', "_racc_do_parse_rb");
      Opal.const_set($nesting[0], 'Racc_YY_Parse_Method', "_racc_yyparse_rb");
      Opal.const_set($nesting[0], 'Racc_Runtime_Core_Version', $$($nesting, 'Racc_Runtime_Core_Version_R'));
      Opal.const_set($nesting[0], 'Racc_Runtime_Core_Revision', $$($nesting, 'Racc_Runtime_Core_Revision_R'));
      Opal.const_set($nesting[0], 'Racc_Runtime_Type', "ruby");
      Opal.defs($$($nesting, 'Parser'), '$racc_runtime_type', $Parser_racc_runtime_type$1 = function $$racc_runtime_type() {
        var self = this;

        return $$($nesting, 'Racc_Runtime_Type')
      }, $Parser_racc_runtime_type$1.$$arity = 0);
      
      Opal.def(self, '$_racc_setup', $Parser__racc_setup$2 = function $$_racc_setup() {
        var $a, $b, self = this, $ret_or_1 = nil, arg = nil, $writer = nil;
        if ($gvars.stderr == null) $gvars.stderr = nil;

        
        if ($truthy($$$(self.$class(), 'Racc_debug_parser'))) {
        } else {
          self.yydebug = false
        };
        if ($truthy((($a = self['yydebug'], $a != null && $a !== nil) ? 'instance-variable' : nil))) {
        } else {
          self.yydebug = false
        };
        if ($truthy(self.yydebug)) {
          
          if ($truthy((($b = self['racc_debug_out'], $b != null && $b !== nil) ? 'instance-variable' : nil))) {
          } else {
            self.racc_debug_out = $gvars.stderr
          };
          self.racc_debug_out = (function() {if ($truthy(($ret_or_1 = self.racc_debug_out))) {
            return $ret_or_1
          } else {
            return $gvars.stderr
          }; return nil; })();};
        arg = $$$(self.$class(), 'Racc_arg');
        if ($truthy($rb_lt(arg.$size(), 14))) {
          
          $writer = [13, true];
          $send(arg, '[]=', Opal.to_a($writer));
          $writer[$rb_minus($writer["length"], 1)];};
        return arg;
      }, $Parser__racc_setup$2.$$arity = 0);
      
      Opal.def(self, '$_racc_init_sysvars', $Parser__racc_init_sysvars$3 = function $$_racc_init_sysvars() {
        var self = this;

        
        self.racc_state = [0];
        self.racc_tstack = [];
        self.racc_vstack = [];
        self.racc_t = nil;
        self.racc_val = nil;
        self.racc_read_next = true;
        self.racc_user_yyerror = false;
        return (self.racc_error_status = 0);
      }, $Parser__racc_init_sysvars$3.$$arity = 0);
      
      Opal.def(self, '$do_parse', $Parser_do_parse$4 = function $$do_parse() {
        var self = this;

        return self.$__send__($$($nesting, 'Racc_Main_Parsing_Routine'), self.$_racc_setup(), false)
      }, $Parser_do_parse$4.$$arity = 0);
      
      Opal.def(self, '$next_token', $Parser_next_token$5 = function $$next_token() {
        var self = this;

        return self.$raise($$($nesting, 'NotImplementedError'), "" + (self.$class()) + "#next_token is not defined")
      }, $Parser_next_token$5.$$arity = 0);
      
      Opal.def(self, '$_racc_do_parse_rb', $Parser__racc_do_parse_rb$6 = function $$_racc_do_parse_rb(arg, in_debug) {
        var $a, $b, $$7, self = this, action_table = nil, action_check = nil, action_default = nil, action_pointer = nil, _ = nil, token_table = nil, tok = nil, act = nil, i = nil;

        
        $b = arg, $a = Opal.to_ary($b), (action_table = ($a[0] == null ? nil : $a[0])), (action_check = ($a[1] == null ? nil : $a[1])), (action_default = ($a[2] == null ? nil : $a[2])), (action_pointer = ($a[3] == null ? nil : $a[3])), (_ = ($a[4] == null ? nil : $a[4])), (_ = ($a[5] == null ? nil : $a[5])), (_ = ($a[6] == null ? nil : $a[6])), (_ = ($a[7] == null ? nil : $a[7])), (_ = ($a[8] == null ? nil : $a[8])), (_ = ($a[9] == null ? nil : $a[9])), (token_table = ($a[10] == null ? nil : $a[10])), (_ = ($a[11] == null ? nil : $a[11])), (_ = ($a[12] == null ? nil : $a[12])), (_ = ($a[13] == null ? nil : $a[13])), $b;
        self.$_racc_init_sysvars();
        tok = (act = (i = nil));
        return $send(self, 'catch', ["racc_end_parse"], ($$7 = function(){var self = $$7.$$s == null ? this : $$7.$$s, $c, $d, $e, $ret_or_2 = nil, $ret_or_3 = nil, $ret_or_4 = nil;
          if (self.racc_state == null) self.racc_state = nil;
          if (self.racc_read_next == null) self.racc_read_next = nil;
          if (self.racc_t == null) self.racc_t = nil;
          if (self.yydebug == null) self.yydebug = nil;
          if (self.racc_val == null) self.racc_val = nil;

        while ($truthy(true)) {
            
            if ($truthy((i = action_pointer['$[]'](self.racc_state['$[]'](-1))))) {
              
              if ($truthy(self.racc_read_next)) {
                if ($truthy(self.racc_t['$!='](0))) {
                  
                  $e = self.$next_token(), $d = Opal.to_ary($e), (tok = ($d[0] == null ? nil : $d[0])), (self.racc_val = ($d[1] == null ? nil : $d[1])), $e;
                  if ($truthy(tok)) {
                    self.racc_t = (function() {if ($truthy(($ret_or_2 = token_table['$[]'](tok)))) {
                      return $ret_or_2
                    } else {
                      return 1
                    }; return nil; })()
                  } else {
                    self.racc_t = 0
                  };
                  if ($truthy(self.yydebug)) {
                    self.$racc_read_token(self.racc_t, tok, self.racc_val)};
                  self.racc_read_next = false;}};
              i = $rb_plus(i, self.racc_t);
              if ($truthy((function() {if ($truthy(($ret_or_3 = (function() {if ($truthy(($ret_or_4 = $rb_ge(i, 0)))) {
                return (act = action_table['$[]'](i))
              } else {
                return $ret_or_4
              }; return nil; })()))) {
                return action_check['$[]'](i)['$=='](self.racc_state['$[]'](-1))
              } else {
                return $ret_or_3
              }; return nil; })())) {
              } else {
                act = action_default['$[]'](self.racc_state['$[]'](-1))
              };
            } else {
              act = action_default['$[]'](self.racc_state['$[]'](-1))
            };
            while ($truthy((act = self.$_racc_evalact(act, arg)))) {
              
            };
          }}, $$7.$$s = self, $$7.$$arity = 0, $$7));
      }, $Parser__racc_do_parse_rb$6.$$arity = 2);
      
      Opal.def(self, '$yyparse', $Parser_yyparse$8 = function $$yyparse(recv, mid) {
        var self = this;

        return self.$__send__($$($nesting, 'Racc_YY_Parse_Method'), recv, mid, self.$_racc_setup(), true)
      }, $Parser_yyparse$8.$$arity = 2);
      
      Opal.def(self, '$_racc_yyparse_rb', $Parser__racc_yyparse_rb$9 = function $$_racc_yyparse_rb(recv, mid, arg, c_debug) {
        var $a, $b, $$10, self = this, action_table = nil, action_check = nil, action_default = nil, action_pointer = nil, _ = nil, token_table = nil, act = nil, i = nil;

        
        $b = arg, $a = Opal.to_ary($b), (action_table = ($a[0] == null ? nil : $a[0])), (action_check = ($a[1] == null ? nil : $a[1])), (action_default = ($a[2] == null ? nil : $a[2])), (action_pointer = ($a[3] == null ? nil : $a[3])), (_ = ($a[4] == null ? nil : $a[4])), (_ = ($a[5] == null ? nil : $a[5])), (_ = ($a[6] == null ? nil : $a[6])), (_ = ($a[7] == null ? nil : $a[7])), (_ = ($a[8] == null ? nil : $a[8])), (_ = ($a[9] == null ? nil : $a[9])), (token_table = ($a[10] == null ? nil : $a[10])), (_ = ($a[11] == null ? nil : $a[11])), (_ = ($a[12] == null ? nil : $a[12])), (_ = ($a[13] == null ? nil : $a[13])), $b;
        self.$_racc_init_sysvars();
        act = nil;
        i = nil;
        return $send(self, 'catch', ["racc_end_parse"], ($$10 = function(){var self = $$10.$$s == null ? this : $$10.$$s, $c, $d, $$11;
          if (self.racc_state == null) self.racc_state = nil;

        
          while (!($truthy((i = action_pointer['$[]'](self.racc_state['$[]'](-1)))))) {
            while ($truthy((act = self.$_racc_evalact(action_default['$[]'](self.racc_state['$[]'](-1)), arg)))) {
              
            }
          };
          return $send(recv, '__send__', [mid], ($$11 = function(tok, val){var self = $$11.$$s == null ? this : $$11.$$s, $e, $f, $ret_or_5 = nil, $ret_or_6 = nil, $ret_or_7 = nil, $ret_or_8 = nil, $ret_or_9 = nil, $ret_or_10 = nil, $ret_or_11 = nil, $ret_or_12 = nil, $ret_or_13 = nil;
            if (self.racc_t == null) self.racc_t = nil;
            if (self.racc_state == null) self.racc_state = nil;
            if (self.racc_read_next == null) self.racc_read_next = nil;

          
            
            if (tok == null) {
              tok = nil;
            };
            
            if (val == null) {
              val = nil;
            };
            if ($truthy(tok)) {
              self.racc_t = (function() {if ($truthy(($ret_or_5 = token_table['$[]'](tok)))) {
                return $ret_or_5
              } else {
                return 1
              }; return nil; })()
            } else {
              self.racc_t = 0
            };
            self.racc_val = val;
            self.racc_read_next = false;
            i = $rb_plus(i, self.racc_t);
            if ($truthy((function() {if ($truthy(($ret_or_6 = (function() {if ($truthy(($ret_or_7 = $rb_ge(i, 0)))) {
              return (act = action_table['$[]'](i))
            } else {
              return $ret_or_7
            }; return nil; })()))) {
              return action_check['$[]'](i)['$=='](self.racc_state['$[]'](-1))
            } else {
              return $ret_or_6
            }; return nil; })())) {
            } else {
              act = action_default['$[]'](self.racc_state['$[]'](-1))
            };
            while ($truthy((act = self.$_racc_evalact(act, arg)))) {
              
            };
            while ($truthy((function() {if ($truthy(($ret_or_8 = (function() {if ($truthy(($ret_or_9 = (i = action_pointer['$[]'](self.racc_state['$[]'](-1)))['$!']()))) {
              return $ret_or_9
            } else {
              return self.racc_read_next['$!']()
            }; return nil; })()))) {
              return $ret_or_8
            } else {
              return self.racc_t['$=='](0)
            }; return nil; })())) {
              
              if ($truthy((function() {if ($truthy(($ret_or_10 = (function() {if ($truthy(($ret_or_11 = (function() {if ($truthy(($ret_or_12 = (function() {if ($truthy(($ret_or_13 = i))) {
                return (i = $rb_plus(i, self.racc_t))
              } else {
                return $ret_or_13
              }; return nil; })()))) {
                return $rb_ge(i, 0)
              } else {
                return $ret_or_12
              }; return nil; })()))) {
                return (act = action_table['$[]'](i))
              } else {
                return $ret_or_11
              }; return nil; })()))) {
                return action_check['$[]'](i)['$=='](self.racc_state['$[]'](-1))
              } else {
                return $ret_or_10
              }; return nil; })())) {
              } else {
                act = action_default['$[]'](self.racc_state['$[]'](-1))
              };
              while ($truthy((act = self.$_racc_evalact(act, arg)))) {
                
              };
            };}, $$11.$$s = self, $$11.$$arity = 2, $$11));}, $$10.$$s = self, $$10.$$arity = 0, $$10));
      }, $Parser__racc_yyparse_rb$9.$$arity = 4);
      
      Opal.def(self, '$_racc_evalact', $Parser__racc_evalact$12 = function $$_racc_evalact(act, arg) {
        var $a, $b, $$13, self = this, action_table = nil, action_check = nil, _ = nil, action_pointer = nil, shift_n = nil, reduce_n = nil, $ret_or_14 = nil, $ret_or_15 = nil, code = nil, $case = nil, i = nil, $ret_or_16 = nil, $ret_or_17 = nil;

        
        $b = arg, $a = Opal.to_ary($b), (action_table = ($a[0] == null ? nil : $a[0])), (action_check = ($a[1] == null ? nil : $a[1])), (_ = ($a[2] == null ? nil : $a[2])), (action_pointer = ($a[3] == null ? nil : $a[3])), (_ = ($a[4] == null ? nil : $a[4])), (_ = ($a[5] == null ? nil : $a[5])), (_ = ($a[6] == null ? nil : $a[6])), (_ = ($a[7] == null ? nil : $a[7])), (_ = ($a[8] == null ? nil : $a[8])), (_ = ($a[9] == null ? nil : $a[9])), (_ = ($a[10] == null ? nil : $a[10])), (shift_n = ($a[11] == null ? nil : $a[11])), (reduce_n = ($a[12] == null ? nil : $a[12])), (_ = ($a[13] == null ? nil : $a[13])), (_ = ($a[14] == null ? nil : $a[14])), $b;
        if ($truthy((function() {if ($truthy(($ret_or_14 = $rb_gt(act, 0)))) {
          return $rb_lt(act, shift_n)
        } else {
          return $ret_or_14
        }; return nil; })())) {
          
          if ($truthy($rb_gt(self.racc_error_status, 0))) {
            if (self.racc_t['$=='](1)) {
            } else {
              self.racc_error_status = $rb_minus(self.racc_error_status, 1)
            }};
          self.racc_vstack.$push(self.racc_val);
          self.racc_state.$push(act);
          self.racc_read_next = true;
          if ($truthy(self.yydebug)) {
            
            self.racc_tstack.$push(self.racc_t);
            self.$racc_shift(self.racc_t, self.racc_tstack, self.racc_vstack);};
        } else if ($truthy((function() {if ($truthy(($ret_or_15 = $rb_lt(act, 0)))) {
          return $rb_gt(act, reduce_n['$-@']())
        } else {
          return $ret_or_15
        }; return nil; })())) {
          
          code = $send(self, 'catch', ["racc_jump"], ($$13 = function(){var self = $$13.$$s == null ? this : $$13.$$s;
            if (self.racc_state == null) self.racc_state = nil;

          
            self.racc_state.$push(self.$_racc_do_reduce(arg, act));
            return false;}, $$13.$$s = self, $$13.$$arity = 0, $$13));
          if ($truthy(code)) {
            $case = code;
            if ((1)['$===']($case)) {
            self.racc_user_yyerror = true;
            return reduce_n['$-@']();}
            else if ((2)['$===']($case)) {return shift_n}
            else {self.$raise("[Racc Bug] unknown jump code")}};
        } else if (act['$=='](shift_n)) {
          
          if ($truthy(self.yydebug)) {
            self.$racc_accept()};
          self.$throw("racc_end_parse", self.racc_vstack['$[]'](0));
        } else if (act['$=='](reduce_n['$-@']())) {
          
          $case = self.racc_error_status;
          if ((0)['$===']($case)) {if ($truthy(arg['$[]'](21))) {
          } else {
            self.$on_error(self.racc_t, self.racc_val, self.racc_vstack)
          }}
          else if ((3)['$===']($case)) {
          if (self.racc_t['$=='](0)) {
            self.$throw("racc_end_parse", nil)};
          self.racc_read_next = true;};
          self.racc_user_yyerror = false;
          self.racc_error_status = 3;
          while ($truthy(true)) {
            
            if ($truthy((i = action_pointer['$[]'](self.racc_state['$[]'](-1))))) {
              
              i = $rb_plus(i, 1);
              if ($truthy((function() {if ($truthy(($ret_or_16 = (function() {if ($truthy(($ret_or_17 = $rb_ge(i, 0)))) {
                
                return (act = action_table['$[]'](i));
              } else {
                return $ret_or_17
              }; return nil; })()))) {
                return action_check['$[]'](i)['$=='](self.racc_state['$[]'](-1))
              } else {
                return $ret_or_16
              }; return nil; })())) {
                break;};};
            if ($truthy($rb_le(self.racc_state.$size(), 1))) {
              self.$throw("racc_end_parse", nil)};
            self.racc_state.$pop();
            self.racc_vstack.$pop();
            if ($truthy(self.yydebug)) {
              
              self.racc_tstack.$pop();
              self.$racc_e_pop(self.racc_state, self.racc_tstack, self.racc_vstack);};
          };
          return act;
        } else {
          self.$raise("" + "[Racc Bug] unknown action " + (act.$inspect()))
        };
        if ($truthy(self.yydebug)) {
          self.$racc_next_state(self.racc_state['$[]'](-1), self.racc_state)};
        return nil;
      }, $Parser__racc_evalact$12.$$arity = 2);
      
      Opal.def(self, '$_racc_do_reduce', $Parser__racc_do_reduce$14 = function $$_racc_do_reduce(arg, act) {
        var $a, $b, self = this, _ = nil, goto_table = nil, goto_check = nil, goto_default = nil, goto_pointer = nil, nt_base = nil, reduce_table = nil, use_result = nil, state = nil, vstack = nil, tstack = nil, i = nil, len = nil, reduce_to = nil, method_id = nil, void_array = nil, tmp_t = nil, tmp_v = nil, $writer = nil, k1 = nil, $ret_or_18 = nil, $ret_or_19 = nil, curstate = nil;

        
        $b = arg, $a = Opal.to_ary($b), (_ = ($a[0] == null ? nil : $a[0])), (_ = ($a[1] == null ? nil : $a[1])), (_ = ($a[2] == null ? nil : $a[2])), (_ = ($a[3] == null ? nil : $a[3])), (goto_table = ($a[4] == null ? nil : $a[4])), (goto_check = ($a[5] == null ? nil : $a[5])), (goto_default = ($a[6] == null ? nil : $a[6])), (goto_pointer = ($a[7] == null ? nil : $a[7])), (nt_base = ($a[8] == null ? nil : $a[8])), (reduce_table = ($a[9] == null ? nil : $a[9])), (_ = ($a[10] == null ? nil : $a[10])), (_ = ($a[11] == null ? nil : $a[11])), (_ = ($a[12] == null ? nil : $a[12])), (use_result = ($a[13] == null ? nil : $a[13])), $b;
        state = self.racc_state;
        vstack = self.racc_vstack;
        tstack = self.racc_tstack;
        i = $rb_times(act, -3);
        len = reduce_table['$[]'](i);
        reduce_to = reduce_table['$[]']($rb_plus(i, 1));
        method_id = reduce_table['$[]']($rb_plus(i, 2));
        void_array = [];
        if ($truthy(self.yydebug)) {
          tmp_t = tstack['$[]'](len['$-@'](), len)};
        tmp_v = vstack['$[]'](len['$-@'](), len);
        if ($truthy(self.yydebug)) {
          
          $writer = [len['$-@'](), len, void_array];
          $send(tstack, '[]=', Opal.to_a($writer));
          $writer[$rb_minus($writer["length"], 1)];};
        
        $writer = [len['$-@'](), len, void_array];
        $send(vstack, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        
        $writer = [len['$-@'](), len, void_array];
        $send(state, '[]=', Opal.to_a($writer));
        $writer[$rb_minus($writer["length"], 1)];;
        if ($truthy(use_result)) {
          vstack.$push(self.$__send__(method_id, tmp_v, vstack, tmp_v['$[]'](0)))
        } else {
          vstack.$push(self.$__send__(method_id, tmp_v, vstack))
        };
        tstack.$push(reduce_to);
        if ($truthy(self.yydebug)) {
          self.$racc_reduce(tmp_t, reduce_to, tstack, vstack)};
        k1 = $rb_minus(reduce_to, nt_base);
        if ($truthy((i = goto_pointer['$[]'](k1)))) {
          
          i = $rb_plus(i, state['$[]'](-1));
          if ($truthy((function() {if ($truthy(($ret_or_18 = (function() {if ($truthy(($ret_or_19 = $rb_ge(i, 0)))) {
            
            return (curstate = goto_table['$[]'](i));
          } else {
            return $ret_or_19
          }; return nil; })()))) {
            return goto_check['$[]'](i)['$=='](k1)
          } else {
            return $ret_or_18
          }; return nil; })())) {
            return curstate};};
        return goto_default['$[]'](k1);
      }, $Parser__racc_do_reduce$14.$$arity = 2);
      
      Opal.def(self, '$on_error', $Parser_on_error$15 = function $$on_error(t, val, vstack) {
        var self = this, $ret_or_20 = nil;

        return self.$raise($$($nesting, 'ParseError'), self.$sprintf("\nparse error on value %s (%s)", val.$inspect(), (function() {if ($truthy(($ret_or_20 = self.$token_to_str(t)))) {
          return $ret_or_20
        } else {
          return "?"
        }; return nil; })()))
      }, $Parser_on_error$15.$$arity = 3);
      
      Opal.def(self, '$yyerror', $Parser_yyerror$16 = function $$yyerror() {
        var self = this;

        return self.$throw("racc_jump", 1)
      }, $Parser_yyerror$16.$$arity = 0);
      
      Opal.def(self, '$yyaccept', $Parser_yyaccept$17 = function $$yyaccept() {
        var self = this;

        return self.$throw("racc_jump", 2)
      }, $Parser_yyaccept$17.$$arity = 0);
      
      Opal.def(self, '$yyerrok', $Parser_yyerrok$18 = function $$yyerrok() {
        var self = this;

        return (self.racc_error_status = 0)
      }, $Parser_yyerrok$18.$$arity = 0);
      
      Opal.def(self, '$racc_read_token', $Parser_racc_read_token$19 = function $$racc_read_token(t, tok, val) {
        var self = this;

        
        self.racc_debug_out.$print("read    ");
        self.racc_debug_out.$print(tok.$inspect(), "(", self.$racc_token2str(t), ") ");
        self.racc_debug_out.$puts(val.$inspect());
        return self.racc_debug_out.$puts();
      }, $Parser_racc_read_token$19.$$arity = 3);
      
      Opal.def(self, '$racc_shift', $Parser_racc_shift$20 = function $$racc_shift(tok, tstack, vstack) {
        var self = this;

        
        self.racc_debug_out.$puts("" + "shift   " + (self.$racc_token2str(tok)));
        self.$racc_print_stacks(tstack, vstack);
        return self.racc_debug_out.$puts();
      }, $Parser_racc_shift$20.$$arity = 3);
      
      Opal.def(self, '$racc_reduce', $Parser_racc_reduce$21 = function $$racc_reduce(toks, sim, tstack, vstack) {
        var $$22, self = this, out = nil;

        
        out = self.racc_debug_out;
        out.$print("reduce ");
        if ($truthy(toks['$empty?']())) {
          out.$print(" <none>")
        } else {
          $send(toks, 'each', [], ($$22 = function(t){var self = $$22.$$s == null ? this : $$22.$$s;

          
            
            if (t == null) {
              t = nil;
            };
            return out.$print(" ", self.$racc_token2str(t));}, $$22.$$s = self, $$22.$$arity = 1, $$22))
        };
        out.$puts("" + " --> " + (self.$racc_token2str(sim)));
        self.$racc_print_stacks(tstack, vstack);
        return self.racc_debug_out.$puts();
      }, $Parser_racc_reduce$21.$$arity = 4);
      
      Opal.def(self, '$racc_accept', $Parser_racc_accept$23 = function $$racc_accept() {
        var self = this;

        
        self.racc_debug_out.$puts("accept");
        return self.racc_debug_out.$puts();
      }, $Parser_racc_accept$23.$$arity = 0);
      
      Opal.def(self, '$racc_e_pop', $Parser_racc_e_pop$24 = function $$racc_e_pop(state, tstack, vstack) {
        var self = this;

        
        self.racc_debug_out.$puts("error recovering mode: pop token");
        self.$racc_print_states(state);
        self.$racc_print_stacks(tstack, vstack);
        return self.racc_debug_out.$puts();
      }, $Parser_racc_e_pop$24.$$arity = 3);
      
      Opal.def(self, '$racc_next_state', $Parser_racc_next_state$25 = function $$racc_next_state(curstate, state) {
        var self = this;

        
        self.racc_debug_out.$puts("" + "goto    " + (curstate));
        self.$racc_print_states(state);
        return self.racc_debug_out.$puts();
      }, $Parser_racc_next_state$25.$$arity = 2);
      
      Opal.def(self, '$racc_print_stacks', $Parser_racc_print_stacks$26 = function $$racc_print_stacks(t, v) {
        var $$27, self = this, out = nil;

        
        out = self.racc_debug_out;
        out.$print("        [");
        $send(t, 'each_index', [], ($$27 = function(i){var self = $$27.$$s == null ? this : $$27.$$s;

        
          
          if (i == null) {
            i = nil;
          };
          return out.$print(" (", self.$racc_token2str(t['$[]'](i)), " ", v['$[]'](i).$inspect(), ")");}, $$27.$$s = self, $$27.$$arity = 1, $$27));
        return out.$puts(" ]");
      }, $Parser_racc_print_stacks$26.$$arity = 2);
      
      Opal.def(self, '$racc_print_states', $Parser_racc_print_states$28 = function $$racc_print_states(s) {
        var $$29, self = this, out = nil;

        
        out = self.racc_debug_out;
        out.$print("        [");
        $send(s, 'each', [], ($$29 = function(st){var self = $$29.$$s == null ? this : $$29.$$s;

        
          
          if (st == null) {
            st = nil;
          };
          return out.$print(" ", st);}, $$29.$$s = self, $$29.$$arity = 1, $$29));
        return out.$puts(" ]");
      }, $Parser_racc_print_states$28.$$arity = 1);
      
      Opal.def(self, '$racc_token2str', $Parser_racc_token2str$30 = function $$racc_token2str(tok) {
        var self = this, $ret_or_21 = nil;

        if ($truthy(($ret_or_21 = $$$(self.$class(), 'Racc_token_to_s_table')['$[]'](tok)))) {
          return $ret_or_21
        } else {
          return self.$raise("" + "[Racc Bug] can't convert token " + (tok) + " to string")
        }
      }, $Parser_racc_token2str$30.$$arity = 1);
      return (Opal.def(self, '$token_to_str', $Parser_token_to_str$31 = function $$token_to_str(t) {
        var self = this;

        return $$$(self.$class(), 'Racc_token_to_s_table')['$[]'](t)
      }, $Parser_token_to_str$31.$$arity = 1), nil) && 'token_to_str';
    })($nesting[0], null, $nesting);
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["strscan"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $klass = Opal.klass, $truthy = Opal.truthy, $send = Opal.send;

  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'StringScanner');

    var $nesting = [self].concat($parent_nesting), $StringScanner_initialize$1, $StringScanner_beginning_of_line$ques$2, $StringScanner_scan$3, $StringScanner_scan_until$4, $StringScanner_$$$5, $StringScanner_check$6, $StringScanner_check_until$7, $StringScanner_peek$8, $StringScanner_eos$ques$9, $StringScanner_exist$ques$10, $StringScanner_skip$11, $StringScanner_skip_until$12, $StringScanner_get_byte$13, $StringScanner_match$ques$14, $StringScanner_pos$eq$15, $StringScanner_matched_size$16, $StringScanner_post_match$17, $StringScanner_pre_match$18, $StringScanner_reset$19, $StringScanner_rest$20, $StringScanner_rest$ques$21, $StringScanner_rest_size$22, $StringScanner_terminate$23, $StringScanner_unscan$24, $StringScanner_anchor$25;

    self.$$prototype.pos = self.$$prototype.string = self.$$prototype.working = self.$$prototype.matched = self.$$prototype.prev_pos = self.$$prototype.match = nil;
    
    self.$attr_reader("pos");
    self.$attr_reader("matched");
    
    Opal.def(self, '$initialize', $StringScanner_initialize$1 = function $$initialize(string) {
      var self = this;

      
      self.string = string;
      self.pos = 0;
      self.matched = nil;
      self.working = string;
      return (self.match = []);
    }, $StringScanner_initialize$1.$$arity = 1);
    self.$attr_reader("string");
    
    Opal.def(self, '$beginning_of_line?', $StringScanner_beginning_of_line$ques$2 = function() {
      var self = this;

      return self.pos === 0 || self.string.charAt(self.pos - 1) === "\n"
    }, $StringScanner_beginning_of_line$ques$2.$$arity = 0);
    Opal.alias(self, "bol?", "beginning_of_line?");
    
    Opal.def(self, '$scan', $StringScanner_scan$3 = function $$scan(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var result = pattern.exec(self.working);

      if (result == null) {
        return self.matched = nil;
      }
      else if (typeof(result) === 'object') {
        self.prev_pos = self.pos;
        self.pos     += result[0].length;
        self.working  = self.working.substring(result[0].length);
        self.matched  = result[0];
        self.match    = result;

        return result[0];
      }
      else if (typeof(result) === 'string') {
        self.pos     += result.length;
        self.working  = self.working.substring(result.length);

        return result;
      }
      else {
        return nil;
      }
    ;
    }, $StringScanner_scan$3.$$arity = 1);
    
    Opal.def(self, '$scan_until', $StringScanner_scan_until$4 = function $$scan_until(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var pos     = self.pos,
          working = self.working,
          result;

      while (true) {
        result   = pattern.exec(working);
        pos     += 1;
        working  = working.substr(1);

        if (result == null) {
          if (working.length === 0) {
            self.match = [];
            return self.matched = nil;
          }

          continue;
        }

        self.matched  = self.string.substr(self.pos, pos - self.pos - 1 + result[0].length);
        self.match    = result;
        self.prev_pos = pos - 1;
        self.pos      = pos;
        self.working  = working.substr(result[0].length);

        return self.matched;
      }
    ;
    }, $StringScanner_scan_until$4.$$arity = 1);
    
    Opal.def(self, '$[]', $StringScanner_$$$5 = function(idx) {
      var self = this, $case = nil;

      
      if ($truthy(self.match['$empty?']())) {
        return nil};
      $case = idx;
      if ($$($nesting, 'Symbol')['$===']($case)) {idx = idx.$to_s()}
      else if ($$($nesting, 'String')['$===']($case)) {nil}
      else {idx = $$($nesting, 'Opal')['$coerce_to!'](idx, $$($nesting, 'Integer'), "to_int")};
      
      var match = self.match;

      if (idx < 0) {
        idx += match.length;
      }

      if (idx < 0 || idx >= match.length) {
        return nil;
      }

      if (match[idx] == null) {
        return nil;
      }

      return match[idx];
    ;
    }, $StringScanner_$$$5.$$arity = 1);
    
    Opal.def(self, '$check', $StringScanner_check$6 = function $$check(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var result = pattern.exec(self.working);

      if (result == null) {
        return self.matched = nil;
      }

      return self.matched = result[0];
    ;
    }, $StringScanner_check$6.$$arity = 1);
    
    Opal.def(self, '$check_until', $StringScanner_check_until$7 = function $$check_until(pattern) {
      var self = this;

      
      var prev_pos = self.prev_pos,
          pos      = self.pos;

      var result = self.$scan_until(pattern);

      if (result !== nil) {
        self.matched = result.substr(-1);
        self.working = self.string.substr(pos);
      }

      self.prev_pos = prev_pos;
      self.pos      = pos;

      return result;
    
    }, $StringScanner_check_until$7.$$arity = 1);
    
    Opal.def(self, '$peek', $StringScanner_peek$8 = function $$peek(length) {
      var self = this;

      return self.working.substring(0, length)
    }, $StringScanner_peek$8.$$arity = 1);
    
    Opal.def(self, '$eos?', $StringScanner_eos$ques$9 = function() {
      var self = this;

      return self.working.length === 0
    }, $StringScanner_eos$ques$9.$$arity = 0);
    
    Opal.def(self, '$exist?', $StringScanner_exist$ques$10 = function(pattern) {
      var self = this;

      
      var result = pattern.exec(self.working);

      if (result == null) {
        return nil;
      }
      else if (result.index == 0) {
        return 0;
      }
      else {
        return result.index + 1;
      }
    
    }, $StringScanner_exist$ques$10.$$arity = 1);
    
    Opal.def(self, '$skip', $StringScanner_skip$11 = function $$skip(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var result = pattern.exec(self.working);

      if (result == null) {
        self.match = [];
        return self.matched = nil;
      }
      else {
        var match_str = result[0];
        var match_len = match_str.length;

        self.matched   = match_str;
        self.match     = result;
        self.prev_pos  = self.pos;
        self.pos      += match_len;
        self.working   = self.working.substring(match_len);

        return match_len;
      }
    ;
    }, $StringScanner_skip$11.$$arity = 1);
    
    Opal.def(self, '$skip_until', $StringScanner_skip_until$12 = function $$skip_until(pattern) {
      var self = this;

      
      var result = self.$scan_until(pattern);

      if (result === nil) {
        return nil;
      }
      else {
        self.matched = result.substr(-1);

        return result.length;
      }
    
    }, $StringScanner_skip_until$12.$$arity = 1);
    
    Opal.def(self, '$get_byte', $StringScanner_get_byte$13 = function $$get_byte() {
      var self = this;

      
      var result = nil;

      if (self.pos < self.string.length) {
        self.prev_pos  = self.pos;
        self.pos      += 1;
        result      = self.matched = self.working.substring(0, 1);
        self.working   = self.working.substring(1);
      }
      else {
        self.matched = nil;
      }

      return result;
    
    }, $StringScanner_get_byte$13.$$arity = 0);
    Opal.alias(self, "getch", "get_byte");
    
    Opal.def(self, '$match?', $StringScanner_match$ques$14 = function(pattern) {
      var self = this;

      
      pattern = self.$anchor(pattern);
      
      var result = pattern.exec(self.working);

      if (result == null) {
        return nil;
      }
      else {
        self.prev_pos = self.pos;

        return result[0].length;
      }
    ;
    }, $StringScanner_match$ques$14.$$arity = 1);
    
    Opal.def(self, '$pos=', $StringScanner_pos$eq$15 = function(pos) {
      var self = this;

      
      
      if (pos < 0) {
        pos += self.string.$length();
      }
    ;
      self.pos = pos;
      return (self.working = self.string.slice(pos));
    }, $StringScanner_pos$eq$15.$$arity = 1);
    
    Opal.def(self, '$matched_size', $StringScanner_matched_size$16 = function $$matched_size() {
      var self = this;

      
      if (self.matched === nil) {
        return nil;
      }

      return self.matched.length
    
    }, $StringScanner_matched_size$16.$$arity = 0);
    
    Opal.def(self, '$post_match', $StringScanner_post_match$17 = function $$post_match() {
      var self = this;

      
      if (self.matched === nil) {
        return nil;
      }

      return self.string.substr(self.pos);
    
    }, $StringScanner_post_match$17.$$arity = 0);
    
    Opal.def(self, '$pre_match', $StringScanner_pre_match$18 = function $$pre_match() {
      var self = this;

      
      if (self.matched === nil) {
        return nil;
      }

      return self.string.substr(0, self.prev_pos);
    
    }, $StringScanner_pre_match$18.$$arity = 0);
    
    Opal.def(self, '$reset', $StringScanner_reset$19 = function $$reset() {
      var self = this;

      
      self.working = self.string;
      self.matched = nil;
      return (self.pos = 0);
    }, $StringScanner_reset$19.$$arity = 0);
    
    Opal.def(self, '$rest', $StringScanner_rest$20 = function $$rest() {
      var self = this;

      return self.working
    }, $StringScanner_rest$20.$$arity = 0);
    
    Opal.def(self, '$rest?', $StringScanner_rest$ques$21 = function() {
      var self = this;

      return self.working.length !== 0
    }, $StringScanner_rest$ques$21.$$arity = 0);
    
    Opal.def(self, '$rest_size', $StringScanner_rest_size$22 = function $$rest_size() {
      var self = this;

      return self.$rest().$size()
    }, $StringScanner_rest_size$22.$$arity = 0);
    
    Opal.def(self, '$terminate', $StringScanner_terminate$23 = function $$terminate() {
      var self = this, $writer = nil;

      
      self.match = nil;
      
      $writer = [self.string.$length()];
      $send(self, 'pos=', Opal.to_a($writer));
      return $writer[$rb_minus($writer["length"], 1)];;
    }, $StringScanner_terminate$23.$$arity = 0);
    
    Opal.def(self, '$unscan', $StringScanner_unscan$24 = function $$unscan() {
      var self = this;

      
      self.pos = self.prev_pos;
      self.prev_pos = nil;
      self.match = nil;
      return self;
    }, $StringScanner_unscan$24.$$arity = 0);
    self.$private();
    return (Opal.def(self, '$anchor', $StringScanner_anchor$25 = function $$anchor(pattern) {
      var self = this;

      
      var flags = pattern.toString().match(/\/([^\/]+)$/);
      flags = flags ? flags[1] : undefined;
      return new RegExp('^(?:' + pattern.source + ')', flags);
    
    }, $StringScanner_anchor$25.$$arity = 1), nil) && 'anchor';
  })($nesting[0], null, $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/lexer"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash2 = Opal.hash2, $truthy = Opal.truthy;

  
  self.$require("strscan");
  self.$require("bcdice/normalize");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $super, $parent_nesting) {
        var self = $klass($base, $super, 'Lexer');

        var $nesting = [self].concat($parent_nesting), $Lexer_initialize$1, $Lexer_next_token$2, $Lexer_source$3;

        self.$$prototype.scanner = nil;
        
        Opal.const_set($nesting[0], 'SYMBOLS', $hash2(["+", "-", "*", "/", "(", ")", "[", "]", "?", "@"], {"+": "PLUS", "-": "MINUS", "*": "ASTERISK", "/": "SLASH", "(": "PARENL", ")": "PARENR", "[": "BRACKETL", "]": "BRACKETR", "?": "QUESTION", "@": "AT"}).$freeze());
        
        Opal.def(self, '$initialize', $Lexer_initialize$1 = function $$initialize(source) {
          var self = this, $ret_or_1 = nil;

          
          source = (function() {if ($truthy(($ret_or_1 = source.$split(" ", 2).$first()))) {
            return $ret_or_1
          } else {
            return ""
          }; return nil; })();
          return (self.scanner = $$($nesting, 'StringScanner').$new(source));
        }, $Lexer_initialize$1.$$arity = 1);
        
        Opal.def(self, '$next_token', $Lexer_next_token$2 = function $$next_token() {
          var self = this, number = nil, cmp_op = nil, char$ = nil, type = nil, $ret_or_2 = nil;

          
          if ($truthy(self.scanner['$eos?']())) {
            return [false, "$"]};
          if ($truthy((number = self.scanner.$scan(/\d+/)))) {
            return ["NUMBER", number.$to_i()]
          } else if ($truthy((cmp_op = self.scanner.$scan(/[<>!=]+/)))) {
            return ["CMP_OP", $$($nesting, 'Normalize').$comparison_operator(cmp_op)]
          } else {
            
            char$ = self.scanner.$getch().$upcase();
            type = (function() {if ($truthy(($ret_or_2 = $$($nesting, 'SYMBOLS')['$[]'](char$)))) {
              return $ret_or_2
            } else {
              return char$.$to_sym()
            }; return nil; })();
            return [type, char$];
          };
        }, $Lexer_next_token$2.$$arity = 0);
        return (Opal.def(self, '$source', $Lexer_source$3 = function $$source() {
          var self = this;

          return self.scanner.$string()
        }, $Lexer_source$3.$$arity = 0), nil) && 'source';
      })($nesting[0], null, $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["singleton"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $send2 = Opal.send2, $send = Opal.send, $truthy = Opal.truthy;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'Singleton');

    var $nesting = [self].concat($parent_nesting), $Singleton_clone$1, $Singleton_dup$2;

    
    
    Opal.def(self, '$clone', $Singleton_clone$1 = function $$clone() {
      var self = this;

      return self.$raise($$($nesting, 'TypeError'), "" + "can't clone instance of singleton " + (self.$class()))
    }, $Singleton_clone$1.$$arity = 0);
    
    Opal.def(self, '$dup', $Singleton_dup$2 = function $$dup() {
      var self = this;

      return self.$raise($$($nesting, 'TypeError'), "" + "can't dup instance of singleton " + (self.$class()))
    }, $Singleton_dup$2.$$arity = 0);
    (function($base, $parent_nesting) {
      var self = $module($base, 'SingletonClassMethods');

      var $nesting = [self].concat($parent_nesting), $SingletonClassMethods_clone$3, $SingletonClassMethods_inherited$4;

      
      
      Opal.def(self, '$clone', $SingletonClassMethods_clone$3 = function $$clone() {
        var $iter = $SingletonClassMethods_clone$3.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

        if ($iter) $SingletonClassMethods_clone$3.$$p = null;
        // Prepare super implicit arguments
        for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
          $zuper[$zuper_i] = arguments[$zuper_i];
        }
        return $$($nesting, 'Singleton').$__init__($send2(self, Opal.find_super_dispatcher(self, 'clone', $SingletonClassMethods_clone$3, false, true), 'clone', $zuper, $iter))
      }, $SingletonClassMethods_clone$3.$$arity = 0);
      
      Opal.def(self, '$inherited', $SingletonClassMethods_inherited$4 = function $$inherited(sub_klass) {
        var $iter = $SingletonClassMethods_inherited$4.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

        if ($iter) $SingletonClassMethods_inherited$4.$$p = null;
        // Prepare super implicit arguments
        for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
          $zuper[$zuper_i] = arguments[$zuper_i];
        }
        
        $send2(self, Opal.find_super_dispatcher(self, 'inherited', $SingletonClassMethods_inherited$4, false, true), 'inherited', $zuper, $iter);
        return $$($nesting, 'Singleton').$__init__(sub_klass);
      }, $SingletonClassMethods_inherited$4.$$arity = 1);
    })($nesting[0], $nesting);
    (function(self, $parent_nesting) {
      var $nesting = [self].concat($parent_nesting), $__init__$5, $included$8;

      
      
      Opal.def(self, '$__init__', $__init__$5 = function $$__init__(klass) {
        var $$6, $instance$7, self = this;

        
        $send(klass, 'instance_eval', [], ($$6 = function(){var self = $$6.$$s == null ? this : $$6.$$s;

        return (self.singleton__instance__ = nil)}, $$6.$$s = self, $$6.$$arity = 0, $$6));
        Opal.defs(klass, '$instance', $instance$7 = function $$instance() {
          var self = this;
          if (self.singleton__instance__ == null) self.singleton__instance__ = nil;

          
          if ($truthy(self.singleton__instance__)) {
            return self.singleton__instance__};
          return (self.singleton__instance__ = self.$new());
        }, $instance$7.$$arity = 0);
        return klass;
      }, $__init__$5.$$arity = 1);
      return (Opal.def(self, '$included', $included$8 = function $$included(klass) {
        var $iter = $included$8.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

        if ($iter) $included$8.$$p = null;
        // Prepare super implicit arguments
        for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
          $zuper[$zuper_i] = arguments[$zuper_i];
        }
        
        $send2(self, Opal.find_super_dispatcher(self, 'included', $included$8, false, true), 'included', $zuper, $iter);
        klass.$extend($$($nesting, 'SingletonClassMethods'));
        return $$($nesting, 'Singleton').$__init__(klass);
      }, $included$8.$$arity = 1), nil) && 'included';
    })(Opal.get_singleton_class($$($nesting, 'Singleton')), $nesting);
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/add_dice/node"] = function(Opal) {
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $send2 = Opal.send2;

  
  self.$require("singleton");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'AddDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $parent_nesting) {
          var self = $module($base, 'Node');

          var $nesting = [self].concat($parent_nesting);

          
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Command');

            var $nesting = [self].concat($parent_nesting), $Command_initialize$1, $Command_expr$2, $Command_s_exp$3, $Command_eval$4, $Command_cmp_op_text$6;

            self.$$prototype.lhs = self.$$prototype.rhs = self.$$prototype.cmp_op = nil;
            
            self.$attr_reader("lhs");
            self.$attr_reader("cmp_op");
            self.$attr_reader("rhs");
            
            Opal.def(self, '$initialize', $Command_initialize$1 = function $$initialize(secret, lhs, cmp_op, rhs) {
              var self = this;

              
              
              if (cmp_op == null) {
                cmp_op = nil;
              };
              
              if (rhs == null) {
                rhs = nil;
              };
              self.secret = secret;
              self.lhs = lhs;
              self.cmp_op = cmp_op;
              return (self.rhs = rhs);
            }, $Command_initialize$1.$$arity = -3);
            
            Opal.def(self, '$expr', $Command_expr$2 = function $$expr(game_system) {
              var $a, self = this;

              return $rb_plus($rb_plus(self.lhs.$expr(game_system), self.$cmp_op_text()), ($a = self.rhs, ($a === nil || $a == null) ? nil : $send($a, 'eval', [game_system, nil])).$to_s())
            }, $Command_expr$2.$$arity = 1);
            
            Opal.def(self, '$s_exp', $Command_s_exp$3 = function $$s_exp() {
              var self = this;

              if ($truthy(self.cmp_op)) {
                return "" + "(Command (" + (self.cmp_op) + " " + (self.lhs.$s_exp()) + " " + (self.rhs.$s_exp()) + "))"
              } else {
                return "" + "(Command " + (self.lhs.$s_exp()) + ")"
              }
            }, $Command_s_exp$3.$$arity = 0);
            
            Opal.def(self, '$eval', $Command_eval$4 = function(game_system, randomizer) {
              var $a, $$5, self = this, total = nil, interrim_expr = nil, $ret_or_1 = nil, result = nil, rhs = nil, $ret_or_2 = nil, sequence = nil;

              
              randomizer = $$($nesting, 'Randomizer').$new(randomizer, game_system);
              total = self.lhs.$eval(game_system, randomizer);
              interrim_expr = (function() {if ($truthy((function() {if ($truthy(($ret_or_1 = $rb_le(randomizer.$rand_results().$size(), 1)))) {
                return self.lhs['$is_a?']($$$($$($nesting, 'Node'), 'DiceRoll'))
              } else {
                return $ret_or_1
              }; return nil; })())) {
                return nil
              } else {
                return self.lhs.$output()
              }; return nil; })();
              result = (function() {if ($truthy(self.cmp_op)) {
                
                rhs = self.rhs.$eval(game_system, nil);
                return game_system.$check_result(total, randomizer.$rand_results(), self.cmp_op, rhs);
              } else {
                return nil
              }; return nil; })();
              result = (function() {if ($truthy(($ret_or_2 = result))) {
                return $ret_or_2
              } else {
                return $$($nesting, 'Result').$new()
              }; return nil; })();
              sequence = ["" + "(" + (self.$expr(game_system)) + ")", interrim_expr, total, ($a = result, ($a === nil || $a == null) ? nil : $send($a, 'text', []))].$compact();
              return $send(result, 'tap', [], ($$5 = function(r){var self = $$5.$$s == null ? this : $$5.$$s, $writer = nil;
                if (self.secret == null) self.secret = nil;

              
                
                if (r == null) {
                  r = nil;
                };
                
                $writer = [self.secret];
                $send(r, 'secret=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];;
                
                $writer = [sequence.$join(" ＞ ")];
                $send(r, 'text=', Opal.to_a($writer));
                return $writer[$rb_minus($writer["length"], 1)];;}, $$5.$$s = self, $$5.$$arity = 1, $$5));
            }, $Command_eval$4.$$arity = 2);
            self.$private();
            return (Opal.def(self, '$cmp_op_text', $Command_cmp_op_text$6 = function $$cmp_op_text() {
              var self = this, $case = nil;

              return (function() {$case = self.cmp_op;
              if ("!="['$===']($case)) {return "<>"}
              else if ("=="['$===']($case)) {return "="}
              else {return self.cmp_op.$to_s()}})()
            }, $Command_cmp_op_text$6.$$arity = 0), nil) && 'cmp_op_text';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'UndecidedTarget');

            var $nesting = [self].concat($parent_nesting), $UndecidedTarget_eval$7, $UndecidedTarget_include_dice$ques$8, $UndecidedTarget_expr$9, $UndecidedTarget_output$10;

            
            self.$include($$($nesting, 'Singleton'));
            
            Opal.def(self, '$eval', $UndecidedTarget_eval$7 = function(_game_system, _randomizer) {
              var self = this;

              return "?"
            }, $UndecidedTarget_eval$7.$$arity = 2);
            
            Opal.def(self, '$include_dice?', $UndecidedTarget_include_dice$ques$8 = function() {
              var self = this;

              return false
            }, $UndecidedTarget_include_dice$ques$8.$$arity = 0);
            
            Opal.def(self, '$expr', $UndecidedTarget_expr$9 = function $$expr(_game_system) {
              var self = this;

              return "?"
            }, $UndecidedTarget_expr$9.$$arity = 1);
            
            Opal.def(self, '$output', $UndecidedTarget_output$10 = function $$output() {
              var self = this;

              return "?"
            }, $UndecidedTarget_output$10.$$arity = 0);
            return Opal.alias(self, "s_exp", "output");
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'BinaryOp');

            var $nesting = [self].concat($parent_nesting), $BinaryOp_initialize$11, $BinaryOp_eval$12, $BinaryOp_include_dice$ques$13, $BinaryOp_expr$14, $BinaryOp_output$15, $BinaryOp_s_exp$16, $BinaryOp_calc$17, $BinaryOp_op_for_s_exp$18;

            self.$$prototype.lhs = self.$$prototype.rhs = self.$$prototype.op = nil;
            
            
            Opal.def(self, '$initialize', $BinaryOp_initialize$11 = function $$initialize(lhs, op, rhs) {
              var self = this;

              
              self.lhs = lhs;
              self.op = op;
              return (self.rhs = rhs);
            }, $BinaryOp_initialize$11.$$arity = 3);
            
            Opal.def(self, '$eval', $BinaryOp_eval$12 = function(game_system, randomizer) {
              var self = this, lhs = nil, rhs = nil;

              
              lhs = self.lhs.$eval(game_system, randomizer);
              rhs = self.rhs.$eval(game_system, randomizer);
              return self.$calc(lhs, rhs, game_system.$round_type()).$to_i();
            }, $BinaryOp_eval$12.$$arity = 2);
            
            Opal.def(self, '$include_dice?', $BinaryOp_include_dice$ques$13 = function() {
              var self = this, $ret_or_3 = nil;

              if ($truthy(($ret_or_3 = self.lhs['$include_dice?']()))) {
                return $ret_or_3
              } else {
                return self.rhs['$include_dice?']()
              }
            }, $BinaryOp_include_dice$ques$13.$$arity = 0);
            
            Opal.def(self, '$expr', $BinaryOp_expr$14 = function $$expr(game_system) {
              var self = this, lhs = nil, rhs = nil;

              
              lhs = self.lhs.$expr(game_system);
              rhs = self.rhs.$expr(game_system);
              return "" + (lhs) + (self.op) + (rhs);
            }, $BinaryOp_expr$14.$$arity = 1);
            
            Opal.def(self, '$output', $BinaryOp_output$15 = function $$output() {
              var self = this;

              return "" + (self.lhs.$output()) + (self.op) + (self.rhs.$output())
            }, $BinaryOp_output$15.$$arity = 0);
            
            Opal.def(self, '$s_exp', $BinaryOp_s_exp$16 = function $$s_exp() {
              var self = this;

              return "" + "(" + (self.$op_for_s_exp()) + " " + (self.lhs.$s_exp()) + " " + (self.rhs.$s_exp()) + ")"
            }, $BinaryOp_s_exp$16.$$arity = 0);
            self.$private();
            
            Opal.def(self, '$calc', $BinaryOp_calc$17 = function $$calc(lhs, rhs, _round_type) {
              var self = this;

              return lhs.$send(self.op, rhs).$to_i()
            }, $BinaryOp_calc$17.$$arity = 3);
            return (Opal.def(self, '$op_for_s_exp', $BinaryOp_op_for_s_exp$18 = function $$op_for_s_exp() {
              var self = this;

              return self.op
            }, $BinaryOp_op_for_s_exp$18.$$arity = 0), nil) && 'op_for_s_exp';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'DivideBase');

            var $nesting = [self].concat($parent_nesting), $DivideBase_initialize$19, $DivideBase_expr$20, $DivideBase_output$21, $DivideBase_rounding_method$22, $DivideBase_op_for_s_exp$23, $DivideBase_calc$24, $DivideBase_divide_and_round$25;

            self.$$prototype.op = nil;
            
            
            Opal.def(self, '$initialize', $DivideBase_initialize$19 = function $$initialize(lhs, rhs) {
              var $iter = $DivideBase_initialize$19.$$p, $yield = $iter || nil, self = this;

              if ($iter) $DivideBase_initialize$19.$$p = null;
              return $send2(self, Opal.find_super_dispatcher(self, 'initialize', $DivideBase_initialize$19, false, true), 'initialize', [lhs, "/", rhs], null)
            }, $DivideBase_initialize$19.$$arity = 2);
            
            Opal.def(self, '$expr', $DivideBase_expr$20 = function $$expr(game_system) {
              var $iter = $DivideBase_expr$20.$$p, $yield = $iter || nil, self = this;

              if ($iter) $DivideBase_expr$20.$$p = null;
              return "" + ($send2(self, Opal.find_super_dispatcher(self, 'expr', $DivideBase_expr$20, false, true), 'expr', [game_system], null)) + (self.$rounding_method())
            }, $DivideBase_expr$20.$$arity = 1);
            
            Opal.def(self, '$output', $DivideBase_output$21 = function $$output() {
              var $iter = $DivideBase_output$21.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

              if ($iter) $DivideBase_output$21.$$p = null;
              // Prepare super implicit arguments
              for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
                $zuper[$zuper_i] = arguments[$zuper_i];
              }
              return "" + ($send2(self, Opal.find_super_dispatcher(self, 'output', $DivideBase_output$21, false, true), 'output', $zuper, $iter)) + (self.$rounding_method())
            }, $DivideBase_output$21.$$arity = 0);
            self.$private();
            
            Opal.def(self, '$rounding_method', $DivideBase_rounding_method$22 = function $$rounding_method() {
              var self = this;

              return $$$(self.$class(), 'ROUNDING_METHOD')
            }, $DivideBase_rounding_method$22.$$arity = 0);
            
            Opal.def(self, '$op_for_s_exp', $DivideBase_op_for_s_exp$23 = function $$op_for_s_exp() {
              var self = this;

              return "" + (self.op) + (self.$rounding_method())
            }, $DivideBase_op_for_s_exp$23.$$arity = 0);
            
            Opal.def(self, '$calc', $DivideBase_calc$24 = function $$calc(lhs, rhs, round_type) {
              var self = this;

              
              if ($truthy(rhs['$zero?']())) {
                return 1};
              return self.$divide_and_round(lhs, rhs, round_type).$to_i();
            }, $DivideBase_calc$24.$$arity = 3);
            return (Opal.def(self, '$divide_and_round', $DivideBase_divide_and_round$25 = function $$divide_and_round(dividend, divisor, round_type) {
              var self = this;

              return self.$raise($$($nesting, 'NotImplementedError'))
            }, $DivideBase_divide_and_round$25.$$arity = 3), nil) && 'divide_and_round';
          })($nesting[0], $$($nesting, 'BinaryOp'), $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'DivideWithGameSystemDefault');

            var $nesting = [self].concat($parent_nesting), $DivideWithGameSystemDefault_divide_and_round$26;

            
            Opal.const_set($nesting[0], 'ROUNDING_METHOD', "");
            self.$private();
            return (Opal.def(self, '$divide_and_round', $DivideWithGameSystemDefault_divide_and_round$26 = function $$divide_and_round(dividend, divisor, round_type) {
              var self = this, $case = nil;

              return (function() {$case = round_type;
              if ($$$($$($nesting, 'RoundType'), 'CEIL')['$===']($case)) {return $rb_divide(dividend.$to_f(), divisor).$ceil()}
              else if ($$$($$($nesting, 'RoundType'), 'ROUND')['$===']($case)) {return $rb_divide(dividend.$to_f(), divisor).$round()}
              else {return $rb_divide(dividend, divisor).$floor()}})()
            }, $DivideWithGameSystemDefault_divide_and_round$26.$$arity = 3), nil) && 'divide_and_round';
          })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'DivideWithRoundingUp');

            var $nesting = [self].concat($parent_nesting), $DivideWithRoundingUp_divide_and_round$27;

            
            Opal.const_set($nesting[0], 'ROUNDING_METHOD', "U");
            self.$private();
            return (Opal.def(self, '$divide_and_round', $DivideWithRoundingUp_divide_and_round$27 = function $$divide_and_round(dividend, divisor, _round_type) {
              var self = this;

              return $rb_divide(dividend.$to_f(), divisor).$ceil()
            }, $DivideWithRoundingUp_divide_and_round$27.$$arity = 3), nil) && 'divide_and_round';
          })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'DivideWithRoundingOff');

            var $nesting = [self].concat($parent_nesting), $DivideWithRoundingOff_divide_and_round$28;

            
            Opal.const_set($nesting[0], 'ROUNDING_METHOD', "R");
            self.$private();
            return (Opal.def(self, '$divide_and_round', $DivideWithRoundingOff_divide_and_round$28 = function $$divide_and_round(dividend, divisor, _round_type) {
              var self = this;

              return $rb_divide(dividend.$to_f(), divisor).$round()
            }, $DivideWithRoundingOff_divide_and_round$28.$$arity = 3), nil) && 'divide_and_round';
          })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'DivideWithRoundingDown');

            var $nesting = [self].concat($parent_nesting), $DivideWithRoundingDown_divide_and_round$29;

            
            Opal.const_set($nesting[0], 'ROUNDING_METHOD', "F");
            self.$private();
            return (Opal.def(self, '$divide_and_round', $DivideWithRoundingDown_divide_and_round$29 = function $$divide_and_round(dividend, divisor, _round_type) {
              var self = this;

              return $rb_divide(dividend, divisor).$to_i()
            }, $DivideWithRoundingDown_divide_and_round$29.$$arity = 3), nil) && 'divide_and_round';
          })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Negate');

            var $nesting = [self].concat($parent_nesting), $Negate_initialize$30, $Negate_eval$31, $Negate_include_dice$ques$32, $Negate_expr$33, $Negate_output$34, $Negate_s_exp$35;

            self.$$prototype.body = nil;
            
            self.$attr_reader("body");
            
            Opal.def(self, '$initialize', $Negate_initialize$30 = function $$initialize(body) {
              var self = this;

              return (self.body = body)
            }, $Negate_initialize$30.$$arity = 1);
            
            Opal.def(self, '$eval', $Negate_eval$31 = function(game_system, randomizer) {
              var self = this;

              return self.body.$eval(game_system, randomizer).$to_i()['$-@']()
            }, $Negate_eval$31.$$arity = 2);
            
            Opal.def(self, '$include_dice?', $Negate_include_dice$ques$32 = function() {
              var self = this;

              return self.body['$include_dice?']()
            }, $Negate_include_dice$ques$32.$$arity = 0);
            
            Opal.def(self, '$expr', $Negate_expr$33 = function $$expr(game_system) {
              var self = this;

              return "" + "-" + (self.body.$expr(game_system))
            }, $Negate_expr$33.$$arity = 1);
            
            Opal.def(self, '$output', $Negate_output$34 = function $$output() {
              var self = this;

              return "" + "-" + (self.body.$output())
            }, $Negate_output$34.$$arity = 0);
            return (Opal.def(self, '$s_exp', $Negate_s_exp$35 = function $$s_exp() {
              var self = this;

              return "" + "(- " + (self.body.$s_exp()) + ")"
            }, $Negate_s_exp$35.$$arity = 0), nil) && 's_exp';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'DiceRoll');

            var $nesting = [self].concat($parent_nesting), $DiceRoll_initialize$36, $DiceRoll_eval$37, $DiceRoll_include_dice$ques$38, $DiceRoll_expr$39, $DiceRoll_output$40, $DiceRoll_s_exp$41, $DiceRoll_eval_sides$42;

            self.$$prototype.times = self.$$prototype.text = self.$$prototype.sides = nil;
            
            
            Opal.def(self, '$initialize', $DiceRoll_initialize$36 = function $$initialize(times, sides) {
              var self = this;

              
              self.times = times;
              self.sides = sides;
              return (self.text = nil);
            }, $DiceRoll_initialize$36.$$arity = 2);
            
            Opal.def(self, '$eval', $DiceRoll_eval$37 = function(game_system, randomizer) {
              var self = this, times = nil, sides = nil, dice_list = nil, total = nil;

              
              times = self.times.$eval(game_system, nil);
              sides = self.$eval_sides(game_system);
              dice_list = randomizer.$roll(times, sides);
              total = dice_list.$sum();
              self.text = "" + (total) + "[" + (dice_list.$join(",")) + "]";
              return total.$to_i();
            }, $DiceRoll_eval$37.$$arity = 2);
            
            Opal.def(self, '$include_dice?', $DiceRoll_include_dice$ques$38 = function() {
              var self = this;

              return true
            }, $DiceRoll_include_dice$ques$38.$$arity = 0);
            
            Opal.def(self, '$expr', $DiceRoll_expr$39 = function $$expr(game_system) {
              var self = this, times = nil, sides = nil;

              
              times = self.times.$eval(game_system, nil);
              sides = self.$eval_sides(game_system);
              return "" + (times) + "D" + (sides);
            }, $DiceRoll_expr$39.$$arity = 1);
            
            Opal.def(self, '$output', $DiceRoll_output$40 = function $$output() {
              var self = this;

              return self.text
            }, $DiceRoll_output$40.$$arity = 0);
            
            Opal.def(self, '$s_exp', $DiceRoll_s_exp$41 = function $$s_exp() {
              var self = this;

              return "" + "(DiceRoll " + (self.times.$s_exp()) + " " + (self.sides.$s_exp()) + ")"
            }, $DiceRoll_s_exp$41.$$arity = 0);
            self.$private();
            return (Opal.def(self, '$eval_sides', $DiceRoll_eval_sides$42 = function $$eval_sides(game_system) {
              var self = this;

              return self.sides.$eval(game_system, nil)
            }, $DiceRoll_eval_sides$42.$$arity = 1), nil) && 'eval_sides';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'ImplicitSidesDiceRoll');

            var $nesting = [self].concat($parent_nesting), $ImplicitSidesDiceRoll_initialize$43, $ImplicitSidesDiceRoll_s_exp$44, $ImplicitSidesDiceRoll_eval_sides$45;

            self.$$prototype.times = nil;
            
            
            Opal.def(self, '$initialize', $ImplicitSidesDiceRoll_initialize$43 = function $$initialize(times) {
              var self = this;

              
              self.times = times;
              return (self.text = nil);
            }, $ImplicitSidesDiceRoll_initialize$43.$$arity = 1);
            
            Opal.def(self, '$s_exp', $ImplicitSidesDiceRoll_s_exp$44 = function $$s_exp() {
              var self = this;

              return "" + "(ImplicitSidesDiceRoll " + (self.times.$s_exp()) + ")"
            }, $ImplicitSidesDiceRoll_s_exp$44.$$arity = 0);
            self.$private();
            return (Opal.def(self, '$eval_sides', $ImplicitSidesDiceRoll_eval_sides$45 = function $$eval_sides(game_system) {
              var self = this;

              return game_system.$sides_implicit_d()
            }, $ImplicitSidesDiceRoll_eval_sides$45.$$arity = 1), nil) && 'eval_sides';
          })($nesting[0], $$($nesting, 'DiceRoll'), $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'DiceRollWithFilter');

            var $nesting = [self].concat($parent_nesting), $DiceRollWithFilter_initialize$50, $DiceRollWithFilter_eval$51, $DiceRollWithFilter_include_dice$ques$52, $DiceRollWithFilter_expr$53, $DiceRollWithFilter_output$54, $DiceRollWithFilter_s_exp$55;

            self.$$prototype.times = self.$$prototype.sides = self.$$prototype.n_filtering = self.$$prototype.filter = self.$$prototype.text = nil;
            
            Opal.const_set($nesting[0], 'Filter', $$($nesting, 'Struct').$new("abbr", "apply"));
            Opal.const_set($nesting[0], 'KEEP_HIGHEST', $$($nesting, 'Filter').$new("KH", $send(self, 'lambda', [], ($$46 = function(sorted_values, n){var self = $$46.$$s == null ? this : $$46.$$s;

            
              
              if (sorted_values == null) {
                sorted_values = nil;
              };
              
              if (n == null) {
                n = nil;
              };
              return sorted_values.$reverse().$take(n);}, $$46.$$s = self, $$46.$$arity = 2, $$46))).$freeze());
            Opal.const_set($nesting[0], 'KEEP_LOWEST', $$($nesting, 'Filter').$new("KL", $send(self, 'lambda', [], ($$47 = function(sorted_values, n){var self = $$47.$$s == null ? this : $$47.$$s;

            
              
              if (sorted_values == null) {
                sorted_values = nil;
              };
              
              if (n == null) {
                n = nil;
              };
              return sorted_values.$take(n);}, $$47.$$s = self, $$47.$$arity = 2, $$47))).$freeze());
            Opal.const_set($nesting[0], 'DROP_HIGHEST', $$($nesting, 'Filter').$new("DH", $send(self, 'lambda', [], ($$48 = function(sorted_values, n){var self = $$48.$$s == null ? this : $$48.$$s;

            
              
              if (sorted_values == null) {
                sorted_values = nil;
              };
              
              if (n == null) {
                n = nil;
              };
              return sorted_values.$reverse().$drop(n);}, $$48.$$s = self, $$48.$$arity = 2, $$48))).$freeze());
            Opal.const_set($nesting[0], 'DROP_LOWEST', $$($nesting, 'Filter').$new("DL", $send(self, 'lambda', [], ($$49 = function(sorted_values, n){var self = $$49.$$s == null ? this : $$49.$$s;

            
              
              if (sorted_values == null) {
                sorted_values = nil;
              };
              
              if (n == null) {
                n = nil;
              };
              return sorted_values.$drop(n);}, $$49.$$s = self, $$49.$$arity = 2, $$49))).$freeze());
            
            Opal.def(self, '$initialize', $DiceRollWithFilter_initialize$50 = function $$initialize(times, sides, n_filtering, filter) {
              var self = this;

              
              self.times = times;
              self.sides = sides;
              self.n_filtering = n_filtering;
              self.filter = filter;
              return (self.text = nil);
            }, $DiceRollWithFilter_initialize$50.$$arity = 4);
            
            Opal.def(self, '$eval', $DiceRollWithFilter_eval$51 = function(game_system, randomizer) {
              var self = this, times = nil, sides = nil, n_filtering = nil, sorted_values = nil, total = nil;

              
              times = self.times.$eval(game_system, nil);
              sides = self.sides.$eval(game_system, nil);
              n_filtering = self.n_filtering.$eval(game_system, nil);
              sorted_values = randomizer.$roll(times, sides).$sort();
              total = self.filter.$apply()['$[]'](sorted_values, n_filtering).$sum();
              self.text = "" + (total) + "[" + (sorted_values.$join(",")) + "]";
              return total.$to_i();
            }, $DiceRollWithFilter_eval$51.$$arity = 2);
            
            Opal.def(self, '$include_dice?', $DiceRollWithFilter_include_dice$ques$52 = function() {
              var self = this;

              return true
            }, $DiceRollWithFilter_include_dice$ques$52.$$arity = 0);
            
            Opal.def(self, '$expr', $DiceRollWithFilter_expr$53 = function $$expr(game_system) {
              var self = this, times = nil, sides = nil, n_filtering = nil;

              
              times = self.times.$eval(game_system, nil);
              sides = self.sides.$eval(game_system, nil);
              n_filtering = self.n_filtering.$eval(game_system, nil);
              return "" + (times) + "D" + (sides) + (self.filter.$abbr()) + (n_filtering);
            }, $DiceRollWithFilter_expr$53.$$arity = 1);
            
            Opal.def(self, '$output', $DiceRollWithFilter_output$54 = function $$output() {
              var self = this;

              return self.text
            }, $DiceRollWithFilter_output$54.$$arity = 0);
            return (Opal.def(self, '$s_exp', $DiceRollWithFilter_s_exp$55 = function $$s_exp() {
              var self = this;

              return "" + "(DiceRollWithFilter " + (self.times.$s_exp()) + " " + (self.sides.$s_exp()) + " " + (self.filter.$abbr().$inspect()) + " " + (self.n_filtering.$s_exp()) + ")"
            }, $DiceRollWithFilter_s_exp$55.$$arity = 0), nil) && 's_exp';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Parenthesis');

            var $nesting = [self].concat($parent_nesting), $Parenthesis_initialize$56, $Parenthesis_eval$57, $Parenthesis_include_dice$ques$58, $Parenthesis_expr$59, $Parenthesis_output$60, $Parenthesis_s_exp$61;

            self.$$prototype.expr = nil;
            
            
            Opal.def(self, '$initialize', $Parenthesis_initialize$56 = function $$initialize(expr) {
              var self = this;

              return (self.expr = expr)
            }, $Parenthesis_initialize$56.$$arity = 1);
            
            Opal.def(self, '$eval', $Parenthesis_eval$57 = function(game_system, randomizer) {
              var self = this;

              return self.expr.$eval(game_system, randomizer).$to_i()
            }, $Parenthesis_eval$57.$$arity = 2);
            
            Opal.def(self, '$include_dice?', $Parenthesis_include_dice$ques$58 = function() {
              var self = this;

              return self.expr['$include_dice?']()
            }, $Parenthesis_include_dice$ques$58.$$arity = 0);
            
            Opal.def(self, '$expr', $Parenthesis_expr$59 = function $$expr(game_system) {
              var self = this;

              return "" + "(" + (self.expr.$expr(game_system)) + ")"
            }, $Parenthesis_expr$59.$$arity = 1);
            
            Opal.def(self, '$output', $Parenthesis_output$60 = function $$output() {
              var self = this;

              return "" + "(" + (self.expr.$output()) + ")"
            }, $Parenthesis_output$60.$$arity = 0);
            return (Opal.def(self, '$s_exp', $Parenthesis_s_exp$61 = function $$s_exp() {
              var self = this;

              return "" + "(Parenthesis " + (self.expr.$s_exp()) + ")"
            }, $Parenthesis_s_exp$61.$$arity = 0), nil) && 's_exp';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Number');

            var $nesting = [self].concat($parent_nesting), $Number_initialize$62, $Number_negate$63, $Number_eval$64, $Number_include_dice$ques$65, $Number_expr$66, $Number_output$67;

            self.$$prototype.literal = nil;
            
            self.$attr_reader("literal");
            
            Opal.def(self, '$initialize', $Number_initialize$62 = function $$initialize(literal) {
              var self = this;

              return (self.literal = literal.$to_i())
            }, $Number_initialize$62.$$arity = 1);
            
            Opal.def(self, '$negate', $Number_negate$63 = function $$negate() {
              var self = this;

              return $$($nesting, 'Number').$new(self.literal['$-@']())
            }, $Number_negate$63.$$arity = 0);
            
            Opal.def(self, '$eval', $Number_eval$64 = function(_game_system, _randomizer) {
              var self = this;

              return self.literal.$to_i()
            }, $Number_eval$64.$$arity = 2);
            
            Opal.def(self, '$include_dice?', $Number_include_dice$ques$65 = function() {
              var self = this;

              return false
            }, $Number_include_dice$ques$65.$$arity = 0);
            
            Opal.def(self, '$expr', $Number_expr$66 = function $$expr(_game_system) {
              var self = this;

              return self.literal.$to_s()
            }, $Number_expr$66.$$arity = 1);
            
            Opal.def(self, '$output', $Number_output$67 = function $$output() {
              var self = this;

              return self.literal.$to_s()
            }, $Number_output$67.$$arity = 0);
            return Opal.alias(self, "s_exp", "output");
          })($nesting[0], null, $nesting);
        })($nesting[0], $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/add_dice/parser"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $truthy = Opal.truthy, $hash = Opal.hash;

  
  self.$require("racc/parser.rb");
  self.$require("bcdice/common_command/lexer");
  self.$require("bcdice/common_command/add_dice/node");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'AddDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Parser');

          var $nesting = [self].concat($parent_nesting), $Parser_parse$1, $Parser_parse$2, $Parser_next_token$3, $Parser_expand_negate$4, $Parser__reduce_1$5, $Parser__reduce_2$6, $Parser__reduce_3$7, $Parser__reduce_4$8, $Parser__reduce_6$9, $Parser__reduce_7$10, $Parser__reduce_8$11, $Parser__reduce_10$12, $Parser__reduce_11$13, $Parser__reduce_13$14, $Parser__reduce_14$15, $Parser__reduce_15$16, $Parser__reduce_16$17, $Parser__reduce_17$18, $Parser__reduce_18$19, $Parser__reduce_19$20, $Parser__reduce_21$21, $Parser__reduce_22$22, $Parser__reduce_23$23, $Parser__reduce_25$24, $Parser__reduce_26$25, $Parser__reduce_27$26, $Parser__reduce_28$27, $Parser__reduce_29$28, $Parser__reduce_30$29, $Parser__reduce_none$30, racc_action_table = nil, racc_action_check = nil, racc_action_pointer = nil, racc_action_default = nil, racc_goto_table = nil, racc_goto_check = nil, racc_goto_pointer = nil, racc_goto_default = nil, racc_reduce_table = nil, racc_reduce_n = nil, racc_shift_n = nil, racc_token_table = nil, racc_nt_base = nil, racc_use_result_var = nil;

          self.$$prototype.lexer = nil;
          
          Opal.defs(self, '$parse', $Parser_parse$1 = function $$parse(source) {
            var self = this;

            return self.$new().$parse(source)
          }, $Parser_parse$1.$$arity = 1);
          
          Opal.def(self, '$parse', $Parser_parse$2 = function $$parse(source) {
            var self = this;

            try {
              
              self.lexer = $$($nesting, 'Lexer').$new(source);
              return self.$do_parse();
            } catch ($err) {
              if (Opal.rescue($err, [$$($nesting, 'ParseError')])) {
                try {
                  return nil
                } finally { Opal.pop_exception() }
              } else { throw $err; }
            }
          }, $Parser_parse$2.$$arity = 1);
          self.$private();
          
          Opal.def(self, '$next_token', $Parser_next_token$3 = function $$next_token() {
            var self = this;

            return self.lexer.$next_token()
          }, $Parser_next_token$3.$$arity = 0);
          
          Opal.def(self, '$expand_negate', $Parser_expand_negate$4 = function $$expand_negate(op, rhs) {
            var self = this;

            
            if ($truthy(rhs['$is_a?']($$$($$($nesting, 'Node'), 'Negate')))) {
              if (op['$==']("+")) {
                return ["-", rhs.$body()]
              } else if (op['$==']("-")) {
                return ["+", rhs.$body()]}};
            return [op, rhs];
          }, $Parser_expand_negate$4.$$arity = 2);
          racc_action_table = [13, 16, 17, 18, 19, 3, 32, 13, 4, 13, 14, 8, 9, 22, 13, 12, 13, 26, 8, 9, 8, 9, 12, 13, 12, 8, 9, 8, 9, 12, 13, 12, 13, nil, 8, 9, 13, 13, 12, 13, nil, 8, 9, 8, 9, 12, 15, 12, 8, 9, nil, 12, 12, nil, 12, nil, 16, 17, 35, 37, 34, 36, 16, 17, 18, 19, 18, 19, 40, 39, 42, 43, 44, 45];
          racc_action_check = [15, 23, 23, 6, 6, 0, 23, 2, 1, 8, 4, 15, 15, 11, 9, 15, 12, 15, 2, 2, 8, 8, 2, 16, 8, 9, 9, 12, 12, 9, 17, 12, 18, nil, 16, 16, 22, 19, 16, 38, nil, 17, 17, 18, 18, 17, 5, 18, 19, 19, nil, 22, 19, nil, 38, nil, 5, 5, 30, 30, 30, 30, 25, 25, 27, 27, 28, 28, 31, 31, 39, 39, 40, 40];
          racc_action_pointer = [1, 8, 5, nil, 10, 43, -12, nil, 7, 12, nil, 8, 14, nil, nil, -2, 21, 28, 30, 35, nil, nil, 34, -12, nil, 49, nil, 49, 51, nil, 49, 63, nil, nil, nil, nil, nil, nil, 37, 63, 65, nil, nil, nil, nil, nil];
          racc_action_default = [-3, -31, -31, -4, -31, -1, -9, -12, -31, -31, -20, -24, -31, -30, 46, -31, -31, -31, -31, -31, -18, -19, -22, -31, -2, -5, -6, -7, -8, -10, -13, -21, -29, -11, -14, -15, -16, -17, -31, -31, -31, -23, -25, -26, -27, -28];
          racc_goto_table = [31, 5, 20, 21, 27, 28, 1, 2, 24, 33, 38, 23, 29, 30, 25, nil, 41];
          racc_goto_check = [9, 3, 6, 6, 5, 5, 1, 2, 4, 7, 10, 3, 6, 6, 3, nil, 9];
          racc_goto_pointer = [nil, 6, 7, -1, -7, -12, -6, -21, nil, -22, -21];
          racc_goto_default = [nil, nil, nil, nil, nil, 6, 7, nil, 10, 11, nil];
          racc_reduce_table = [0, 0, "racc_error", 2, 21, "_reduce_1", 4, 21, "_reduce_2", 0, 22, "_reduce_3", 1, 22, "_reduce_4", 1, 24, "_reduce_none", 1, 24, "_reduce_6", 3, 23, "_reduce_7", 3, 23, "_reduce_8", 1, 23, "_reduce_none", 3, 25, "_reduce_10", 4, 25, "_reduce_11", 1, 25, "_reduce_none", 0, 27, "_reduce_13", 1, 27, "_reduce_14", 1, 27, "_reduce_15", 1, 27, "_reduce_16", 1, 27, "_reduce_17", 2, 26, "_reduce_18", 2, 26, "_reduce_19", 1, 26, "_reduce_none", 3, 28, "_reduce_21", 2, 28, "_reduce_22", 5, 28, "_reduce_23", 1, 28, "_reduce_none", 2, 30, "_reduce_25", 2, 30, "_reduce_26", 2, 30, "_reduce_27", 2, 30, "_reduce_28", 3, 29, "_reduce_29", 1, 29, "_reduce_30"];
          racc_reduce_n = 31;
          racc_shift_n = 46;
          racc_token_table = $hash(false, 0, "error", 1, "NUMBER", 2, "CMP_OP", 3, "S", 4, "D", 5, "K", 6, "H", 7, "L", 8, "U", 9, "R", 10, "F", 11, "C", 12, "PLUS", 13, "MINUS", 14, "ASTERISK", 15, "SLASH", 16, "PARENL", 17, "PARENR", 18, "QUESTION", 19);
          racc_nt_base = 20;
          racc_use_result_var = true;
          Opal.const_set($nesting[0], 'Racc_arg', [racc_action_table, racc_action_check, racc_action_default, racc_action_pointer, racc_goto_table, racc_goto_check, racc_goto_default, racc_goto_pointer, racc_nt_base, racc_reduce_table, racc_token_table, racc_shift_n, racc_reduce_n, racc_use_result_var]);
          Opal.const_set($nesting[0], 'Racc_token_to_s_table', ["$end", "error", "NUMBER", "CMP_OP", "S", "D", "K", "H", "L", "U", "R", "F", "C", "PLUS", "MINUS", "ASTERISK", "SLASH", "PARENL", "PARENR", "QUESTION", "$start", "command", "secret", "add", "target", "mul", "unary", "round_type", "dice", "term", "filter_type"]);
          Opal.const_set($nesting[0], 'Racc_debug_parser', false);
          
          Opal.def(self, '$_reduce_1', $Parser__reduce_1$5 = function $$_reduce_1(val, _values, result) {
            var $a, $b, self = this, secret = nil, lhs = nil;

            
            $b = val, $a = Opal.to_ary($b), (secret = ($a[0] == null ? nil : $a[0])), (lhs = ($a[1] == null ? nil : $a[1])), $b;
            if ($truthy(lhs['$include_dice?']())) {
            } else {
              self.$raise($$($nesting, 'ParseError'))
            };
            result = $$$($$($nesting, 'Node'), 'Command').$new(secret, lhs);
            return result;
          }, $Parser__reduce_1$5.$$arity = 3);
          
          Opal.def(self, '$_reduce_2', $Parser__reduce_2$6 = function $$_reduce_2(val, _values, result) {
            var $a, $b, self = this, secret = nil, lhs = nil, cmp_op = nil, rhs = nil, $ret_or_1 = nil, $ret_or_2 = nil;

            
            $b = val, $a = Opal.to_ary($b), (secret = ($a[0] == null ? nil : $a[0])), (lhs = ($a[1] == null ? nil : $a[1])), (cmp_op = ($a[2] == null ? nil : $a[2])), (rhs = ($a[3] == null ? nil : $a[3])), $b;
            if ($truthy((function() {if ($truthy(($ret_or_1 = (function() {if ($truthy(($ret_or_2 = lhs['$include_dice?']()['$!']()))) {
              return $ret_or_2
            } else {
              return rhs['$include_dice?']()
            }; return nil; })()))) {
              return $ret_or_1
            } else {
              return cmp_op['$nil?']()
            }; return nil; })())) {
              self.$raise($$($nesting, 'ParseError'))};
            result = $$$($$($nesting, 'Node'), 'Command').$new(secret, lhs, cmp_op, rhs);
            return result;
          }, $Parser__reduce_2$6.$$arity = 3);
          
          Opal.def(self, '$_reduce_3', $Parser__reduce_3$7 = function $$_reduce_3(val, _values, result) {
            var self = this;

            
            result = false;
            return result;
          }, $Parser__reduce_3$7.$$arity = 3);
          
          Opal.def(self, '$_reduce_4', $Parser__reduce_4$8 = function $$_reduce_4(val, _values, result) {
            var self = this;

            
            result = true;
            return result;
          }, $Parser__reduce_4$8.$$arity = 3);
          
          Opal.def(self, '$_reduce_6', $Parser__reduce_6$9 = function $$_reduce_6(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'UndecidedTarget').$instance();
            return result;
          }, $Parser__reduce_6$9.$$arity = 3);
          
          Opal.def(self, '$_reduce_7', $Parser__reduce_7$10 = function $$_reduce_7(val, _values, result) {
            var $a, $b, self = this, lhs = nil, op = nil, rhs = nil;

            
            lhs = val['$[]'](0);
            $b = self.$expand_negate("+", val['$[]'](2)), $a = Opal.to_ary($b), (op = ($a[0] == null ? nil : $a[0])), (rhs = ($a[1] == null ? nil : $a[1])), $b;
            result = $$$($$($nesting, 'Node'), 'BinaryOp').$new(lhs, op, rhs);
            return result;
          }, $Parser__reduce_7$10.$$arity = 3);
          
          Opal.def(self, '$_reduce_8', $Parser__reduce_8$11 = function $$_reduce_8(val, _values, result) {
            var $a, $b, self = this, lhs = nil, op = nil, rhs = nil;

            
            lhs = val['$[]'](0);
            $b = self.$expand_negate("-", val['$[]'](2)), $a = Opal.to_ary($b), (op = ($a[0] == null ? nil : $a[0])), (rhs = ($a[1] == null ? nil : $a[1])), $b;
            result = $$$($$($nesting, 'Node'), 'BinaryOp').$new(lhs, op, rhs);
            return result;
          }, $Parser__reduce_8$11.$$arity = 3);
          
          Opal.def(self, '$_reduce_10', $Parser__reduce_10$12 = function $$_reduce_10(val, _values, result) {
            var self = this, lhs = nil, rhs = nil;

            
            lhs = val['$[]'](0);
            rhs = val['$[]'](2);
            result = $$$($$($nesting, 'Node'), 'BinaryOp').$new(lhs, "*", rhs);
            return result;
          }, $Parser__reduce_10$12.$$arity = 3);
          
          Opal.def(self, '$_reduce_11', $Parser__reduce_11$13 = function $$_reduce_11(val, _values, result) {
            var self = this, lhs = nil, rhs = nil, divied_class = nil;

            
            lhs = val['$[]'](0);
            rhs = val['$[]'](2);
            divied_class = val['$[]'](3);
            result = divied_class.$new(lhs, rhs);
            return result;
          }, $Parser__reduce_11$13.$$arity = 3);
          
          Opal.def(self, '$_reduce_13', $Parser__reduce_13$14 = function $$_reduce_13(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'DivideWithGameSystemDefault');
            return result;
          }, $Parser__reduce_13$14.$$arity = 3);
          
          Opal.def(self, '$_reduce_14', $Parser__reduce_14$15 = function $$_reduce_14(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'DivideWithRoundingDown');
            return result;
          }, $Parser__reduce_14$15.$$arity = 3);
          
          Opal.def(self, '$_reduce_15', $Parser__reduce_15$16 = function $$_reduce_15(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'DivideWithRoundingUp');
            return result;
          }, $Parser__reduce_15$16.$$arity = 3);
          
          Opal.def(self, '$_reduce_16', $Parser__reduce_16$17 = function $$_reduce_16(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'DivideWithRoundingUp');
            return result;
          }, $Parser__reduce_16$17.$$arity = 3);
          
          Opal.def(self, '$_reduce_17', $Parser__reduce_17$18 = function $$_reduce_17(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'DivideWithRoundingOff');
            return result;
          }, $Parser__reduce_17$18.$$arity = 3);
          
          Opal.def(self, '$_reduce_18', $Parser__reduce_18$19 = function $$_reduce_18(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_18$19.$$arity = 3);
          
          Opal.def(self, '$_reduce_19', $Parser__reduce_19$20 = function $$_reduce_19(val, _values, result) {
            var self = this, body = nil;

            
            body = val['$[]'](1);
            result = (function() {if ($truthy(body['$is_a?']($$$($$($nesting, 'Node'), 'Negate')))) {
              return body.$body()
            } else {
              return $$$($$($nesting, 'Node'), 'Negate').$new(body)
            }; return nil; })();
            return result;
          }, $Parser__reduce_19$20.$$arity = 3);
          
          Opal.def(self, '$_reduce_21', $Parser__reduce_21$21 = function $$_reduce_21(val, _values, result) {
            var self = this, times = nil, sides = nil, $ret_or_3 = nil;

            
            times = val['$[]'](0);
            sides = val['$[]'](2);
            if ($truthy((function() {if ($truthy(($ret_or_3 = times['$include_dice?']()))) {
              return $ret_or_3
            } else {
              return sides['$include_dice?']()
            }; return nil; })())) {
              self.$raise($$($nesting, 'ParseError'))};
            result = $$$($$($nesting, 'Node'), 'DiceRoll').$new(times, sides);
            return result;
          }, $Parser__reduce_21$21.$$arity = 3);
          
          Opal.def(self, '$_reduce_22', $Parser__reduce_22$22 = function $$_reduce_22(val, _values, result) {
            var self = this, times = nil;

            
            times = val['$[]'](0);
            if ($truthy(times['$include_dice?']())) {
              self.$raise($$($nesting, 'ParseError'))};
            result = $$$($$($nesting, 'Node'), 'ImplicitSidesDiceRoll').$new(times);
            return result;
          }, $Parser__reduce_22$22.$$arity = 3);
          
          Opal.def(self, '$_reduce_23', $Parser__reduce_23$23 = function $$_reduce_23(val, _values, result) {
            var self = this, times = nil, sides = nil, filter = nil, n_filtering = nil, $ret_or_4 = nil, $ret_or_5 = nil;

            
            times = val['$[]'](0);
            sides = val['$[]'](2);
            filter = val['$[]'](3);
            n_filtering = val['$[]'](4);
            if ($truthy((function() {if ($truthy(($ret_or_4 = (function() {if ($truthy(($ret_or_5 = times['$include_dice?']()))) {
              return $ret_or_5
            } else {
              return sides['$include_dice?']()
            }; return nil; })()))) {
              return $ret_or_4
            } else {
              return n_filtering['$include_dice?']()
            }; return nil; })())) {
              self.$raise($$($nesting, 'ParseError'))};
            result = $$$($$($nesting, 'Node'), 'DiceRollWithFilter').$new(times, sides, n_filtering, filter);
            return result;
          }, $Parser__reduce_23$23.$$arity = 3);
          
          Opal.def(self, '$_reduce_25', $Parser__reduce_25$24 = function $$_reduce_25(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Node'), 'DiceRollWithFilter'), 'KEEP_HIGHEST');
            return result;
          }, $Parser__reduce_25$24.$$arity = 3);
          
          Opal.def(self, '$_reduce_26', $Parser__reduce_26$25 = function $$_reduce_26(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Node'), 'DiceRollWithFilter'), 'KEEP_LOWEST');
            return result;
          }, $Parser__reduce_26$25.$$arity = 3);
          
          Opal.def(self, '$_reduce_27', $Parser__reduce_27$26 = function $$_reduce_27(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Node'), 'DiceRollWithFilter'), 'DROP_HIGHEST');
            return result;
          }, $Parser__reduce_27$26.$$arity = 3);
          
          Opal.def(self, '$_reduce_28', $Parser__reduce_28$27 = function $$_reduce_28(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Node'), 'DiceRollWithFilter'), 'DROP_LOWEST');
            return result;
          }, $Parser__reduce_28$27.$$arity = 3);
          
          Opal.def(self, '$_reduce_29', $Parser__reduce_29$28 = function $$_reduce_29(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'Parenthesis').$new(val['$[]'](1));
            return result;
          }, $Parser__reduce_29$28.$$arity = 3);
          
          Opal.def(self, '$_reduce_30', $Parser__reduce_30$29 = function $$_reduce_30(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'Number').$new(val['$[]'](0));
            return result;
          }, $Parser__reduce_30$29.$$arity = 3);
          return (Opal.def(self, '$_reduce_none', $Parser__reduce_none$30 = function $$_reduce_none(val, _values, result) {
            var self = this;

            return val['$[]'](0)
          }, $Parser__reduce_none$30.$$arity = 3), nil) && '_reduce_none';
        })($nesting[0], $$$($$($nesting, 'Racc'), 'Parser'), $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/add_dice/randomizer"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'AddDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Randomizer');

          var $nesting = [self].concat($parent_nesting), $Randomizer_initialize$1, $Randomizer_roll$2;

          self.$$prototype.game_system = self.$$prototype.rand_source = self.$$prototype.rand_results = nil;
          
          self.$attr_reader("rand_results");
          Opal.const_set($nesting[0], 'RandResult', $$($nesting, 'Struct').$new("sides", "value"));
          
          Opal.def(self, '$initialize', $Randomizer_initialize$1 = function $$initialize(rand_source, game_system) {
            var self = this;

            
            self.rand_source = rand_source;
            self.game_system = game_system;
            return (self.rand_results = []);
          }, $Randomizer_initialize$1.$$arity = 2);
          return (Opal.def(self, '$roll', $Randomizer_roll$2 = function $$roll(times, sides) {
            var $$3, $$4, $$5, self = this, dice_list = nil, $ret_or_1 = nil, rand_results = nil;

            
            dice_list = (function() {if (sides['$=='](66)) {
              return $send($$($nesting, 'Array'), 'new', [times], ($$3 = function(){var self = $$3.$$s == null ? this : $$3.$$s;
                if (self.rand_source == null) self.rand_source = nil;
                if (self.game_system == null) self.game_system = nil;

              return self.rand_source.$roll_d66(self.game_system.$d66_sort_type())}, $$3.$$s = self, $$3.$$arity = 0, $$3))
            } else if ($truthy((function() {if ($truthy(($ret_or_1 = sides['$=='](9)))) {
              return self.game_system['$enabled_d9?']()
            } else {
              return $ret_or_1
            }; return nil; })())) {
              return $send($$($nesting, 'Array'), 'new', [times], ($$4 = function(){var self = $$4.$$s == null ? this : $$4.$$s;
                if (self.rand_source == null) self.rand_source = nil;

              return self.rand_source.$roll_d9()}, $$4.$$s = self, $$4.$$arity = 0, $$4))
            } else {
              return self.rand_source.$roll_barabara(times, sides)
            }; return nil; })();
            if ($truthy(self.game_system['$sort_add_dice?']())) {
              dice_list['$sort!']()};
            rand_results = $send(dice_list, 'map', [], ($$5 = function(value){var self = $$5.$$s == null ? this : $$5.$$s;

            
              
              if (value == null) {
                value = nil;
              };
              return $$($nesting, 'RandResult').$new(sides, value);}, $$5.$$s = self, $$5.$$arity = 1, $$5));
            self.rand_results.$concat(rand_results);
            return dice_list;
          }, $Randomizer_roll$2.$$arity = 2), nil) && 'roll';
        })($nesting[0], null, $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/add_dice"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $send = Opal.send;

  
  self.$require("bcdice/normalize");
  self.$require("bcdice/common_command/add_dice/parser");
  self.$require("bcdice/common_command/add_dice/randomizer");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'AddDice');

        var $nesting = [self].concat($parent_nesting);

        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /[+\-(]*\d+/.$freeze());
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1;

          return (Opal.def(self, '$eval', $eval$1 = function(command, game_system, randomizer) {
            var $a, self = this, cmd = nil;

            
            cmd = $$($nesting, 'Parser').$parse(command);
            return ($a = cmd, ($a === nil || $a == null) ? nil : $send($a, 'eval', [game_system, randomizer]));
          }, $eval$1.$$arity = 3), nil) && 'eval'
        })(Opal.get_singleton_class(self), $nesting);
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/reroll_dice/node"] = function(Opal) {
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash2 = Opal.hash2, $truthy = Opal.truthy, $send = Opal.send;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'RerollDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $parent_nesting) {
          var self = $module($base, 'Node');

          var $nesting = [self].concat($parent_nesting);

          
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Command');

            var $nesting = [self].concat($parent_nesting), $Command_initialize$1, $Command_eval$2, $Command_roll$7, $Command_expr$9, $Command_result_with_text$11;

            self.$$prototype.cmp_op = self.$$prototype.reroll_cmp_op = self.$$prototype.target_number_node = self.$$prototype.reroll_threshold_node = self.$$prototype.notations = self.$$prototype.source = nil;
            
            
            Opal.def(self, '$initialize', $Command_initialize$1 = function $$initialize($kwargs) {
              var secret, notations, source, cmp_op, target_number, reroll_cmp_op, reroll_threshold, self = this;

              
              
              if ($kwargs == null) {
                $kwargs = $hash2([], {});
              } else if (!$kwargs.$$is_hash) {
                throw Opal.ArgumentError.$new('expected kwargs');
              };
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'secret')) {
                throw Opal.ArgumentError.$new('missing keyword: secret');
              }
              secret = $kwargs.$$smap["secret"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'notations')) {
                throw Opal.ArgumentError.$new('missing keyword: notations');
              }
              notations = $kwargs.$$smap["notations"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'source')) {
                throw Opal.ArgumentError.$new('missing keyword: source');
              }
              source = $kwargs.$$smap["source"];;
              
              cmp_op = $kwargs.$$smap["cmp_op"];
              if (cmp_op == null) {
                cmp_op = nil
              };
              
              target_number = $kwargs.$$smap["target_number"];
              if (target_number == null) {
                target_number = nil
              };
              
              reroll_cmp_op = $kwargs.$$smap["reroll_cmp_op"];
              if (reroll_cmp_op == null) {
                reroll_cmp_op = nil
              };
              
              reroll_threshold = $kwargs.$$smap["reroll_threshold"];
              if (reroll_threshold == null) {
                reroll_threshold = nil
              };
              self.secret = secret;
              self.notations = notations;
              self.cmp_op = cmp_op;
              self.target_number_node = target_number;
              self.reroll_cmp_op = reroll_cmp_op;
              self.reroll_threshold_node = reroll_threshold;
              return (self.source = source);
            }, $Command_initialize$1.$$arity = 1);
            
            Opal.def(self, '$eval', $Command_eval$2 = function(game_system, randomizer) {
              var $a, $b, $$3, $$4, $$5, $$6, self = this, round_type = nil, cmp_op = nil, $ret_or_1 = nil, reroll_cmp_op = nil, $ret_or_2 = nil, $ret_or_3 = nil, target_number = nil, $ret_or_4 = nil, reroll_threshold = nil, $ret_or_5 = nil, $ret_or_6 = nil, reroll_condition = nil, dice_queue = nil, dice_list_list = nil, dice_list = nil, one_count = nil, success_count = nil, sequence = nil;

              
              round_type = game_system.$round_type();
              cmp_op = (function() {if ($truthy(($ret_or_1 = self.cmp_op))) {
                return $ret_or_1
              } else {
                return game_system.$default_cmp_op()
              }; return nil; })();
              reroll_cmp_op = (function() {if ($truthy(($ret_or_2 = (function() {if ($truthy(($ret_or_3 = self.reroll_cmp_op))) {
                return $ret_or_3
              } else {
                return cmp_op
              }; return nil; })()))) {
                return $ret_or_2
              } else {
                return ">="
              }; return nil; })();
              target_number = (function() {if ($truthy(($ret_or_4 = ($a = self.target_number_node, ($a === nil || $a == null) ? nil : $send($a, 'eval', [round_type]))))) {
                return $ret_or_4
              } else {
                return game_system.$default_target_number()
              }; return nil; })();
              reroll_threshold = (function() {if ($truthy(($ret_or_5 = (function() {if ($truthy(($ret_or_6 = ($b = self.reroll_threshold_node, ($b === nil || $b == null) ? nil : $send($b, 'eval', [round_type]))))) {
                return $ret_or_6
              } else {
                return game_system.$reroll_dice_reroll_threshold()
              }; return nil; })()))) {
                return $ret_or_5
              } else {
                return target_number
              }; return nil; })();
              reroll_condition = $$($nesting, 'RerollCondition').$new(reroll_cmp_op, reroll_threshold);
              dice_queue = $send(self.notations, 'map', [], ($$3 = function(node){var self = $$3.$$s == null ? this : $$3.$$s;

              
                
                if (node == null) {
                  node = nil;
                };
                return node.$to_dice(round_type);}, $$3.$$s = self, $$3.$$arity = 1, $$3));
              if ($truthy($send(dice_queue, 'all?', [], ($$4 = function(d){var self = $$4.$$s == null ? this : $$4.$$s;

              
                
                if (d == null) {
                  d = nil;
                };
                return reroll_condition['$valid?'](d.$sides());}, $$4.$$s = self, $$4.$$arity = 1, $$4)))) {
              } else {
                return self.$result_with_text("" + (self.source) + " ＞ 条件が間違っています。2R6>=5 あるいは 2R6[5] のように振り足し目標値を指定してください。")
              };
              dice_list_list = self.$roll(dice_queue, randomizer, reroll_condition, game_system['$sort_barabara_dice?']());
              dice_list = dice_list_list.$flatten();
              one_count = dice_list_list.$take(self.notations.$size()).$flatten().$count(1);
              success_count = (function() {if ($truthy(cmp_op)) {
                return $send(dice_list, 'count', [], ($$5 = function(val){var self = $$5.$$s == null ? this : $$5.$$s;

                
                  
                  if (val == null) {
                    val = nil;
                  };
                  return val.$send(cmp_op, target_number);}, $$5.$$s = self, $$5.$$arity = 1, $$5))
              } else {
                return 0
              }; return nil; })();
              sequence = [self.$expr(round_type, reroll_condition, cmp_op, target_number), $send(dice_list_list, 'map', [], ($$6 = function(list){var self = $$6.$$s == null ? this : $$6.$$s;

              
                
                if (list == null) {
                  list = nil;
                };
                return list.$join(",");}, $$6.$$s = self, $$6.$$arity = 1, $$6)).$join(" + "), "" + "成功数" + (success_count), game_system.$grich_text(one_count, dice_list.$size(), success_count)].$compact();
              return self.$result_with_text(sequence.$join(" ＞ "));
            }, $Command_eval$2.$$arity = 2);
            self.$private();
            
            Opal.def(self, '$roll', $Command_roll$7 = function $$roll(dice_queue, randomizer, reroll_condition, sort) {
              var $a, $$8, self = this, dice_list_list = nil, loop_count = nil, $ret_or_7 = nil, dice = nil, dice_list = nil, reroll_count = nil;

              
              dice_list_list = [];
              loop_count = 0;
              while ($truthy((function() {if ($truthy(($ret_or_7 = dice_queue['$empty?']()['$!']()))) {
                return $rb_lt(loop_count, $$($nesting, 'REROLL_LIMIT'))
              } else {
                return $ret_or_7
              }; return nil; })())) {
                
                dice = dice_queue.$shift();
                loop_count = $rb_plus(loop_count, 1);
                dice_list = dice.$roll(randomizer);
                if ($truthy(sort)) {
                  dice_list['$sort!']()};
                dice_list_list.$push(dice_list);
                reroll_count = $send(dice_list, 'count', [], ($$8 = function(val){var self = $$8.$$s == null ? this : $$8.$$s;

                
                  
                  if (val == null) {
                    val = nil;
                  };
                  return reroll_condition['$reroll?'](val);}, $$8.$$s = self, $$8.$$arity = 1, $$8));
                if ($truthy($rb_gt(reroll_count, 0))) {
                  dice_queue.$push($$($nesting, 'Dice').$new(reroll_count, dice.$sides()))};
              };
              return dice_list_list;
            }, $Command_roll$7.$$arity = 4);
            
            Opal.def(self, '$expr', $Command_expr$9 = function $$expr(round_type, reroll_condition, cmp_op, target_number) {
              var $$10, self = this, notation = nil, reroll_cmp_op_text = nil, cmp_op_text = nil;

              
              notation = $send(self.notations, 'map', [], ($$10 = function(n){var self = $$10.$$s == null ? this : $$10.$$s;

              
                
                if (n == null) {
                  n = nil;
                };
                return n.$to_dice(round_type);}, $$10.$$s = self, $$10.$$arity = 1, $$10)).$join("+");
              reroll_cmp_op_text = (function() {if (reroll_condition.$cmp_op()['$=='](cmp_op)) {
                return ""
              } else {
                return $$($nesting, 'Format').$comparison_operator(reroll_condition.$cmp_op())
              }; return nil; })();
              cmp_op_text = $$($nesting, 'Format').$comparison_operator(cmp_op);
              return "" + "(" + (notation) + "[" + (reroll_cmp_op_text) + (reroll_condition.$threshold()) + "]" + (cmp_op_text) + (target_number) + ")";
            }, $Command_expr$9.$$arity = 4);
            return (Opal.def(self, '$result_with_text', $Command_result_with_text$11 = function $$result_with_text(text) {
              var $$12, self = this;

              return $send($$($nesting, 'Result').$new(), 'tap', [], ($$12 = function(r){var self = $$12.$$s == null ? this : $$12.$$s, $writer = nil;
                if (self.secret == null) self.secret = nil;

              
                
                if (r == null) {
                  r = nil;
                };
                
                $writer = [self.secret];
                $send(r, 'secret=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];;
                
                $writer = [text];
                $send(r, 'text=', Opal.to_a($writer));
                return $writer[$rb_minus($writer["length"], 1)];;}, $$12.$$s = self, $$12.$$arity = 1, $$12))
            }, $Command_result_with_text$11.$$arity = 1), nil) && 'result_with_text';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'RerollCondition');

            var $nesting = [self].concat($parent_nesting), $RerollCondition_initialize$13, $RerollCondition_valid$ques$14, $RerollCondition_reroll$ques$15;

            self.$$prototype.threshold = self.$$prototype.cmp_op = nil;
            
            self.$attr_reader("cmp_op");
            self.$attr_reader("threshold");
            
            Opal.def(self, '$initialize', $RerollCondition_initialize$13 = function $$initialize(cmp_op, threshold) {
              var self = this;

              
              self.cmp_op = cmp_op;
              return (self.threshold = threshold);
            }, $RerollCondition_initialize$13.$$arity = 2);
            
            Opal.def(self, '$valid?', $RerollCondition_valid$ques$14 = function(sides) {
              var self = this, $case = nil;

              
              if ($truthy(self.threshold)) {
              } else {
                return false
              };
              return (function() {$case = self.cmp_op;
              if ("<="['$===']($case)) {return $rb_lt(self.threshold, sides)}
              else if ("<"['$===']($case)) {return $rb_le(self.threshold, sides)}
              else if (">="['$===']($case)) {return $rb_gt(self.threshold, 1)}
              else if (">"['$===']($case)) {return $rb_ge(self.threshold, 1)}
              else if ("!="['$===']($case)) {return Opal.Range.$new(1, sides, false)['$include?'](self.threshold)}
              else {return true}})();
            }, $RerollCondition_valid$ques$14.$$arity = 1);
            return (Opal.def(self, '$reroll?', $RerollCondition_reroll$ques$15 = function(value) {
              var self = this;

              return value.$send(self.cmp_op, self.threshold)
            }, $RerollCondition_reroll$ques$15.$$arity = 1), nil) && 'reroll?';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Notation');

            var $nesting = [self].concat($parent_nesting), $Notation_initialize$16, $Notation_to_dice$17;

            self.$$prototype.times = self.$$prototype.sides = nil;
            
            
            Opal.def(self, '$initialize', $Notation_initialize$16 = function $$initialize(times, sides) {
              var self = this;

              
              self.times = times;
              return (self.sides = sides);
            }, $Notation_initialize$16.$$arity = 2);
            return (Opal.def(self, '$to_dice', $Notation_to_dice$17 = function $$to_dice(round_type) {
              var self = this, times = nil, sides = nil;

              
              times = self.times.$eval(round_type);
              sides = self.sides.$eval(round_type);
              return $$($nesting, 'Dice').$new(times, sides);
            }, $Notation_to_dice$17.$$arity = 1), nil) && 'to_dice';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Dice');

            var $nesting = [self].concat($parent_nesting), $Dice_initialize$18, $Dice_roll$19, $Dice_to_s$20;

            
            self.$attr_reader("times", "sides");
            
            Opal.def(self, '$initialize', $Dice_initialize$18 = function $$initialize(times, sides) {
              var self = this;

              
              self.times = times;
              return (self.sides = sides);
            }, $Dice_initialize$18.$$arity = 2);
            
            Opal.def(self, '$roll', $Dice_roll$19 = function $$roll(randomizer) {
              var self = this;

              return randomizer.$roll_barabara(self.$times(), self.$sides())
            }, $Dice_roll$19.$$arity = 1);
            return (Opal.def(self, '$to_s', $Dice_to_s$20 = function $$to_s() {
              var self = this;

              return "" + (self.$times()) + "R" + (self.$sides())
            }, $Dice_to_s$20.$$arity = 0), nil) && 'to_s';
          })($nesting[0], null, $nesting);
        })($nesting[0], $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/arithmetic/node"] = function(Opal) {
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send2 = Opal.send2;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'Arithmetic');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'Node');

        var $nesting = [self].concat($parent_nesting);

        
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'BinaryOp');

          var $nesting = [self].concat($parent_nesting), $BinaryOp_initialize$1, $BinaryOp_eval$2, $BinaryOp_output$3, $BinaryOp_s_exp$4, $BinaryOp_op_for_s_exp$5;

          self.$$prototype.lhs = self.$$prototype.rhs = self.$$prototype.op = nil;
          
          
          Opal.def(self, '$initialize', $BinaryOp_initialize$1 = function $$initialize(lhs, op, rhs) {
            var self = this;

            
            self.lhs = lhs;
            self.op = op;
            return (self.rhs = rhs);
          }, $BinaryOp_initialize$1.$$arity = 3);
          
          Opal.def(self, '$eval', $BinaryOp_eval$2 = function(round_type) {
            var self = this, l = nil, r = nil;

            
            l = self.lhs.$eval(round_type);
            r = self.rhs.$eval(round_type);
            return l.$send(self.op, r);
          }, $BinaryOp_eval$2.$$arity = 1);
          
          Opal.def(self, '$output', $BinaryOp_output$3 = function $$output() {
            var self = this;

            return "" + (self.lhs.$output()) + (self.op) + (self.rhs.$output())
          }, $BinaryOp_output$3.$$arity = 0);
          
          Opal.def(self, '$s_exp', $BinaryOp_s_exp$4 = function $$s_exp() {
            var self = this;

            return "" + "(" + (self.$op_for_s_exp()) + " " + (self.lhs.$s_exp()) + " " + (self.rhs.$s_exp()) + ")"
          }, $BinaryOp_s_exp$4.$$arity = 0);
          return (Opal.def(self, '$op_for_s_exp', $BinaryOp_op_for_s_exp$5 = function $$op_for_s_exp() {
            var self = this;

            return self.op
          }, $BinaryOp_op_for_s_exp$5.$$arity = 0), nil) && 'op_for_s_exp';
        })($nesting[0], null, $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideBase');

          var $nesting = [self].concat($parent_nesting), $DivideBase_initialize$6, $DivideBase_eval$7, $DivideBase_output$8, $DivideBase_rounding_method$9, $DivideBase_op_for_s_exp$10, $DivideBase_divide_and_round$11;

          self.$$prototype.lhs = self.$$prototype.rhs = self.$$prototype.op = nil;
          
          
          Opal.def(self, '$initialize', $DivideBase_initialize$6 = function $$initialize(lhs, rhs) {
            var $iter = $DivideBase_initialize$6.$$p, $yield = $iter || nil, self = this;

            if ($iter) $DivideBase_initialize$6.$$p = null;
            return $send2(self, Opal.find_super_dispatcher(self, 'initialize', $DivideBase_initialize$6, false, true), 'initialize', [lhs, "/", rhs], null)
          }, $DivideBase_initialize$6.$$arity = 2);
          
          Opal.def(self, '$eval', $DivideBase_eval$7 = function(round_type) {
            var self = this, l = nil, r = nil;

            
            l = self.lhs.$eval(round_type);
            r = self.rhs.$eval(round_type);
            if (r['$=='](0)) {
              self.$raise($$($nesting, 'ZeroDivisionError'))};
            return self.$divide_and_round(l, r, round_type);
          }, $DivideBase_eval$7.$$arity = 1);
          
          Opal.def(self, '$output', $DivideBase_output$8 = function $$output() {
            var $iter = $DivideBase_output$8.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

            if ($iter) $DivideBase_output$8.$$p = null;
            // Prepare super implicit arguments
            for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
              $zuper[$zuper_i] = arguments[$zuper_i];
            }
            return "" + ($send2(self, Opal.find_super_dispatcher(self, 'output', $DivideBase_output$8, false, true), 'output', $zuper, $iter)) + (self.$rounding_method())
          }, $DivideBase_output$8.$$arity = 0);
          self.$private();
          
          Opal.def(self, '$rounding_method', $DivideBase_rounding_method$9 = function $$rounding_method() {
            var self = this;

            return $$$(self.$class(), 'ROUNDING_METHOD')
          }, $DivideBase_rounding_method$9.$$arity = 0);
          
          Opal.def(self, '$op_for_s_exp', $DivideBase_op_for_s_exp$10 = function $$op_for_s_exp() {
            var self = this;

            return "" + (self.op) + (self.$rounding_method())
          }, $DivideBase_op_for_s_exp$10.$$arity = 0);
          return (Opal.def(self, '$divide_and_round', $DivideBase_divide_and_round$11 = function $$divide_and_round(_dividend, _divisor, _round_type) {
            var self = this;

            return self.$raise($$($nesting, 'NotImplementedError'))
          }, $DivideBase_divide_and_round$11.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'BinaryOp'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideWithGameSystemDefault');

          var $nesting = [self].concat($parent_nesting), $DivideWithGameSystemDefault_divide_and_round$12;

          
          Opal.const_set($nesting[0], 'ROUNDING_METHOD', "");
          self.$private();
          return (Opal.def(self, '$divide_and_round', $DivideWithGameSystemDefault_divide_and_round$12 = function $$divide_and_round(dividend, divisor, round_type) {
            var self = this, $case = nil;

            return (function() {$case = round_type;
            if ($$$($$($nesting, 'RoundType'), 'CEIL')['$===']($case)) {return $rb_divide(dividend.$to_f(), divisor).$ceil()}
            else if ($$$($$($nesting, 'RoundType'), 'ROUND')['$===']($case)) {return $rb_divide(dividend.$to_f(), divisor).$round()}
            else {return $rb_divide(dividend, divisor).$to_i()}})()
          }, $DivideWithGameSystemDefault_divide_and_round$12.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideWithCeil');

          var $nesting = [self].concat($parent_nesting), $DivideWithCeil_divide_and_round$13;

          
          Opal.const_set($nesting[0], 'ROUNDING_METHOD', "C");
          self.$private();
          return (Opal.def(self, '$divide_and_round', $DivideWithCeil_divide_and_round$13 = function $$divide_and_round(dividend, divisor, _round_type) {
            var self = this;

            return $rb_divide(dividend.$to_f(), divisor).$ceil()
          }, $DivideWithCeil_divide_and_round$13.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideWithRound');

          var $nesting = [self].concat($parent_nesting), $DivideWithRound_divide_and_round$14;

          
          Opal.const_set($nesting[0], 'ROUNDING_METHOD', "R");
          self.$private();
          return (Opal.def(self, '$divide_and_round', $DivideWithRound_divide_and_round$14 = function $$divide_and_round(dividend, divisor, _round_type) {
            var self = this;

            return $rb_divide(dividend.$to_f(), divisor).$round()
          }, $DivideWithRound_divide_and_round$14.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'DivideWithFloor');

          var $nesting = [self].concat($parent_nesting), $DivideWithFloor_divide_and_round$15;

          
          Opal.const_set($nesting[0], 'ROUNDING_METHOD', "F");
          self.$private();
          return (Opal.def(self, '$divide_and_round', $DivideWithFloor_divide_and_round$15 = function $$divide_and_round(dividend, divisor, _round_type) {
            var self = this;

            return $rb_divide(dividend, divisor).$to_i()
          }, $DivideWithFloor_divide_and_round$15.$$arity = 3), nil) && 'divide_and_round';
        })($nesting[0], $$($nesting, 'DivideBase'), $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Negative');

          var $nesting = [self].concat($parent_nesting), $Negative_initialize$16, $Negative_eval$17, $Negative_output$18, $Negative_s_exp$19;

          self.$$prototype.body = nil;
          
          
          Opal.def(self, '$initialize', $Negative_initialize$16 = function $$initialize(body) {
            var self = this;

            return (self.body = body)
          }, $Negative_initialize$16.$$arity = 1);
          
          Opal.def(self, '$eval', $Negative_eval$17 = function(round_type) {
            var self = this;

            return self.body.$eval(round_type)['$-@']()
          }, $Negative_eval$17.$$arity = 1);
          
          Opal.def(self, '$output', $Negative_output$18 = function $$output() {
            var self = this;

            return "" + "-" + (self.body.$output())
          }, $Negative_output$18.$$arity = 0);
          return (Opal.def(self, '$s_exp', $Negative_s_exp$19 = function $$s_exp() {
            var self = this;

            return "" + "(- " + (self.body.$s_exp()) + ")"
          }, $Negative_s_exp$19.$$arity = 0), nil) && 's_exp';
        })($nesting[0], null, $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Parenthesis');

          var $nesting = [self].concat($parent_nesting), $Parenthesis_initialize$20, $Parenthesis_eval$21, $Parenthesis_output$22, $Parenthesis_s_exp$23;

          self.$$prototype.expr = nil;
          
          
          Opal.def(self, '$initialize', $Parenthesis_initialize$20 = function $$initialize(expr) {
            var self = this;

            return (self.expr = expr)
          }, $Parenthesis_initialize$20.$$arity = 1);
          
          Opal.def(self, '$eval', $Parenthesis_eval$21 = function(round_type) {
            var self = this;

            return self.expr.$eval(round_type)
          }, $Parenthesis_eval$21.$$arity = 1);
          
          Opal.def(self, '$output', $Parenthesis_output$22 = function $$output() {
            var self = this;

            return "" + "(" + (self.expr.$output()) + ")"
          }, $Parenthesis_output$22.$$arity = 0);
          return (Opal.def(self, '$s_exp', $Parenthesis_s_exp$23 = function $$s_exp() {
            var self = this;

            return "" + "(Parenthesis " + (self.expr.$s_exp()) + ")"
          }, $Parenthesis_s_exp$23.$$arity = 0), nil) && 's_exp';
        })($nesting[0], null, $nesting);
        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Number');

          var $nesting = [self].concat($parent_nesting), $Number_initialize$24, $Number_eval$25, $Number_output$26;

          self.$$prototype.value = nil;
          
          
          Opal.def(self, '$initialize', $Number_initialize$24 = function $$initialize(value) {
            var self = this;

            return (self.value = value)
          }, $Number_initialize$24.$$arity = 1);
          
          Opal.def(self, '$eval', $Number_eval$25 = function(_round_type) {
            var self = this;

            return self.value
          }, $Number_eval$25.$$arity = 1);
          
          Opal.def(self, '$output', $Number_output$26 = function $$output() {
            var self = this;

            return self.value.$to_s()
          }, $Number_output$26.$$arity = 0);
          return Opal.alias(self, "s_exp", "output");
        })($nesting[0], null, $nesting);
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/barabara_dice/parser"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash = Opal.hash, $hash2 = Opal.hash2, $truthy = Opal.truthy;

  
  self.$require("racc/parser.rb");
  self.$require("bcdice/common_command/lexer");
  self.$require("bcdice/common_command/reroll_dice/node");
  self.$require("bcdice/arithmetic/node");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'BarabaraDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Parser');

          var $nesting = [self].concat($parent_nesting), $Parser_parse$1, $Parser_parse$2, $Parser_next_token$3, $Parser__reduce_1$4, $Parser__reduce_2$5, $Parser__reduce_3$6, $Parser__reduce_4$7, $Parser__reduce_5$8, $Parser__reduce_6$9, $Parser__reduce_7$10, $Parser__reduce_8$11, $Parser__reduce_9$12, $Parser__reduce_10$13, $Parser__reduce_12$14, $Parser__reduce_13$15, $Parser__reduce_15$16, $Parser__reduce_16$17, $Parser__reduce_17$18, $Parser__reduce_18$19, $Parser__reduce_19$20, $Parser__reduce_20$21, $Parser__reduce_21$22, $Parser__reduce_23$23, $Parser__reduce_24$24, $Parser__reduce_none$25, racc_action_table = nil, racc_action_check = nil, racc_action_pointer = nil, racc_action_default = nil, racc_goto_table = nil, racc_goto_check = nil, racc_goto_pointer = nil, racc_goto_default = nil, racc_reduce_table = nil, racc_reduce_n = nil, racc_shift_n = nil, racc_token_table = nil, racc_nt_base = nil, racc_use_result_var = nil;

          self.$$prototype.lexer = nil;
          
          Opal.defs(self, '$parse', $Parser_parse$1 = function $$parse(source) {
            var self = this;

            return self.$new().$parse(source)
          }, $Parser_parse$1.$$arity = 1);
          
          Opal.def(self, '$parse', $Parser_parse$2 = function $$parse(source) {
            var self = this;

            try {
              
              self.lexer = $$($nesting, 'Lexer').$new(source);
              return self.$do_parse();
            } catch ($err) {
              if (Opal.rescue($err, [$$($nesting, 'ParseError')])) {
                try {
                  return nil
                } finally { Opal.pop_exception() }
              } else { throw $err; }
            }
          }, $Parser_parse$2.$$arity = 1);
          self.$private();
          
          Opal.def(self, '$next_token', $Parser_next_token$3 = function $$next_token() {
            var self = this;

            return self.lexer.$next_token()
          }, $Parser_next_token$3.$$arity = 0);
          racc_action_table = [13, 9, 3, 9, 24, 25, 9, 9, 9, 26, 18, 19, 8, 12, 8, 18, 19, 8, 8, 8, 9, 4, 9, 38, 36, 37, 39, 18, 19, 18, 19, 8, 9, 8, 9, 27, 28, 24, 25, 18, 19, 18, 19, 8, 9, 8, 9, 27, 28, 27, 28, 18, 19, 18, 19, 8, 10, 8, 14];
          racc_action_check = [5, 2, 0, 8, 15, 15, 13, 14, 12, 15, 8, 8, 2, 5, 8, 12, 12, 13, 14, 12, 18, 1, 19, 34, 34, 34, 34, 18, 18, 19, 19, 18, 24, 19, 25, 16, 16, 21, 21, 24, 24, 25, 25, 24, 27, 25, 28, 31, 31, 32, 32, 27, 27, 28, 28, 27, 4, 28, 7];
          racc_action_pointer = [-6, 21, -1, nil, 56, -9, nil, 55, 1, nil, nil, nil, 6, 4, 5, -5, 24, nil, 18, 20, nil, 28, nil, nil, 30, 32, nil, 42, 44, nil, nil, 36, 38, nil, 19, nil, nil, nil, nil, nil];
          racc_action_default = [-2, -25, -25, -3, -25, -4, -7, -25, -25, -24, 40, -1, -25, -25, -25, -25, -11, -14, -25, -25, -22, -5, -6, -8, -25, -25, -23, -25, -25, -20, -21, -9, -10, -12, -15, -13, -16, -17, -18, -19];
          racc_goto_table = [7, 1, 6, 15, 2, 29, 30, 21, 31, 32, 5, 7, 23, 22, 33, 34, 11, 35];
          racc_goto_check = [7, 1, 6, 5, 2, 9, 9, 5, 8, 8, 3, 7, 7, 6, 9, 9, 4, 10];
          racc_goto_pointer = [nil, 1, 4, 8, 11, -5, 0, -2, -16, -13, -17];
          racc_goto_default = [nil, nil, nil, nil, nil, nil, nil, 20, 16, 17, nil];
          racc_reduce_table = [0, 0, "racc_error", 3, 24, "_reduce_1", 0, 25, "_reduce_2", 1, 25, "_reduce_3", 0, 27, "_reduce_4", 2, 27, "_reduce_5", 3, 26, "_reduce_6", 1, 26, "_reduce_7", 3, 29, "_reduce_8", 3, 28, "_reduce_9", 3, 28, "_reduce_10", 1, 28, "_reduce_none", 3, 31, "_reduce_12", 4, 31, "_reduce_13", 1, 31, "_reduce_none", 0, 33, "_reduce_15", 1, 33, "_reduce_16", 1, 33, "_reduce_17", 1, 33, "_reduce_18", 1, 33, "_reduce_19", 2, 32, "_reduce_20", 2, 32, "_reduce_21", 1, 32, "_reduce_none", 3, 30, "_reduce_23", 1, 30, "_reduce_24"];
          racc_reduce_n = 25;
          racc_shift_n = 40;
          racc_token_table = $hash(false, 0, "error", 1, "NUMBER", 2, "B", 3, "R", 4, "U", 5, "C", 6, "F", 7, "S", 8, "PLUS", 9, "MINUS", 10, "ASTERISK", 11, "SLASH", 12, "PARENL", 13, "PARENR", 14, "BRACKETL", 15, "BRACKETR", 16, "LESS", 17, "GREATER", 18, "EQUAL", 19, "NOT", 20, "AT", 21, "CMP_OP", 22);
          racc_nt_base = 23;
          racc_use_result_var = true;
          Opal.const_set($nesting[0], 'Racc_arg', [racc_action_table, racc_action_check, racc_action_default, racc_action_pointer, racc_goto_table, racc_goto_check, racc_goto_default, racc_goto_pointer, racc_nt_base, racc_reduce_table, racc_token_table, racc_shift_n, racc_reduce_n, racc_use_result_var]);
          Opal.const_set($nesting[0], 'Racc_token_to_s_table', ["$end", "error", "NUMBER", "B", "R", "U", "C", "F", "S", "PLUS", "MINUS", "ASTERISK", "SLASH", "PARENL", "PARENR", "BRACKETL", "BRACKETR", "LESS", "GREATER", "EQUAL", "NOT", "AT", "CMP_OP", "$start", "expr", "secret", "notations", "target", "add", "dice", "term", "mul", "unary", "round_type"]);
          Opal.const_set($nesting[0], 'Racc_debug_parser', false);
          
          Opal.def(self, '$_reduce_1', $Parser__reduce_1$4 = function $$_reduce_1(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'Command').$new($hash2(["secret", "notations", "cmp_op", "target_number"], {"secret": val['$[]'](0), "notations": val['$[]'](1), "cmp_op": val['$[]'](2)['$[]']("cmp_op"), "target_number": val['$[]'](2)['$[]']("target")}));
            return result;
          }, $Parser__reduce_1$4.$$arity = 3);
          
          Opal.def(self, '$_reduce_2', $Parser__reduce_2$5 = function $$_reduce_2(val, _values, result) {
            var self = this;

            
            result = false;
            return result;
          }, $Parser__reduce_2$5.$$arity = 3);
          
          Opal.def(self, '$_reduce_3', $Parser__reduce_3$6 = function $$_reduce_3(val, _values, result) {
            var self = this;

            
            result = true;
            return result;
          }, $Parser__reduce_3$6.$$arity = 3);
          
          Opal.def(self, '$_reduce_4', $Parser__reduce_4$7 = function $$_reduce_4(val, _values, result) {
            var self = this;

            
            result = $hash2([], {});
            return result;
          }, $Parser__reduce_4$7.$$arity = 3);
          
          Opal.def(self, '$_reduce_5', $Parser__reduce_5$8 = function $$_reduce_5(val, _values, result) {
            var $a, $b, self = this, cmp_op = nil, target = nil;

            
            $b = val, $a = Opal.to_ary($b), (cmp_op = ($a[0] == null ? nil : $a[0])), (target = ($a[1] == null ? nil : $a[1])), $b;
            if ($truthy(cmp_op)) {
            } else {
              self.$raise($$($nesting, 'ParseError'))
            };
            result = $hash2(["cmp_op", "target"], {"cmp_op": cmp_op, "target": target});
            return result;
          }, $Parser__reduce_5$8.$$arity = 3);
          
          Opal.def(self, '$_reduce_6', $Parser__reduce_6$9 = function $$_reduce_6(val, _values, result) {
            var self = this, notations = nil;

            
            notations = val['$[]'](0);
            notations.$push(val['$[]'](2));
            result = notations;
            return result;
          }, $Parser__reduce_6$9.$$arity = 3);
          
          Opal.def(self, '$_reduce_7', $Parser__reduce_7$10 = function $$_reduce_7(val, _values, result) {
            var self = this;

            
            result = [val['$[]'](0)];
            return result;
          }, $Parser__reduce_7$10.$$arity = 3);
          
          Opal.def(self, '$_reduce_8', $Parser__reduce_8$11 = function $$_reduce_8(val, _values, result) {
            var self = this, times = nil, sides = nil;

            
            times = val['$[]'](0);
            sides = val['$[]'](2);
            result = $$$($$($nesting, 'Node'), 'Notation').$new(times, sides);
            return result;
          }, $Parser__reduce_8$11.$$arity = 3);
          
          Opal.def(self, '$_reduce_9', $Parser__reduce_9$12 = function $$_reduce_9(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "+", val['$[]'](2));
            return result;
          }, $Parser__reduce_9$12.$$arity = 3);
          
          Opal.def(self, '$_reduce_10', $Parser__reduce_10$13 = function $$_reduce_10(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "-", val['$[]'](2));
            return result;
          }, $Parser__reduce_10$13.$$arity = 3);
          
          Opal.def(self, '$_reduce_12', $Parser__reduce_12$14 = function $$_reduce_12(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "*", val['$[]'](2));
            return result;
          }, $Parser__reduce_12$14.$$arity = 3);
          
          Opal.def(self, '$_reduce_13', $Parser__reduce_13$15 = function $$_reduce_13(val, _values, result) {
            var self = this, divied_class = nil;

            
            divied_class = val['$[]'](3);
            result = divied_class.$new(val['$[]'](0), val['$[]'](2));
            return result;
          }, $Parser__reduce_13$15.$$arity = 3);
          
          Opal.def(self, '$_reduce_15', $Parser__reduce_15$16 = function $$_reduce_15(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithGameSystemDefault');
            return result;
          }, $Parser__reduce_15$16.$$arity = 3);
          
          Opal.def(self, '$_reduce_16', $Parser__reduce_16$17 = function $$_reduce_16(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
            return result;
          }, $Parser__reduce_16$17.$$arity = 3);
          
          Opal.def(self, '$_reduce_17', $Parser__reduce_17$18 = function $$_reduce_17(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
            return result;
          }, $Parser__reduce_17$18.$$arity = 3);
          
          Opal.def(self, '$_reduce_18', $Parser__reduce_18$19 = function $$_reduce_18(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithRound');
            return result;
          }, $Parser__reduce_18$19.$$arity = 3);
          
          Opal.def(self, '$_reduce_19', $Parser__reduce_19$20 = function $$_reduce_19(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithFloor');
            return result;
          }, $Parser__reduce_19$20.$$arity = 3);
          
          Opal.def(self, '$_reduce_20', $Parser__reduce_20$21 = function $$_reduce_20(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_20$21.$$arity = 3);
          
          Opal.def(self, '$_reduce_21', $Parser__reduce_21$22 = function $$_reduce_21(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Negative').$new(val['$[]'](1));
            return result;
          }, $Parser__reduce_21$22.$$arity = 3);
          
          Opal.def(self, '$_reduce_23', $Parser__reduce_23$23 = function $$_reduce_23(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_23$23.$$arity = 3);
          
          Opal.def(self, '$_reduce_24', $Parser__reduce_24$24 = function $$_reduce_24(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Number').$new(val['$[]'](0));
            return result;
          }, $Parser__reduce_24$24.$$arity = 3);
          return (Opal.def(self, '$_reduce_none', $Parser__reduce_none$25 = function $$_reduce_none(val, _values, result) {
            var self = this;

            return val['$[]'](0)
          }, $Parser__reduce_none$25.$$arity = 3), nil) && '_reduce_none';
        })($nesting[0], $$$($$($nesting, 'Racc'), 'Parser'), $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/barabara_dice"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $send = Opal.send;

  
  self.$require("bcdice/common_command/barabara_dice/parser");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'BarabaraDice');

        var $nesting = [self].concat($parent_nesting);

        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /\d+B\d+/.$freeze());
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1;

          return (Opal.def(self, '$eval', $eval$1 = function(command, game_system, randomizer) {
            var $a, self = this, cmd = nil;

            
            cmd = $$($nesting, 'Parser').$parse(command);
            return ($a = cmd, ($a === nil || $a == null) ? nil : $send($a, 'eval', [game_system, randomizer]));
          }, $eval$1.$$arity = 3), nil) && 'eval'
        })(Opal.get_singleton_class(self), $nesting);
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/calc/node"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash2 = Opal.hash2, $truthy = Opal.truthy, $send = Opal.send;

  
  self.$require("bcdice/arithmetic/node");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'Calc');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $parent_nesting) {
          var self = $module($base, 'Node');

          var $nesting = [self].concat($parent_nesting);

          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Command');

            var $nesting = [self].concat($parent_nesting), $Command_initialize$1, $Command_eval$2;

            self.$$prototype.expr = nil;
            
            
            Opal.def(self, '$initialize', $Command_initialize$1 = function $$initialize($kwargs) {
              var secret, expr, self = this;

              
              
              if ($kwargs == null) {
                $kwargs = $hash2([], {});
              } else if (!$kwargs.$$is_hash) {
                throw Opal.ArgumentError.$new('expected kwargs');
              };
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'secret')) {
                throw Opal.ArgumentError.$new('missing keyword: secret');
              }
              secret = $kwargs.$$smap["secret"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'expr')) {
                throw Opal.ArgumentError.$new('missing keyword: expr');
              }
              expr = $kwargs.$$smap["expr"];;
              self.secret = secret;
              return (self.expr = expr);
            }, $Command_initialize$1.$$arity = 1);
            return (Opal.def(self, '$eval', $Command_eval$2 = function(round_type) {
              var $$3, self = this, value = nil, output = nil;

              
              value = (function() { try {
                return self.expr.$eval(round_type).$to_i()
              } catch ($err) {
                if (Opal.rescue($err, [$$($nesting, 'ZeroDivisionError')])) {
                  try {
                    return "ゼロ除算が発生したため計算できませんでした"
                  } finally { Opal.pop_exception() }
                } else { throw $err; }
              }})();
              output = (function() {if ($truthy(self.expr['$is_a?']($$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Parenthesis')))) {
                return self.expr.$output()
              } else {
                return "" + "(" + (self.expr.$output()) + ")"
              }; return nil; })();
              return $send($$($nesting, 'Result').$new(), 'tap', [], ($$3 = function(r){var self = $$3.$$s == null ? this : $$3.$$s, $writer = nil;
                if (self.secret == null) self.secret = nil;

              
                
                if (r == null) {
                  r = nil;
                };
                
                $writer = [self.secret];
                $send(r, 'secret=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];;
                
                $writer = ["" + "c" + (output) + " ＞ " + (value)];
                $send(r, 'text=', Opal.to_a($writer));
                return $writer[$rb_minus($writer["length"], 1)];;}, $$3.$$s = self, $$3.$$arity = 1, $$3));
            }, $Command_eval$2.$$arity = 1), nil) && 'eval';
          })($nesting[0], null, $nesting)
        })($nesting[0], $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/calc/parser"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash = Opal.hash, $hash2 = Opal.hash2;

  
  self.$require("racc/parser.rb");
  self.$require("bcdice/common_command/lexer");
  self.$require("bcdice/common_command/calc/node");
  self.$require("bcdice/arithmetic/node");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'Calc');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Parser');

          var $nesting = [self].concat($parent_nesting), $Parser_parse$1, $Parser_parse$2, $Parser_next_token$3, $Parser__reduce_1$4, $Parser__reduce_2$5, $Parser__reduce_3$6, $Parser__reduce_4$7, $Parser__reduce_5$8, $Parser__reduce_7$9, $Parser__reduce_8$10, $Parser__reduce_10$11, $Parser__reduce_11$12, $Parser__reduce_12$13, $Parser__reduce_13$14, $Parser__reduce_14$15, $Parser__reduce_15$16, $Parser__reduce_16$17, $Parser__reduce_18$18, $Parser__reduce_19$19, $Parser__reduce_none$20, racc_action_table = nil, racc_action_check = nil, racc_action_pointer = nil, racc_action_default = nil, racc_goto_table = nil, racc_goto_check = nil, racc_goto_pointer = nil, racc_goto_default = nil, racc_reduce_table = nil, racc_reduce_n = nil, racc_shift_n = nil, racc_token_table = nil, racc_nt_base = nil, racc_use_result_var = nil;

          self.$$prototype.lexer = nil;
          
          Opal.defs(self, '$parse', $Parser_parse$1 = function $$parse(source) {
            var self = this;

            return self.$new().$parse(source)
          }, $Parser_parse$1.$$arity = 1);
          
          Opal.def(self, '$parse', $Parser_parse$2 = function $$parse(source) {
            var self = this;

            try {
              
              self.lexer = $$($nesting, 'Lexer').$new(source);
              return self.$do_parse();
            } catch ($err) {
              if (Opal.rescue($err, [$$($nesting, 'ParseError')])) {
                try {
                  return nil
                } finally { Opal.pop_exception() }
              } else { throw $err; }
            }
          }, $Parser_parse$2.$$arity = 1);
          self.$private();
          
          Opal.def(self, '$next_token', $Parser_next_token$3 = function $$next_token() {
            var self = this;

            return self.lexer.$next_token()
          }, $Parser_next_token$3.$$arity = 0);
          racc_action_table = [14, 3, 14, 15, 16, 4, 10, 11, 10, 11, 13, 14, 13, 14, 17, 18, 5, 10, 11, 10, 11, 13, 14, 13, 14, 17, 18, 6, 10, 11, 10, 11, 13, 14, 13, 14, 17, 18, nil, 10, 11, 10, 11, 13, nil, 13, 15, 16, nil, nil, nil, 26, 30, 28, 29, 31];
          racc_action_check = [5, 0, 10, 7, 7, 1, 5, 5, 10, 10, 5, 11, 10, 13, 8, 8, 2, 11, 11, 13, 13, 11, 15, 13, 16, 22, 22, 4, 15, 15, 16, 16, 15, 17, 16, 18, 23, 23, nil, 17, 17, 18, 18, 17, nil, 18, 21, 21, nil, nil, nil, 21, 25, 25, 25, 25];
          racc_action_pointer = [-6, 5, 11, nil, 27, -2, nil, -5, 4, nil, 0, 9, nil, 11, nil, 20, 22, 31, 33, nil, nil, 38, 15, 26, nil, 49, nil, nil, nil, nil, nil, nil];
          racc_action_default = [-2, -20, -20, -3, -20, -20, 32, -1, -6, -9, -20, -20, -17, -20, -19, -20, -20, -20, -20, -15, -16, -20, -4, -5, -7, -10, -18, -8, -11, -12, -13, -14];
          racc_goto_table = [7, 1, 19, 20, 22, 23, 2, 27, 21, 24, 25];
          racc_goto_check = [3, 1, 5, 5, 4, 4, 2, 6, 3, 5, 5];
          racc_goto_pointer = [nil, 1, 6, -5, -11, -8, -18, nil];
          racc_goto_default = [nil, nil, nil, nil, 8, 9, nil, 12];
          racc_reduce_table = [0, 0, "racc_error", 3, 15, "_reduce_1", 0, 16, "_reduce_2", 1, 16, "_reduce_3", 3, 17, "_reduce_4", 3, 17, "_reduce_5", 1, 17, "_reduce_none", 3, 18, "_reduce_7", 4, 18, "_reduce_8", 1, 18, "_reduce_none", 0, 20, "_reduce_10", 1, 20, "_reduce_11", 1, 20, "_reduce_12", 1, 20, "_reduce_13", 1, 20, "_reduce_14", 2, 19, "_reduce_15", 2, 19, "_reduce_16", 1, 19, "_reduce_none", 3, 21, "_reduce_18", 1, 21, "_reduce_19"];
          racc_reduce_n = 20;
          racc_shift_n = 32;
          racc_token_table = $hash(false, 0, "error", 1, "NUMBER", 2, "R", 3, "U", 4, "C", 5, "F", 6, "S", 7, "PLUS", 8, "MINUS", 9, "ASTERISK", 10, "SLASH", 11, "PARENL", 12, "PARENR", 13);
          racc_nt_base = 14;
          racc_use_result_var = true;
          Opal.const_set($nesting[0], 'Racc_arg', [racc_action_table, racc_action_check, racc_action_default, racc_action_pointer, racc_goto_table, racc_goto_check, racc_goto_default, racc_goto_pointer, racc_nt_base, racc_reduce_table, racc_token_table, racc_shift_n, racc_reduce_n, racc_use_result_var]);
          Opal.const_set($nesting[0], 'Racc_token_to_s_table', ["$end", "error", "NUMBER", "R", "U", "C", "F", "S", "PLUS", "MINUS", "ASTERISK", "SLASH", "PARENL", "PARENR", "$start", "expr", "secret", "add", "mul", "unary", "round_type", "term"]);
          Opal.const_set($nesting[0], 'Racc_debug_parser', false);
          
          Opal.def(self, '$_reduce_1', $Parser__reduce_1$4 = function $$_reduce_1(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'Command').$new($hash2(["secret", "expr"], {"secret": val['$[]'](0), "expr": val['$[]'](2)}));
            return result;
          }, $Parser__reduce_1$4.$$arity = 3);
          
          Opal.def(self, '$_reduce_2', $Parser__reduce_2$5 = function $$_reduce_2(val, _values, result) {
            var self = this;

            
            result = false;
            return result;
          }, $Parser__reduce_2$5.$$arity = 3);
          
          Opal.def(self, '$_reduce_3', $Parser__reduce_3$6 = function $$_reduce_3(val, _values, result) {
            var self = this;

            
            result = true;
            return result;
          }, $Parser__reduce_3$6.$$arity = 3);
          
          Opal.def(self, '$_reduce_4', $Parser__reduce_4$7 = function $$_reduce_4(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "+", val['$[]'](2));
            return result;
          }, $Parser__reduce_4$7.$$arity = 3);
          
          Opal.def(self, '$_reduce_5', $Parser__reduce_5$8 = function $$_reduce_5(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "-", val['$[]'](2));
            return result;
          }, $Parser__reduce_5$8.$$arity = 3);
          
          Opal.def(self, '$_reduce_7', $Parser__reduce_7$9 = function $$_reduce_7(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "*", val['$[]'](2));
            return result;
          }, $Parser__reduce_7$9.$$arity = 3);
          
          Opal.def(self, '$_reduce_8', $Parser__reduce_8$10 = function $$_reduce_8(val, _values, result) {
            var self = this, divied_class = nil;

            
            divied_class = val['$[]'](3);
            result = divied_class.$new(val['$[]'](0), val['$[]'](2));
            return result;
          }, $Parser__reduce_8$10.$$arity = 3);
          
          Opal.def(self, '$_reduce_10', $Parser__reduce_10$11 = function $$_reduce_10(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithGameSystemDefault');
            return result;
          }, $Parser__reduce_10$11.$$arity = 3);
          
          Opal.def(self, '$_reduce_11', $Parser__reduce_11$12 = function $$_reduce_11(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
            return result;
          }, $Parser__reduce_11$12.$$arity = 3);
          
          Opal.def(self, '$_reduce_12', $Parser__reduce_12$13 = function $$_reduce_12(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
            return result;
          }, $Parser__reduce_12$13.$$arity = 3);
          
          Opal.def(self, '$_reduce_13', $Parser__reduce_13$14 = function $$_reduce_13(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithRound');
            return result;
          }, $Parser__reduce_13$14.$$arity = 3);
          
          Opal.def(self, '$_reduce_14', $Parser__reduce_14$15 = function $$_reduce_14(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithFloor');
            return result;
          }, $Parser__reduce_14$15.$$arity = 3);
          
          Opal.def(self, '$_reduce_15', $Parser__reduce_15$16 = function $$_reduce_15(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_15$16.$$arity = 3);
          
          Opal.def(self, '$_reduce_16', $Parser__reduce_16$17 = function $$_reduce_16(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Negative').$new(val['$[]'](1));
            return result;
          }, $Parser__reduce_16$17.$$arity = 3);
          
          Opal.def(self, '$_reduce_18', $Parser__reduce_18$18 = function $$_reduce_18(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Parenthesis').$new(val['$[]'](1));
            return result;
          }, $Parser__reduce_18$18.$$arity = 3);
          
          Opal.def(self, '$_reduce_19', $Parser__reduce_19$19 = function $$_reduce_19(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Number').$new(val['$[]'](0));
            return result;
          }, $Parser__reduce_19$19.$$arity = 3);
          return (Opal.def(self, '$_reduce_none', $Parser__reduce_none$20 = function $$_reduce_none(val, _values, result) {
            var self = this;

            return val['$[]'](0)
          }, $Parser__reduce_none$20.$$arity = 3), nil) && '_reduce_none';
        })($nesting[0], $$$($$($nesting, 'Racc'), 'Parser'), $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/calc"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $send = Opal.send;

  
  self.$require("bcdice/common_command/calc/parser");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'Calc');

        var $nesting = [self].concat($parent_nesting);

        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /C[+\-(]*\d+/.$freeze());
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1;

          return (Opal.def(self, '$eval', $eval$1 = function(command, game_system, _randomizer) {
            var $a, self = this, cmd = nil;

            
            cmd = $$($nesting, 'Parser').$parse(command);
            return ($a = cmd, ($a === nil || $a == null) ? nil : $send($a, 'eval', [game_system.$round_type()]));
          }, $eval$1.$$arity = 3), nil) && 'eval'
        })(Opal.get_singleton_class(self), $nesting);
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/choice"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash2 = Opal.hash2, $send = Opal.send, $truthy = Opal.truthy;

  
  self.$require("strscan");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $super, $parent_nesting) {
        var self = $klass($base, $super, 'Choice');

        var $nesting = [self].concat($parent_nesting), $Choice_initialize$3, $Choice_roll$4, $Choice_expr$6;

        self.$$prototype.items = self.$$prototype.block_delimiter = nil;
        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /choice/.$freeze());
        (function($base, $parent_nesting) {
          var self = $module($base, 'BlockDelimiter');

          var $nesting = [self].concat($parent_nesting);

          
          Opal.const_set($nesting[0], 'BRACKET', "bracket");
          Opal.const_set($nesting[0], 'PAREN', "paren");
          Opal.const_set($nesting[0], 'SPACE', "space");
        })($nesting[0], $nesting);
        Opal.const_set($nesting[0], 'DELIMITER', $hash2(["bracket", "paren", "space"], {"bracket": /,/, "paren": /,/, "space": /\s+/}).$freeze());
        Opal.const_set($nesting[0], 'TERMINATION', $hash2(["bracket", "paren", "space"], {"bracket": /\]/, "paren": /\)/, "space": /$/}).$freeze());
        Opal.const_set($nesting[0], 'SUFFIX', $hash2(["bracket", "paren", "space"], {"bracket": "]", "paren": ")", "space": ""}).$freeze());
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1, $parse$2;

          
          
          Opal.def(self, '$eval', $eval$1 = function(command, _game_system, randomizer) {
            var $a, self = this, cmd = nil;

            
            cmd = self.$parse(command);
            return ($a = cmd, ($a === nil || $a == null) ? nil : $send($a, 'roll', [randomizer]));
          }, $eval$1.$$arity = 3);
          self.$private();
          return (Opal.def(self, '$parse', $parse$2 = function $$parse(command) {
            var $a, self = this, scanner = nil, secret = nil, type = nil, $case = nil, delimiter = nil, termination = nil, items = nil, item = nil, last_item = nil;

            
            scanner = $$($nesting, 'StringScanner').$new(command);
            scanner.$skip(/\s+/);
            secret = scanner.$scan(/S/i)['$nil?']()['$!']();
            if ($truthy(scanner.$scan(/choice/i))) {
            } else {
              return nil
            };
            type = (function() {$case = scanner.$scan(/\(|\[|\s+/);
            if ("["['$===']($case)) {return $$$($$($nesting, 'BlockDelimiter'), 'BRACKET')}
            else if ("("['$===']($case)) {return $$$($$($nesting, 'BlockDelimiter'), 'PAREN')}
            else if ($$($nesting, 'String')['$===']($case)) {return $$$($$($nesting, 'BlockDelimiter'), 'SPACE')}
            else {return nil}})();
            delimiter = $$($nesting, 'DELIMITER')['$[]'](type);
            termination = $$($nesting, 'TERMINATION')['$[]'](type);
            items = [];
            while ($truthy((item = scanner.$scan_until(delimiter)))) {
              items.$push(item.$delete_suffix(","))
            };
            last_item = scanner.$scan_until(termination);
            if ($truthy(last_item)) {
            } else {
              return nil
            };
            items.$push(last_item.$delete_suffix($$($nesting, 'SUFFIX')['$[]'](type)));
            items = $send($send(items, 'map', [], "strip".$to_proc()), 'reject', [], "empty?".$to_proc());
            if ($truthy(items['$empty?']())) {
              return nil};
            return self.$new($hash2(["secret", "block_delimiter", "items"], {"secret": secret, "block_delimiter": type, "items": items}));
          }, $parse$2.$$arity = 1), nil) && 'parse';
        })(Opal.get_singleton_class(self), $nesting);
        
        Opal.def(self, '$initialize', $Choice_initialize$3 = function $$initialize($kwargs) {
          var secret, block_delimiter, items, self = this;

          
          
          if ($kwargs == null) {
            $kwargs = $hash2([], {});
          } else if (!$kwargs.$$is_hash) {
            throw Opal.ArgumentError.$new('expected kwargs');
          };
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'secret')) {
            throw Opal.ArgumentError.$new('missing keyword: secret');
          }
          secret = $kwargs.$$smap["secret"];;
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'block_delimiter')) {
            throw Opal.ArgumentError.$new('missing keyword: block_delimiter');
          }
          block_delimiter = $kwargs.$$smap["block_delimiter"];;
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'items')) {
            throw Opal.ArgumentError.$new('missing keyword: items');
          }
          items = $kwargs.$$smap["items"];;
          self.secret = secret;
          self.block_delimiter = block_delimiter;
          return (self.items = items);
        }, $Choice_initialize$3.$$arity = 1);
        
        Opal.def(self, '$roll', $Choice_roll$4 = function $$roll(randomizer) {
          var $$5, self = this, index = nil, chosen = nil;

          
          index = randomizer.$roll_index(self.items.$size());
          chosen = self.items['$[]'](index);
          return $send($$($nesting, 'Result').$new(), 'tap', [], ($$5 = function(r){var self = $$5.$$s == null ? this : $$5.$$s, $writer = nil;
            if (self.secret == null) self.secret = nil;

          
            
            if (r == null) {
              r = nil;
            };
            
            $writer = [self.secret];
            $send(r, 'secret=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = ["" + "(" + (self.$expr()) + ") ＞ " + (chosen)];
            $send(r, 'text=', Opal.to_a($writer));
            return $writer[$rb_minus($writer["length"], 1)];;}, $$5.$$s = self, $$5.$$arity = 1, $$5));
        }, $Choice_roll$4.$$arity = 1);
        return (Opal.def(self, '$expr', $Choice_expr$6 = function $$expr() {
          var self = this, $case = nil;

          return (function() {$case = self.block_delimiter;
          if ($$$($$($nesting, 'BlockDelimiter'), 'SPACE')['$===']($case)) {return "" + "choice " + (self.items.$join(" "))}
          else if ($$$($$($nesting, 'BlockDelimiter'), 'BRACKET')['$===']($case)) {return "" + "choice[" + (self.items.$join(",")) + "]"}
          else if ($$$($$($nesting, 'BlockDelimiter'), 'PAREN')['$===']($case)) {return "" + "choice(" + (self.items.$join(",")) + ")"}
          else { return nil }})()
        }, $Choice_expr$6.$$arity = 0), nil) && 'expr';
      })($nesting[0], null, $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/d66_dice"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $hash2 = Opal.hash2;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $super, $parent_nesting) {
        var self = $klass($base, $super, 'D66Dice');

        var $nesting = [self].concat($parent_nesting), $D66Dice_initialize$4, $D66Dice_eval$5, $D66Dice_roll$7;

        self.$$prototype.sort_type = nil;
        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /D66/.$freeze());
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1, $parse$2, $sort_type_from_suffix$3;

          
          
          Opal.def(self, '$eval', $eval$1 = function(command, game_system, randomizer) {
            var $a, self = this, cmd = nil;

            
            cmd = self.$parse(command, game_system);
            return ($a = cmd, ($a === nil || $a == null) ? nil : $send($a, 'eval', [randomizer]));
          }, $eval$1.$$arity = 3);
          self.$private();
          
          Opal.def(self, '$parse', $parse$2 = function $$parse(command, game_system) {
            var self = this, m = nil, $ret_or_1 = nil;

            
            command = command.$split(" ", 2).$first();
            m = /^(S)?D66([ANSD])?$/i.$match(command);
            if ($truthy(m)) {
            } else {
              return nil
            };
            return self.$new($hash2(["secret", "sort_type", "suffix"], {"secret": m['$[]'](1)['$nil?']()['$!'](), "sort_type": (function() {if ($truthy(($ret_or_1 = self.$sort_type_from_suffix(m['$[]'](2))))) {
              return $ret_or_1
            } else {
              return game_system.$d66_sort_type()
            }; return nil; })(), "suffix": m['$[]'](2)}));
          }, $parse$2.$$arity = 2);
          return (Opal.def(self, '$sort_type_from_suffix', $sort_type_from_suffix$3 = function $$sort_type_from_suffix(suffix) {
            var self = this, $case = nil;

            return (function() {$case = suffix;
            if ("A"['$===']($case) || "S"['$===']($case)) {return $$$($$($nesting, 'D66SortType'), 'ASC')}
            else if ("D"['$===']($case)) {return $$$($$($nesting, 'D66SortType'), 'DESC')}
            else if ("N"['$===']($case)) {return $$$($$($nesting, 'D66SortType'), 'NO_SORT')}
            else { return nil }})()
          }, $sort_type_from_suffix$3.$$arity = 1), nil) && 'sort_type_from_suffix';
        })(Opal.get_singleton_class(self), $nesting);
        
        Opal.def(self, '$initialize', $D66Dice_initialize$4 = function $$initialize($kwargs) {
          var secret, sort_type, suffix, self = this;

          
          
          if ($kwargs == null) {
            $kwargs = $hash2([], {});
          } else if (!$kwargs.$$is_hash) {
            throw Opal.ArgumentError.$new('expected kwargs');
          };
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'secret')) {
            throw Opal.ArgumentError.$new('missing keyword: secret');
          }
          secret = $kwargs.$$smap["secret"];;
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'sort_type')) {
            throw Opal.ArgumentError.$new('missing keyword: sort_type');
          }
          sort_type = $kwargs.$$smap["sort_type"];;
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'suffix')) {
            throw Opal.ArgumentError.$new('missing keyword: suffix');
          }
          suffix = $kwargs.$$smap["suffix"];;
          self.secret = secret;
          self.sort_type = sort_type;
          return (self.suffix = suffix);
        }, $D66Dice_initialize$4.$$arity = 1);
        
        Opal.def(self, '$eval', $D66Dice_eval$5 = function(randomizer) {
          var $$6, self = this, value = nil;

          
          value = self.$roll(randomizer);
          return $send($$($nesting, 'Result').$new(), 'tap', [], ($$6 = function(r){var self = $$6.$$s == null ? this : $$6.$$s, $writer = nil;
            if (self.secret == null) self.secret = nil;
            if (self.suffix == null) self.suffix = nil;

          
            
            if (r == null) {
              r = nil;
            };
            
            $writer = [self.secret];
            $send(r, 'secret=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = ["" + "(D66" + (self.suffix) + ") ＞ " + (value)];
            $send(r, 'text=', Opal.to_a($writer));
            return $writer[$rb_minus($writer["length"], 1)];;}, $$6.$$s = self, $$6.$$arity = 1, $$6));
        }, $D66Dice_eval$5.$$arity = 1);
        self.$private();
        return (Opal.def(self, '$roll', $D66Dice_roll$7 = function $$roll(randomizer) {
          var $$8, self = this, dice_list = nil, $case = nil;

          
          dice_list = $send($$($nesting, 'Array'), 'new', [2], ($$8 = function(){var self = $$8.$$s == null ? this : $$8.$$s;

          return randomizer.$roll_once(6)}, $$8.$$s = self, $$8.$$arity = 0, $$8));
          $case = self.sort_type;
          if ($$$($$($nesting, 'D66SortType'), 'ASC')['$===']($case)) {dice_list['$sort!']()}
          else if ($$$($$($nesting, 'D66SortType'), 'DESC')['$===']($case)) {dice_list['$sort!']()['$reverse!']()};
          return $rb_plus($rb_times(dice_list['$[]'](0), 10), dice_list['$[]'](1));
        }, $D66Dice_roll$7.$$arity = 1), nil) && 'roll';
      })($nesting[0], null, $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/repeat"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $hash2 = Opal.hash2;

  
  self.$require("strscan");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $super, $parent_nesting) {
        var self = $klass($base, $super, 'Repeat');

        var $nesting = [self].concat($parent_nesting), $Repeat_initialize$3, $Repeat_roll$4, $Repeat_validate$9, $Repeat_result_with_text$10;

        self.$$prototype.times = self.$$prototype.trailer = self.$$prototype.secret = nil;
        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /(repeat|rep|x)\d+/.$freeze());
        Opal.const_set($nesting[0], 'REPEAT_LIMIT', 100);
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1, $parse$2;

          
          
          Opal.def(self, '$eval', $eval$1 = function(command, game_system, randomizer) {
            var $a, self = this, cmd = nil;

            
            cmd = self.$parse(command);
            return ($a = cmd, ($a === nil || $a == null) ? nil : $send($a, 'roll', [game_system, randomizer]));
          }, $eval$1.$$arity = 3);
          self.$private();
          return (Opal.def(self, '$parse', $parse$2 = function $$parse(command) {
            var $a, self = this, scanner = nil, secret = nil, keyword = nil, repeat_times = nil, whitespace = nil, $ret_or_1 = nil, $ret_or_2 = nil, trailer = nil, $ret_or_3 = nil;

            
            scanner = $$($nesting, 'StringScanner').$new(command);
            secret = scanner.$scan(/s/i)['$nil?']()['$!']();
            keyword = scanner.$scan(/repeat|rep|x/i);
            repeat_times = ($a = scanner.$scan(/\d+/), ($a === nil || $a == null) ? nil : $send($a, 'to_i', []));
            whitespace = scanner.$scan(/\s+/);
            if ($truthy((function() {if ($truthy(($ret_or_1 = (function() {if ($truthy(($ret_or_2 = keyword['$nil?']()))) {
              return $ret_or_2
            } else {
              return repeat_times['$nil?']()
            }; return nil; })()))) {
              return $ret_or_1
            } else {
              return whitespace['$nil?']()
            }; return nil; })())) {
              return nil};
            trailer = scanner.$post_match();
            if ($truthy((function() {if ($truthy(($ret_or_3 = trailer['$nil?']()))) {
              return $ret_or_3
            } else {
              return trailer['$empty?']()
            }; return nil; })())) {
              return nil};
            return self.$new($hash2(["secret", "times", "trailer"], {"secret": secret, "times": repeat_times, "trailer": trailer}));
          }, $parse$2.$$arity = 1), nil) && 'parse';
        })(Opal.get_singleton_class(self), $nesting);
        
        Opal.def(self, '$initialize', $Repeat_initialize$3 = function $$initialize($kwargs) {
          var secret, times, trailer, self = this;

          
          
          if ($kwargs == null) {
            $kwargs = $hash2([], {});
          } else if (!$kwargs.$$is_hash) {
            throw Opal.ArgumentError.$new('expected kwargs');
          };
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'secret')) {
            throw Opal.ArgumentError.$new('missing keyword: secret');
          }
          secret = $kwargs.$$smap["secret"];;
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'times')) {
            throw Opal.ArgumentError.$new('missing keyword: times');
          }
          times = $kwargs.$$smap["times"];;
          
          if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'trailer')) {
            throw Opal.ArgumentError.$new('missing keyword: trailer');
          }
          trailer = $kwargs.$$smap["trailer"];;
          self.secret = secret;
          self.times = times;
          return (self.trailer = trailer);
        }, $Repeat_initialize$3.$$arity = 1);
        
        Opal.def(self, '$roll', $Repeat_roll$4 = function $$roll(game_system, randomizer) {
          var $$5, $$6, $$7, $$8, self = this, err = nil, results = nil, text = nil, secret = nil, $ret_or_4 = nil;

          
          err = self.$validate();
          if ($truthy(err)) {
            return err};
          results = $send($$($nesting, 'Array'), 'new', [self.times], ($$5 = function(){var self = $$5.$$s == null ? this : $$5.$$s, cmd = nil, $writer = nil;
            if (self.trailer == null) self.trailer = nil;

          
            cmd = game_system.$class().$new(self.trailer);
            
            $writer = [randomizer];
            $send(cmd, 'randomizer=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            return cmd.$eval();}, $$5.$$s = self, $$5.$$arity = 0, $$5));
          if ($send(results, 'count', [], ($$6 = function(i){var self = $$6.$$s == null ? this : $$6.$$s;

          
            
            if (i == null) {
              i = nil;
            };
            return i['$=='](nil);}, $$6.$$s = self, $$6.$$arity = 1, $$6))['$=='](self.times)) {
            return self.$result_with_text("" + "繰り返し対象のコマンドが実行できませんでした (" + (self.trailer) + ")")};
          text = $send(results.$map(), 'with_index', [1], ($$7 = function(r, index){var self = $$7.$$s == null ? this : $$7.$$s;

          
            
            if (r == null) {
              r = nil;
            };
            
            if (index == null) {
              index = nil;
            };
            return "" + "#" + (index) + "\n" + (r.$text());}, $$7.$$s = self, $$7.$$arity = 2, $$7)).$join("\n\n");
          secret = (function() {if ($truthy(($ret_or_4 = self.secret))) {
            return $ret_or_4
          } else {
            return $send(results, 'any?', [], "secret?".$to_proc())
          }; return nil; })();
          return $send($$($nesting, 'Result').$new(), 'tap', [], ($$8 = function(r){var self = $$8.$$s == null ? this : $$8.$$s, $writer = nil;

          
            
            if (r == null) {
              r = nil;
            };
            
            $writer = [secret];
            $send(r, 'secret=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = [text];
            $send(r, 'text=', Opal.to_a($writer));
            return $writer[$rb_minus($writer["length"], 1)];;}, $$8.$$s = self, $$8.$$arity = 1, $$8));
        }, $Repeat_roll$4.$$arity = 2);
        self.$private();
        
        Opal.def(self, '$validate', $Repeat_validate$9 = function $$validate() {
          var self = this, $ret_or_5 = nil;

          if ($truthy(/^(repeat|rep|x)\d+/['$match?'](self.trailer))) {
            return self.$result_with_text("Repeatコマンドの重複はできません")
          } else if ($truthy((function() {if ($truthy(($ret_or_5 = $rb_lt(self.times, 1)))) {
            return $ret_or_5
          } else {
            return $rb_lt($$($nesting, 'REPEAT_LIMIT'), self.times)
          }; return nil; })())) {
            return self.$result_with_text("" + "繰り返し回数は1以上、" + ($$($nesting, 'REPEAT_LIMIT')) + "以下としてください")
          } else {
            return nil
          }
        }, $Repeat_validate$9.$$arity = 0);
        return (Opal.def(self, '$result_with_text', $Repeat_result_with_text$10 = function $$result_with_text(text) {
          var $$11, self = this;

          return $send($$($nesting, 'Result').$new(), 'tap', [], ($$11 = function(r){var self = $$11.$$s == null ? this : $$11.$$s, $writer = nil;
            if (self.secret == null) self.secret = nil;

          
            
            if (r == null) {
              r = nil;
            };
            
            $writer = [self.secret];
            $send(r, 'secret=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = [text];
            $send(r, 'text=', Opal.to_a($writer));
            return $writer[$rb_minus($writer["length"], 1)];;}, $$11.$$s = self, $$11.$$arity = 1, $$11))
        }, $Repeat_result_with_text$10.$$arity = 1), nil) && 'result_with_text';
      })($nesting[0], null, $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/format"] = function(Opal) {
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $truthy = Opal.truthy;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'Format');

      var $nesting = [self].concat($parent_nesting), $Format_comparison_operator$1, $Format_modifier$2;

      
      self.$module_function();
      
      Opal.def(self, '$comparison_operator', $Format_comparison_operator$1 = function $$comparison_operator(op) {
        var self = this, $case = nil;

        return (function() {$case = op;
        if ("=="['$===']($case)) {return "="}
        else if ("!="['$===']($case)) {return "<>"}
        else if ($$($nesting, 'Symbol')['$===']($case)) {return op.$to_s()}
        else { return nil }})()
      }, $Format_comparison_operator$1.$$arity = 1);
      
      Opal.def(self, '$modifier', $Format_modifier$2 = function $$modifier(number) {
        var self = this;

        if ($truthy(number['$nil?']())) {
          return nil
        } else if (number['$=='](0)) {
          return ""
        } else if ($truthy($rb_gt(number, 0))) {
          return "" + "+" + (number)
        } else {
          return number.$to_s()
        }
      }, $Format_modifier$2.$$arity = 1);
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/result"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send = Opal.send;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $super, $parent_nesting) {
      var self = $klass($base, $super, 'Result');

      var $nesting = [self].concat($parent_nesting), $Result_initialize$10, $Result_secret$ques$11, $Result_success$ques$12, $Result_failure$ques$13, $Result_critical$ques$14, $Result_fumble$ques$15, $Result_condition$eq$16;

      self.$$prototype.secret = self.$$prototype.success = self.$$prototype.failure = self.$$prototype.critical = self.$$prototype.fumble = nil;
      
      (function(self, $parent_nesting) {
        var $nesting = [self].concat($parent_nesting), $success$1, $failure$3, $critical$5, $fumble$7, $nothing$9;

        
        
        Opal.def(self, '$success', $success$1 = function $$success(text) {
          var $$2, self = this;

          return $send(self.$new(), 'tap', [], ($$2 = function(r){var self = $$2.$$s == null ? this : $$2.$$s, $writer = nil;

          
            
            if (r == null) {
              r = nil;
            };
            
            $writer = [text];
            $send(r, 'text=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = [true];
            $send(r, 'success=', Opal.to_a($writer));
            return $writer[$rb_minus($writer["length"], 1)];;}, $$2.$$s = self, $$2.$$arity = 1, $$2))
        }, $success$1.$$arity = 1);
        
        Opal.def(self, '$failure', $failure$3 = function $$failure(text) {
          var $$4, self = this;

          return $send(self.$new(), 'tap', [], ($$4 = function(r){var self = $$4.$$s == null ? this : $$4.$$s, $writer = nil;

          
            
            if (r == null) {
              r = nil;
            };
            
            $writer = [text];
            $send(r, 'text=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = [true];
            $send(r, 'failure=', Opal.to_a($writer));
            return $writer[$rb_minus($writer["length"], 1)];;}, $$4.$$s = self, $$4.$$arity = 1, $$4))
        }, $failure$3.$$arity = 1);
        
        Opal.def(self, '$critical', $critical$5 = function $$critical(text) {
          var $$6, self = this;

          return $send(self.$new(), 'tap', [], ($$6 = function(r){var self = $$6.$$s == null ? this : $$6.$$s, $writer = nil;

          
            
            if (r == null) {
              r = nil;
            };
            
            $writer = [text];
            $send(r, 'text=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = [true];
            $send(r, 'critical=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = [true];
            $send(r, 'success=', Opal.to_a($writer));
            return $writer[$rb_minus($writer["length"], 1)];;}, $$6.$$s = self, $$6.$$arity = 1, $$6))
        }, $critical$5.$$arity = 1);
        
        Opal.def(self, '$fumble', $fumble$7 = function $$fumble(text) {
          var $$8, self = this;

          return $send(self.$new(), 'tap', [], ($$8 = function(r){var self = $$8.$$s == null ? this : $$8.$$s, $writer = nil;

          
            
            if (r == null) {
              r = nil;
            };
            
            $writer = [text];
            $send(r, 'text=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = [true];
            $send(r, 'fumble=', Opal.to_a($writer));
            $writer[$rb_minus($writer["length"], 1)];;
            
            $writer = [true];
            $send(r, 'failure=', Opal.to_a($writer));
            return $writer[$rb_minus($writer["length"], 1)];;}, $$8.$$s = self, $$8.$$arity = 1, $$8))
        }, $fumble$7.$$arity = 1);
        return (Opal.def(self, '$nothing', $nothing$9 = function $$nothing() {
          var self = this;

          return "nothing"
        }, $nothing$9.$$arity = 0), nil) && 'nothing';
      })(Opal.get_singleton_class(self), $nesting);
      
      Opal.def(self, '$initialize', $Result_initialize$10 = function $$initialize(text) {
        var self = this;

        
        
        if (text == null) {
          text = nil;
        };
        self.text = text;
        self.rands = nil;
        self.detailed_rands = nil;
        self.secret = false;
        self.success = false;
        self.failure = false;
        self.critical = false;
        return (self.fumble = false);
      }, $Result_initialize$10.$$arity = -1);
      self.$attr_accessor("text", "rands", "detailed_rands");
      self.$attr_writer("secret", "success", "failure", "critical", "fumble");
      
      Opal.def(self, '$secret?', $Result_secret$ques$11 = function() {
        var self = this;

        return self.secret
      }, $Result_secret$ques$11.$$arity = 0);
      
      Opal.def(self, '$success?', $Result_success$ques$12 = function() {
        var self = this;

        return self.success
      }, $Result_success$ques$12.$$arity = 0);
      
      Opal.def(self, '$failure?', $Result_failure$ques$13 = function() {
        var self = this;

        return self.failure
      }, $Result_failure$ques$13.$$arity = 0);
      
      Opal.def(self, '$critical?', $Result_critical$ques$14 = function() {
        var self = this;

        return self.critical
      }, $Result_critical$ques$14.$$arity = 0);
      
      Opal.def(self, '$fumble?', $Result_fumble$ques$15 = function() {
        var self = this;

        return self.fumble
      }, $Result_fumble$ques$15.$$arity = 0);
      return (Opal.def(self, '$condition=', $Result_condition$eq$16 = function(condition) {
        var self = this;

        
        self.success = condition;
        return (self.failure = condition['$!']());
      }, $Result_condition$eq$16.$$arity = 1), nil) && 'condition=';
    })($nesting[0], null, $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/barabara_dice/result"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $send2 = Opal.send2;

  
  self.$require("bcdice/result");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'BarabaraDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Result');

          var $nesting = [self].concat($parent_nesting), $Result_initialize$1;

          
          self.$attr_accessor("success_num");
          return (Opal.def(self, '$initialize', $Result_initialize$1 = function $$initialize(text) {
            var $iter = $Result_initialize$1.$$p, $yield = $iter || nil, self = this;

            if ($iter) $Result_initialize$1.$$p = null;
            
            
            if (text == null) {
              text = nil;
            };
            $send2(self, Opal.find_super_dispatcher(self, 'initialize', $Result_initialize$1, false, true), 'initialize', [text], null);
            return (self.success_num = 0);
          }, $Result_initialize$1.$$arity = -1), nil) && 'initialize';
        })($nesting[0], $$$($$$('::', 'BCDice'), 'Result'), $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/barabara_dice/node"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash2 = Opal.hash2, $send = Opal.send, $truthy = Opal.truthy;

  
  self.$require("bcdice/format");
  self.$require("bcdice/common_command/barabara_dice/result");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'BarabaraDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $parent_nesting) {
          var self = $module($base, 'Node');

          var $nesting = [self].concat($parent_nesting);

          
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Command');

            var $nesting = [self].concat($parent_nesting), $Command_initialize$1, $Command_eval$2;

            self.$$prototype.notations = self.$$prototype.cmp_op = self.$$prototype.target_number = nil;
            
            
            Opal.def(self, '$initialize', $Command_initialize$1 = function $$initialize($kwargs) {
              var secret, notations, cmp_op, target_number, self = this;

              
              
              if ($kwargs == null) {
                $kwargs = $hash2([], {});
              } else if (!$kwargs.$$is_hash) {
                throw Opal.ArgumentError.$new('expected kwargs');
              };
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'secret')) {
                throw Opal.ArgumentError.$new('missing keyword: secret');
              }
              secret = $kwargs.$$smap["secret"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'notations')) {
                throw Opal.ArgumentError.$new('missing keyword: notations');
              }
              notations = $kwargs.$$smap["notations"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'cmp_op')) {
                throw Opal.ArgumentError.$new('missing keyword: cmp_op');
              }
              cmp_op = $kwargs.$$smap["cmp_op"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'target_number')) {
                throw Opal.ArgumentError.$new('missing keyword: target_number');
              }
              target_number = $kwargs.$$smap["target_number"];;
              self.secret = secret;
              self.notations = notations;
              self.cmp_op = cmp_op;
              return (self.target_number = target_number);
            }, $Command_initialize$1.$$arity = 1);
            return (Opal.def(self, '$eval', $Command_eval$2 = function(game_system, randomizer) {
              var $$3, $a, $$4, $$5, $$6, self = this, round_type = nil, notations = nil, cmp_op = nil, $ret_or_1 = nil, target_number = nil, $ret_or_2 = nil, dice_list_list = nil, dice_list = nil, count_of_1 = nil, success_num = nil, success_num_text = nil, sequence = nil;

              
              round_type = game_system.$round_type();
              notations = $send(self.notations, 'map', [], ($$3 = function(n){var self = $$3.$$s == null ? this : $$3.$$s;

              
                
                if (n == null) {
                  n = nil;
                };
                return n.$to_dice(round_type);}, $$3.$$s = self, $$3.$$arity = 1, $$3));
              cmp_op = (function() {if ($truthy(($ret_or_1 = self.cmp_op))) {
                return $ret_or_1
              } else {
                return game_system.$default_cmp_op()
              }; return nil; })();
              target_number = (function() {if ($truthy(($ret_or_2 = ($a = self.target_number, ($a === nil || $a == null) ? nil : $send($a, 'eval', [round_type]))))) {
                return $ret_or_2
              } else {
                return game_system.$default_target_number()
              }; return nil; })();
              dice_list_list = $send(notations, 'map', [], ($$4 = function(d){var self = $$4.$$s == null ? this : $$4.$$s;

              
                
                if (d == null) {
                  d = nil;
                };
                return d.$roll(randomizer);}, $$4.$$s = self, $$4.$$arity = 1, $$4));
              if ($truthy(game_system['$sort_barabara_dice?']())) {
                $send(dice_list_list, 'map!', [], "sort".$to_proc())};
              dice_list = dice_list_list.$flatten();
              count_of_1 = dice_list.$count(1);
              success_num = (function() {if ($truthy(cmp_op)) {
                return $send(dice_list, 'count', [], ($$5 = function(d){var self = $$5.$$s == null ? this : $$5.$$s;

                
                  
                  if (d == null) {
                    d = nil;
                  };
                  return d.$send(cmp_op, target_number);}, $$5.$$s = self, $$5.$$arity = 1, $$5))
              } else {
                return 0
              }; return nil; })();
              if ($truthy(cmp_op)) {
                success_num_text = "" + "成功数" + (success_num)};
              sequence = ["" + "(" + (notations.$join("+")) + ($$($nesting, 'Format').$comparison_operator(cmp_op)) + (target_number) + ")", dice_list.$join(","), success_num_text, game_system.$grich_text(count_of_1, dice_list.$size(), success_num)].$compact();
              return $send($$($nesting, 'Result').$new(), 'tap', [], ($$6 = function(r){var self = $$6.$$s == null ? this : $$6.$$s, $writer = nil;
                if (self.secret == null) self.secret = nil;

              
                
                if (r == null) {
                  r = nil;
                };
                
                $writer = [self.secret];
                $send(r, 'secret=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];;
                
                $writer = [sequence.$join(" ＞ ")];
                $send(r, 'text=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];;
                
                $writer = [randomizer.$rand_results()];
                $send(r, 'rands=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];;
                
                $writer = [randomizer.$detailed_rand_results()];
                $send(r, 'detailed_rands=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];;
                
                $writer = [success_num];
                $send(r, 'success_num=', Opal.to_a($writer));
                return $writer[$rb_minus($writer["length"], 1)];;}, $$6.$$s = self, $$6.$$arity = 1, $$6));
            }, $Command_eval$2.$$arity = 2), nil) && 'eval';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Notation');

            var $nesting = [self].concat($parent_nesting), $Notation_initialize$7, $Notation_to_dice$8;

            self.$$prototype.times = self.$$prototype.sides = nil;
            
            
            Opal.def(self, '$initialize', $Notation_initialize$7 = function $$initialize(times, sides) {
              var self = this;

              
              self.times = times;
              return (self.sides = sides);
            }, $Notation_initialize$7.$$arity = 2);
            return (Opal.def(self, '$to_dice', $Notation_to_dice$8 = function $$to_dice(round_type) {
              var self = this, times = nil, sides = nil;

              
              times = self.times.$eval(round_type);
              sides = self.sides.$eval(round_type);
              return $$($nesting, 'Dice').$new(times, sides);
            }, $Notation_to_dice$8.$$arity = 1), nil) && 'to_dice';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Dice');

            var $nesting = [self].concat($parent_nesting), $Dice_initialize$9, $Dice_roll$10, $Dice_to_s$11;

            self.$$prototype.times = self.$$prototype.sides = nil;
            
            
            Opal.def(self, '$initialize', $Dice_initialize$9 = function $$initialize(times, sides) {
              var self = this;

              
              self.times = times;
              return (self.sides = sides);
            }, $Dice_initialize$9.$$arity = 2);
            
            Opal.def(self, '$roll', $Dice_roll$10 = function $$roll(randomizer) {
              var self = this;

              return randomizer.$roll_barabara(self.times, self.sides)
            }, $Dice_roll$10.$$arity = 1);
            return (Opal.def(self, '$to_s', $Dice_to_s$11 = function $$to_s() {
              var self = this;

              return "" + (self.times) + "B" + (self.sides)
            }, $Dice_to_s$11.$$arity = 0), nil) && 'to_s';
          })($nesting[0], null, $nesting);
        })($nesting[0], $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/reroll_dice/parser"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash = Opal.hash, $hash2 = Opal.hash2, $truthy = Opal.truthy;

  
  self.$require("racc/parser.rb");
  self.$require("bcdice/common_command/lexer");
  self.$require("bcdice/common_command/barabara_dice/node");
  self.$require("bcdice/arithmetic/node");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'RerollDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Parser');

          var $nesting = [self].concat($parent_nesting), $Parser_parse$1, $Parser_parse$2, $Parser_next_token$3, $Parser__reduce_1$4, $Parser__reduce_2$5, $Parser__reduce_3$6, $Parser__reduce_4$7, $Parser__reduce_5$8, $Parser__reduce_6$9, $Parser__reduce_7$10, $Parser__reduce_8$11, $Parser__reduce_9$12, $Parser__reduce_10$13, $Parser__reduce_11$14, $Parser__reduce_12$15, $Parser__reduce_13$16, $Parser__reduce_14$17, $Parser__reduce_15$18, $Parser__reduce_16$19, $Parser__reduce_18$20, $Parser__reduce_19$21, $Parser__reduce_21$22, $Parser__reduce_22$23, $Parser__reduce_23$24, $Parser__reduce_24$25, $Parser__reduce_25$26, $Parser__reduce_26$27, $Parser__reduce_27$28, $Parser__reduce_29$29, $Parser__reduce_30$30, $Parser__reduce_none$31, racc_action_table = nil, racc_action_check = nil, racc_action_pointer = nil, racc_action_default = nil, racc_goto_table = nil, racc_goto_check = nil, racc_goto_pointer = nil, racc_goto_default = nil, racc_reduce_table = nil, racc_reduce_n = nil, racc_shift_n = nil, racc_token_table = nil, racc_nt_base = nil, racc_use_result_var = nil;

          self.$$prototype.lexer = nil;
          
          Opal.defs(self, '$parse', $Parser_parse$1 = function $$parse(source) {
            var self = this;

            return self.$new().$parse(source)
          }, $Parser_parse$1.$$arity = 1);
          
          Opal.def(self, '$parse', $Parser_parse$2 = function $$parse(source) {
            var self = this;

            try {
              
              self.lexer = $$($nesting, 'Lexer').$new(source);
              return self.$do_parse();
            } catch ($err) {
              if (Opal.rescue($err, [$$($nesting, 'ParseError')])) {
                try {
                  return nil
                } finally { Opal.pop_exception() }
              } else { throw $err; }
            }
          }, $Parser_parse$2.$$arity = 1);
          self.$private();
          
          Opal.def(self, '$next_token', $Parser_next_token$3 = function $$next_token() {
            var self = this;

            return self.lexer.$next_token()
          }, $Parser_next_token$3.$$arity = 0);
          racc_action_table = [9, 3, 9, 9, 9, 15, 20, 21, 20, 21, 8, 14, 8, 8, 8, 9, 9, 4, 13, 28, 10, 39, 20, 21, 9, 8, 8, 31, 32, 9, 20, 21, 33, 16, 8, 20, 21, 9, 24, 8, 34, 35, 9, 20, 21, 31, 32, 8, 20, 21, 9, 13, 8, 31, 32, 9, 20, 21, 34, 35, 8, 20, 21, 9, nil, 8, 34, 35, 9, 20, 21, 31, 32, 8, 20, 21, 9, nil, 8, nil, 31, 32, 20, 21, 31, 32, 8, 40, nil, nil, nil, 47, 51, 49, 50, 52];
          racc_action_check = [14, 0, 24, 2, 15, 5, 14, 14, 24, 24, 14, 5, 24, 2, 15, 16, 8, 1, 5, 14, 4, 24, 8, 8, 13, 16, 8, 17, 17, 20, 13, 13, 17, 7, 13, 20, 20, 21, 11, 20, 18, 18, 28, 21, 21, 26, 26, 21, 28, 28, 31, 12, 28, 38, 38, 32, 31, 31, 42, 42, 31, 32, 32, 34, nil, 32, 43, 43, 35, 34, 34, 46, 46, 34, 35, 35, 39, nil, 35, nil, 27, 27, 39, 39, 41, 41, 39, 27, nil, nil, nil, 41, 45, 45, 45, 45];
          racc_action_pointer = [-6, 17, 1, nil, 20, -3, nil, 30, 14, nil, nil, 18, 30, 22, -2, 2, 13, 19, 30, nil, 27, 35, nil, nil, 0, nil, 37, 72, 40, nil, nil, 48, 53, nil, 61, 66, nil, nil, 45, 74, nil, 76, 48, 56, nil, 89, 63, nil, nil, nil, nil, nil, nil];
          racc_action_default = [-4, -31, -31, -5, -31, -6, -13, -31, -31, -30, 53, -1, -6, -31, -31, -31, -31, -31, -17, -20, -31, -31, -28, -3, -31, -2, -7, -31, -31, -12, -14, -31, -31, -29, -31, -31, -26, -27, -10, -31, -8, -31, -15, -16, -18, -21, -11, -9, -19, -22, -23, -24, -25];
          racc_goto_table = [17, 7, 11, 36, 37, 26, 27, 1, 6, 25, 42, 43, 2, 5, 7, 30, 38, 44, 45, 12, 41, 29, 23, 48, nil, nil, nil, nil, nil, nil, nil, 46];
          racc_goto_check = [7, 9, 4, 11, 11, 7, 7, 1, 8, 4, 10, 10, 2, 3, 9, 9, 7, 11, 11, 5, 7, 8, 6, 12, nil, nil, nil, nil, nil, nil, nil, 7];
          racc_goto_pointer = [nil, 7, 12, 11, -3, 14, 11, -8, 6, -1, -21, -17, -22];
          racc_goto_default = [nil, nil, nil, nil, nil, nil, nil, nil, nil, 22, 18, 19, nil];
          racc_reduce_table = [0, 0, "racc_error", 3, 23, "_reduce_1", 4, 23, "_reduce_2", 4, 23, "_reduce_3", 0, 24, "_reduce_4", 1, 24, "_reduce_5", 0, 26, "_reduce_6", 2, 26, "_reduce_7", 3, 27, "_reduce_8", 4, 27, "_reduce_9", 2, 28, "_reduce_10", 3, 28, "_reduce_11", 3, 25, "_reduce_12", 1, 25, "_reduce_13", 3, 30, "_reduce_14", 3, 29, "_reduce_15", 3, 29, "_reduce_16", 1, 29, "_reduce_none", 3, 32, "_reduce_18", 4, 32, "_reduce_19", 1, 32, "_reduce_none", 0, 34, "_reduce_21", 1, 34, "_reduce_22", 1, 34, "_reduce_23", 1, 34, "_reduce_24", 1, 34, "_reduce_25", 2, 33, "_reduce_26", 2, 33, "_reduce_27", 1, 33, "_reduce_none", 3, 31, "_reduce_29", 1, 31, "_reduce_30"];
          racc_reduce_n = 31;
          racc_shift_n = 53;
          racc_token_table = $hash(false, 0, "error", 1, "NUMBER", 2, "R", 3, "U", 4, "C", 5, "F", 6, "S", 7, "PLUS", 8, "MINUS", 9, "ASTERISK", 10, "SLASH", 11, "PARENL", 12, "PARENR", 13, "BRACKETL", 14, "BRACKETR", 15, "LESS", 16, "GREATER", 17, "EQUAL", 18, "NOT", 19, "AT", 20, "CMP_OP", 21);
          racc_nt_base = 22;
          racc_use_result_var = true;
          Opal.const_set($nesting[0], 'Racc_arg', [racc_action_table, racc_action_check, racc_action_default, racc_action_pointer, racc_goto_table, racc_goto_check, racc_goto_default, racc_goto_pointer, racc_nt_base, racc_reduce_table, racc_token_table, racc_shift_n, racc_reduce_n, racc_use_result_var]);
          Opal.const_set($nesting[0], 'Racc_token_to_s_table', ["$end", "error", "NUMBER", "R", "U", "C", "F", "S", "PLUS", "MINUS", "ASTERISK", "SLASH", "PARENL", "PARENR", "BRACKETL", "BRACKETR", "LESS", "GREATER", "EQUAL", "NOT", "AT", "CMP_OP", "$start", "expr", "secret", "notations", "target", "bracket", "at", "add", "dice", "term", "mul", "unary", "round_type"]);
          Opal.const_set($nesting[0], 'Racc_debug_parser', false);
          
          Opal.def(self, '$_reduce_1', $Parser__reduce_1$4 = function $$_reduce_1(val, _values, result) {
            var self = this;

            
            result = $$$($$($nesting, 'Node'), 'Command').$new($hash2(["secret", "notations", "cmp_op", "target_number", "source"], {"secret": val['$[]'](0), "notations": val['$[]'](1), "cmp_op": val['$[]'](2)['$[]']("cmp_op"), "target_number": val['$[]'](2)['$[]']("target"), "source": self.lexer.$source()}));
            return result;
          }, $Parser__reduce_1$4.$$arity = 3);
          
          Opal.def(self, '$_reduce_2', $Parser__reduce_2$5 = function $$_reduce_2(val, _values, result) {
            var self = this, target = nil, threshold = nil;

            
            target = val['$[]'](3);
            threshold = val['$[]'](2);
            result = $$$($$($nesting, 'Node'), 'Command').$new($hash2(["secret", "notations", "cmp_op", "target_number", "reroll_cmp_op", "reroll_threshold", "source"], {"secret": val['$[]'](0), "notations": val['$[]'](1), "cmp_op": target['$[]']("cmp_op"), "target_number": target['$[]']("target"), "reroll_cmp_op": threshold['$[]']("cmp_op"), "reroll_threshold": threshold['$[]']("threshold"), "source": self.lexer.$source()}));
            return result;
          }, $Parser__reduce_2$5.$$arity = 3);
          
          Opal.def(self, '$_reduce_3', $Parser__reduce_3$6 = function $$_reduce_3(val, _values, result) {
            var self = this, target = nil, threshold = nil;

            
            target = val['$[]'](2);
            threshold = val['$[]'](3);
            result = $$$($$($nesting, 'Node'), 'Command').$new($hash2(["secret", "notations", "cmp_op", "target_number", "reroll_cmp_op", "reroll_threshold", "source"], {"secret": val['$[]'](0), "notations": val['$[]'](1), "cmp_op": target['$[]']("cmp_op"), "target_number": target['$[]']("target"), "reroll_cmp_op": threshold['$[]']("cmp_op"), "reroll_threshold": threshold['$[]']("threshold"), "source": self.lexer.$source()}));
            return result;
          }, $Parser__reduce_3$6.$$arity = 3);
          
          Opal.def(self, '$_reduce_4', $Parser__reduce_4$7 = function $$_reduce_4(val, _values, result) {
            var self = this;

            
            result = false;
            return result;
          }, $Parser__reduce_4$7.$$arity = 3);
          
          Opal.def(self, '$_reduce_5', $Parser__reduce_5$8 = function $$_reduce_5(val, _values, result) {
            var self = this;

            
            result = true;
            return result;
          }, $Parser__reduce_5$8.$$arity = 3);
          
          Opal.def(self, '$_reduce_6', $Parser__reduce_6$9 = function $$_reduce_6(val, _values, result) {
            var self = this;

            
            result = $hash2([], {});
            return result;
          }, $Parser__reduce_6$9.$$arity = 3);
          
          Opal.def(self, '$_reduce_7', $Parser__reduce_7$10 = function $$_reduce_7(val, _values, result) {
            var $a, $b, self = this, cmp_op = nil, target = nil;

            
            $b = val, $a = Opal.to_ary($b), (cmp_op = ($a[0] == null ? nil : $a[0])), (target = ($a[1] == null ? nil : $a[1])), $b;
            if ($truthy(cmp_op)) {
            } else {
              self.$raise($$($nesting, 'ParseError'))
            };
            result = $hash2(["cmp_op", "target"], {"cmp_op": cmp_op, "target": target});
            return result;
          }, $Parser__reduce_7$10.$$arity = 3);
          
          Opal.def(self, '$_reduce_8', $Parser__reduce_8$11 = function $$_reduce_8(val, _values, result) {
            var self = this;

            
            result = $hash2(["threshold"], {"threshold": val['$[]'](1)});
            return result;
          }, $Parser__reduce_8$11.$$arity = 3);
          
          Opal.def(self, '$_reduce_9', $Parser__reduce_9$12 = function $$_reduce_9(val, _values, result) {
            var self = this, cmp_op = nil, threshold = nil;

            
            cmp_op = val['$[]'](1);
            threshold = val['$[]'](2);
            if ($truthy(cmp_op)) {
            } else {
              self.$raise($$($nesting, 'ParseError'))
            };
            result = $hash2(["cmp_op", "threshold"], {"cmp_op": cmp_op, "threshold": threshold});
            return result;
          }, $Parser__reduce_9$12.$$arity = 3);
          
          Opal.def(self, '$_reduce_10', $Parser__reduce_10$13 = function $$_reduce_10(val, _values, result) {
            var self = this;

            
            result = $hash2(["threshold"], {"threshold": val['$[]'](1)});
            return result;
          }, $Parser__reduce_10$13.$$arity = 3);
          
          Opal.def(self, '$_reduce_11', $Parser__reduce_11$14 = function $$_reduce_11(val, _values, result) {
            var self = this, cmp_op = nil, threshold = nil;

            
            cmp_op = val['$[]'](1);
            threshold = val['$[]'](2);
            if ($truthy(cmp_op)) {
            } else {
              self.$raise($$($nesting, 'ParseError'))
            };
            result = $hash2(["cmp_op", "threshold"], {"cmp_op": cmp_op, "threshold": threshold});
            return result;
          }, $Parser__reduce_11$14.$$arity = 3);
          
          Opal.def(self, '$_reduce_12', $Parser__reduce_12$15 = function $$_reduce_12(val, _values, result) {
            var self = this, notations = nil;

            
            notations = val['$[]'](0);
            notations.$push(val['$[]'](2));
            result = notations;
            return result;
          }, $Parser__reduce_12$15.$$arity = 3);
          
          Opal.def(self, '$_reduce_13', $Parser__reduce_13$16 = function $$_reduce_13(val, _values, result) {
            var self = this;

            
            result = [val['$[]'](0)];
            return result;
          }, $Parser__reduce_13$16.$$arity = 3);
          
          Opal.def(self, '$_reduce_14', $Parser__reduce_14$17 = function $$_reduce_14(val, _values, result) {
            var self = this, times = nil, sides = nil;

            
            times = val['$[]'](0);
            sides = val['$[]'](2);
            result = $$$($$($nesting, 'Node'), 'Notation').$new(times, sides);
            return result;
          }, $Parser__reduce_14$17.$$arity = 3);
          
          Opal.def(self, '$_reduce_15', $Parser__reduce_15$18 = function $$_reduce_15(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "+", val['$[]'](2));
            return result;
          }, $Parser__reduce_15$18.$$arity = 3);
          
          Opal.def(self, '$_reduce_16', $Parser__reduce_16$19 = function $$_reduce_16(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "-", val['$[]'](2));
            return result;
          }, $Parser__reduce_16$19.$$arity = 3);
          
          Opal.def(self, '$_reduce_18', $Parser__reduce_18$20 = function $$_reduce_18(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "*", val['$[]'](2));
            return result;
          }, $Parser__reduce_18$20.$$arity = 3);
          
          Opal.def(self, '$_reduce_19', $Parser__reduce_19$21 = function $$_reduce_19(val, _values, result) {
            var self = this, divied_class = nil;

            
            divied_class = val['$[]'](3);
            result = divied_class.$new(val['$[]'](0), val['$[]'](2));
            return result;
          }, $Parser__reduce_19$21.$$arity = 3);
          
          Opal.def(self, '$_reduce_21', $Parser__reduce_21$22 = function $$_reduce_21(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithGameSystemDefault');
            return result;
          }, $Parser__reduce_21$22.$$arity = 3);
          
          Opal.def(self, '$_reduce_22', $Parser__reduce_22$23 = function $$_reduce_22(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
            return result;
          }, $Parser__reduce_22$23.$$arity = 3);
          
          Opal.def(self, '$_reduce_23', $Parser__reduce_23$24 = function $$_reduce_23(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
            return result;
          }, $Parser__reduce_23$24.$$arity = 3);
          
          Opal.def(self, '$_reduce_24', $Parser__reduce_24$25 = function $$_reduce_24(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithRound');
            return result;
          }, $Parser__reduce_24$25.$$arity = 3);
          
          Opal.def(self, '$_reduce_25', $Parser__reduce_25$26 = function $$_reduce_25(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithFloor');
            return result;
          }, $Parser__reduce_25$26.$$arity = 3);
          
          Opal.def(self, '$_reduce_26', $Parser__reduce_26$27 = function $$_reduce_26(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_26$27.$$arity = 3);
          
          Opal.def(self, '$_reduce_27', $Parser__reduce_27$28 = function $$_reduce_27(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Negative').$new(val['$[]'](1));
            return result;
          }, $Parser__reduce_27$28.$$arity = 3);
          
          Opal.def(self, '$_reduce_29', $Parser__reduce_29$29 = function $$_reduce_29(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_29$29.$$arity = 3);
          
          Opal.def(self, '$_reduce_30', $Parser__reduce_30$30 = function $$_reduce_30(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Number').$new(val['$[]'](0));
            return result;
          }, $Parser__reduce_30$30.$$arity = 3);
          return (Opal.def(self, '$_reduce_none', $Parser__reduce_none$31 = function $$_reduce_none(val, _values, result) {
            var self = this;

            return val['$[]'](0)
          }, $Parser__reduce_none$31.$$arity = 3), nil) && '_reduce_none';
        })($nesting[0], $$$($$($nesting, 'Racc'), 'Parser'), $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/reroll_dice"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $send = Opal.send;

  
  self.$require("bcdice/normalize");
  self.$require("bcdice/format");
  self.$require("bcdice/common_command/reroll_dice/parser");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'RerollDice');

        var $nesting = [self].concat($parent_nesting);

        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /\d+R\d+/.$freeze());
        Opal.const_set($nesting[0], 'REROLL_LIMIT', 10000);
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1;

          return (Opal.def(self, '$eval', $eval$1 = function(command, game_system, randomizer) {
            var $a, self = this, cmd = nil;

            
            cmd = $$($nesting, 'Parser').$parse(command);
            return ($a = cmd, ($a === nil || $a == null) ? nil : $send($a, 'eval', [game_system, randomizer]));
          }, $eval$1.$$arity = 3), nil) && 'eval'
        })(Opal.get_singleton_class(self), $nesting);
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/upper_dice/node"] = function(Opal) {
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash2 = Opal.hash2, $send = Opal.send, $truthy = Opal.truthy;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'UpperDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $parent_nesting) {
          var self = $module($base, 'Node');

          var $nesting = [self].concat($parent_nesting);

          
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Command');

            var $nesting = [self].concat($parent_nesting), $Command_initialize$1, $Command_eval$2, $Command_result_success_count$5, $Command_result_max_sum$7, $Command_interlim_expr$10, $Command_expr$12, $Command_result_with_text$13;

            self.$$prototype.notations = self.$$prototype.reroll_threshold = self.$$prototype.modifier = self.$$prototype.target_number = self.$$prototype.cmp_op = nil;
            
            
            Opal.def(self, '$initialize', $Command_initialize$1 = function $$initialize($kwargs) {
              var secret, notations, modifier, cmp_op, target_number, reroll_threshold, self = this;

              
              
              if ($kwargs == null) {
                $kwargs = $hash2([], {});
              } else if (!$kwargs.$$is_hash) {
                throw Opal.ArgumentError.$new('expected kwargs');
              };
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'secret')) {
                throw Opal.ArgumentError.$new('missing keyword: secret');
              }
              secret = $kwargs.$$smap["secret"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'notations')) {
                throw Opal.ArgumentError.$new('missing keyword: notations');
              }
              notations = $kwargs.$$smap["notations"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'modifier')) {
                throw Opal.ArgumentError.$new('missing keyword: modifier');
              }
              modifier = $kwargs.$$smap["modifier"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'cmp_op')) {
                throw Opal.ArgumentError.$new('missing keyword: cmp_op');
              }
              cmp_op = $kwargs.$$smap["cmp_op"];;
              
              if (!Opal.hasOwnProperty.call($kwargs.$$smap, 'target_number')) {
                throw Opal.ArgumentError.$new('missing keyword: target_number');
              }
              target_number = $kwargs.$$smap["target_number"];;
              
              reroll_threshold = $kwargs.$$smap["reroll_threshold"];
              if (reroll_threshold == null) {
                reroll_threshold = nil
              };
              self.secret = secret;
              self.notations = notations;
              self.modifier = modifier;
              self.cmp_op = cmp_op;
              self.target_number = target_number;
              return (self.reroll_threshold = reroll_threshold);
            }, $Command_initialize$1.$$arity = 1);
            
            Opal.def(self, '$eval', $Command_eval$2 = function(game_system, randomizer) {
              var $$3, $a, $b, $c, $$4, self = this, round_type = nil, dice_list = nil, reroll_threshold = nil, $ret_or_1 = nil, $ret_or_2 = nil, modifier = nil, $ret_or_3 = nil, target_number = nil, expr = nil, roll_list = nil, result = nil, sequence = nil;

              
              round_type = game_system.$round_type();
              dice_list = $send(self.notations, 'map', [], ($$3 = function(n){var self = $$3.$$s == null ? this : $$3.$$s;

              
                
                if (n == null) {
                  n = nil;
                };
                return n.$to_dice(round_type);}, $$3.$$s = self, $$3.$$arity = 1, $$3));
              reroll_threshold = (function() {if ($truthy(($ret_or_1 = (function() {if ($truthy(($ret_or_2 = ($a = self.reroll_threshold, ($a === nil || $a == null) ? nil : $send($a, 'eval', [round_type]))))) {
                return $ret_or_2
              } else {
                return game_system.$upper_dice_reroll_threshold()
              }; return nil; })()))) {
                return $ret_or_1
              } else {
                return 0
              }; return nil; })();
              modifier = (function() {if ($truthy(($ret_or_3 = ($b = self.modifier, ($b === nil || $b == null) ? nil : $send($b, 'eval', [round_type]))))) {
                return $ret_or_3
              } else {
                return 0
              }; return nil; })();
              target_number = ($c = self.target_number, ($c === nil || $c == null) ? nil : $send($c, 'eval', [round_type]));
              expr = self.$expr(dice_list, reroll_threshold, modifier, target_number);
              if ($truthy($rb_le(reroll_threshold, 1))) {
                return self.$result_with_text("" + "(" + (expr) + ") ＞ 無限ロールの条件がまちがっています")};
              roll_list = $send(dice_list, 'map', [], ($$4 = function(n){var self = $$4.$$s == null ? this : $$4.$$s;

              
                
                if (n == null) {
                  n = nil;
                };
                return n.$roll(randomizer, reroll_threshold, game_system['$sort_barabara_dice?']());}, $$4.$$s = self, $$4.$$arity = 1, $$4)).$reduce([], "concat");
              result = (function() {if ($truthy(self.cmp_op)) {
                return self.$result_success_count(roll_list, modifier, target_number)
              } else {
                return self.$result_max_sum(roll_list, modifier)
              }; return nil; })();
              sequence = ["" + "(" + (expr) + ")", self.$interlim_expr(roll_list, modifier), result];
              return self.$result_with_text(sequence.$join(" ＞ "));
            }, $Command_eval$2.$$arity = 2);
            self.$private();
            
            Opal.def(self, '$result_success_count', $Command_result_success_count$5 = function $$result_success_count(roll_list, modifier, target_number) {
              var $$6, self = this, success_count = nil;

              
              success_count = $send(roll_list, 'count', [], ($$6 = function(e){var self = $$6.$$s == null ? this : $$6.$$s, x = nil;
                if (self.cmp_op == null) self.cmp_op = nil;

              
                
                if (e == null) {
                  e = nil;
                };
                x = $rb_plus(e['$[]']("sum"), modifier);
                return x.$send(self.cmp_op, target_number);}, $$6.$$s = self, $$6.$$arity = 1, $$6));
              return "" + "成功数" + (success_count);
            }, $Command_result_success_count$5.$$arity = 3);
            
            Opal.def(self, '$result_max_sum', $Command_result_max_sum$7 = function $$result_max_sum(roll_list, modifier) {
              var $$8, $$9, self = this, sum_list = nil, total = nil, max = nil;

              
              sum_list = $send(roll_list, 'map', [], ($$8 = function(e){var self = $$8.$$s == null ? this : $$8.$$s;

              
                
                if (e == null) {
                  e = nil;
                };
                return e['$[]']("sum");}, $$8.$$s = self, $$8.$$arity = 1, $$8));
              total = $rb_plus(sum_list.$sum(), modifier);
              max = $send(sum_list, 'map', [], ($$9 = function(i){var self = $$9.$$s == null ? this : $$9.$$s;

              
                
                if (i == null) {
                  i = nil;
                };
                return $rb_plus(i, modifier);}, $$9.$$s = self, $$9.$$arity = 1, $$9)).$max();
              return "" + (max) + "/" + (total) + "(最大/合計)";
            }, $Command_result_max_sum$7.$$arity = 2);
            
            Opal.def(self, '$interlim_expr', $Command_interlim_expr$10 = function $$interlim_expr(roll_list, modifier) {
              var $$11, self = this, dice = nil;

              
              dice = $send(roll_list, 'map', [], ($$11 = function(e){var self = $$11.$$s == null ? this : $$11.$$s;

              
                
                if (e == null) {
                  e = nil;
                };
                if (e['$[]']("list").$size()['$=='](1)) {
                  return e['$[]']("sum")
                } else {
                  return "" + (e['$[]']("sum")) + "[" + (e['$[]']("list").$join(",")) + "]"
                };}, $$11.$$s = self, $$11.$$arity = 1, $$11)).$join(",");
              return $rb_plus(dice, $$($nesting, 'Format').$modifier(modifier));
            }, $Command_interlim_expr$10.$$arity = 2);
            
            Opal.def(self, '$expr', $Command_expr$12 = function $$expr(dice_list, reroll_threshold, modifier, target_number) {
              var self = this, formated_cmp_op = nil, formated_modifier = nil;

              
              formated_cmp_op = $$($nesting, 'Format').$comparison_operator(self.cmp_op);
              formated_modifier = $$($nesting, 'Format').$modifier(modifier);
              return "" + (dice_list.$join("+")) + "[" + (reroll_threshold) + "]" + (formated_modifier) + (formated_cmp_op) + (target_number);
            }, $Command_expr$12.$$arity = 4);
            return (Opal.def(self, '$result_with_text', $Command_result_with_text$13 = function $$result_with_text(text) {
              var $$14, self = this;

              return $send($$($nesting, 'Result').$new(), 'tap', [], ($$14 = function(r){var self = $$14.$$s == null ? this : $$14.$$s, $writer = nil;
                if (self.secret == null) self.secret = nil;

              
                
                if (r == null) {
                  r = nil;
                };
                
                $writer = [self.secret];
                $send(r, 'secret=', Opal.to_a($writer));
                $writer[$rb_minus($writer["length"], 1)];;
                
                $writer = [text];
                $send(r, 'text=', Opal.to_a($writer));
                return $writer[$rb_minus($writer["length"], 1)];;}, $$14.$$s = self, $$14.$$arity = 1, $$14))
            }, $Command_result_with_text$13.$$arity = 1), nil) && 'result_with_text';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Notation');

            var $nesting = [self].concat($parent_nesting), $Notation_initialize$15, $Notation_to_dice$16;

            self.$$prototype.roll_times = self.$$prototype.sides = nil;
            
            
            Opal.def(self, '$initialize', $Notation_initialize$15 = function $$initialize(roll_times, sides) {
              var self = this;

              
              self.roll_times = roll_times;
              return (self.sides = sides);
            }, $Notation_initialize$15.$$arity = 2);
            return (Opal.def(self, '$to_dice', $Notation_to_dice$16 = function $$to_dice(round_type) {
              var self = this, roll_times = nil, sides = nil;

              
              roll_times = self.roll_times.$eval(round_type);
              sides = self.sides.$eval(round_type);
              return $$($nesting, 'Dice').$new(roll_times, sides);
            }, $Notation_to_dice$16.$$arity = 1), nil) && 'to_dice';
          })($nesting[0], null, $nesting);
          (function($base, $super, $parent_nesting) {
            var self = $klass($base, $super, 'Dice');

            var $nesting = [self].concat($parent_nesting), $Dice_initialize$17, $Dice_roll$18, $Dice_to_s$21, $Dice_roll_ones$22;

            self.$$prototype.roll_times = self.$$prototype.sides = nil;
            
            
            Opal.def(self, '$initialize', $Dice_initialize$17 = function $$initialize(roll_times, sides) {
              var self = this;

              
              self.roll_times = roll_times;
              return (self.sides = sides);
            }, $Dice_initialize$17.$$arity = 2);
            
            Opal.def(self, '$roll', $Dice_roll$18 = function $$roll(randomizer, reroll_threshold, sort) {
              var $$19, $$20, self = this, ret = nil;

              
              ret = $send($$($nesting, 'Array'), 'new', [self.roll_times], ($$19 = function(){var self = $$19.$$s == null ? this : $$19.$$s, list = nil;

              
                list = self.$roll_ones(randomizer, reroll_threshold);
                return $hash2(["sum", "list"], {"sum": list.$sum(), "list": list});}, $$19.$$s = self, $$19.$$arity = 0, $$19));
              if ($truthy(sort)) {
                ret = $send(ret, 'sort_by', [], ($$20 = function(e){var self = $$20.$$s == null ? this : $$20.$$s;

                
                  
                  if (e == null) {
                    e = nil;
                  };
                  return e['$[]']("sum");}, $$20.$$s = self, $$20.$$arity = 1, $$20))};
              return ret;
            }, $Dice_roll$18.$$arity = 3);
            
            Opal.def(self, '$to_s', $Dice_to_s$21 = function $$to_s() {
              var self = this;

              return "" + (self.roll_times) + "U" + (self.sides)
            }, $Dice_to_s$21.$$arity = 0);
            self.$private();
            return (Opal.def(self, '$roll_ones', $Dice_roll_ones$22 = function $$roll_ones(randomizer, reroll_threshold) {
              var $$23, self = this, dice_list = nil;

              
              dice_list = [];
              (function(){var $brk = Opal.new_brk(); try {return $send(self, 'loop', [], ($$23 = function(){var self = $$23.$$s == null ? this : $$23.$$s, value = nil;
                if (self.sides == null) self.sides = nil;

              
                value = randomizer.$roll_once(self.sides);
                dice_list.$push(value);
                if ($truthy($rb_lt(value, reroll_threshold))) {
                  
                  Opal.brk(nil, $brk)
                } else {
                  return nil
                };}, $$23.$$s = self, $$23.$$brk = $brk, $$23.$$arity = 0, $$23))
              } catch (err) { if (err === $brk) { return err.$v } else { throw err } }})();
              return dice_list;
            }, $Dice_roll_ones$22.$$arity = 2), nil) && 'roll_ones';
          })($nesting[0], null, $nesting);
        })($nesting[0], $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/upper_dice/parser"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $klass = Opal.klass, $hash = Opal.hash, $hash2 = Opal.hash2, $truthy = Opal.truthy;

  
  self.$require("racc/parser.rb");
  self.$require("bcdice/common_command/lexer");
  self.$require("bcdice/common_command/upper_dice/node");
  self.$require("bcdice/arithmetic/node");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'UpperDice');

        var $nesting = [self].concat($parent_nesting);

        (function($base, $super, $parent_nesting) {
          var self = $klass($base, $super, 'Parser');

          var $nesting = [self].concat($parent_nesting), $Parser_parse$1, $Parser_parse$2, $Parser_next_token$3, $Parser__reduce_1$4, $Parser__reduce_2$5, $Parser__reduce_3$6, $Parser__reduce_4$7, $Parser__reduce_5$8, $Parser__reduce_6$9, $Parser__reduce_7$10, $Parser__reduce_8$11, $Parser__reduce_9$12, $Parser__reduce_10$13, $Parser__reduce_11$14, $Parser__reduce_12$15, $Parser__reduce_13$16, $Parser__reduce_14$17, $Parser__reduce_15$18, $Parser__reduce_16$19, $Parser__reduce_17$20, $Parser__reduce_18$21, $Parser__reduce_19$22, $Parser__reduce_20$23, $Parser__reduce_22$24, $Parser__reduce_23$25, $Parser__reduce_25$26, $Parser__reduce_26$27, $Parser__reduce_27$28, $Parser__reduce_28$29, $Parser__reduce_29$30, $Parser__reduce_30$31, $Parser__reduce_31$32, $Parser__reduce_33$33, $Parser__reduce_34$34, $Parser__reduce_none$35, racc_action_table = nil, racc_action_check = nil, racc_action_pointer = nil, racc_action_default = nil, racc_goto_table = nil, racc_goto_check = nil, racc_goto_pointer = nil, racc_goto_default = nil, racc_reduce_table = nil, racc_reduce_n = nil, racc_shift_n = nil, racc_token_table = nil, racc_nt_base = nil, racc_use_result_var = nil;

          self.$$prototype.lexer = nil;
          
          Opal.defs(self, '$parse', $Parser_parse$1 = function $$parse(source) {
            var self = this;

            return self.$new().$parse(source)
          }, $Parser_parse$1.$$arity = 1);
          
          Opal.def(self, '$parse', $Parser_parse$2 = function $$parse(source) {
            var self = this;

            try {
              
              self.lexer = $$($nesting, 'Lexer').$new(source);
              return self.$do_parse();
            } catch ($err) {
              if (Opal.rescue($err, [$$($nesting, 'ParseError')])) {
                try {
                  return nil
                } finally { Opal.pop_exception() }
              } else { throw $err; }
            }
          }, $Parser_parse$2.$$arity = 1);
          self.$private();
          
          Opal.def(self, '$next_token', $Parser_next_token$3 = function $$next_token() {
            var self = this;

            return self.lexer.$next_token()
          }, $Parser_next_token$3.$$arity = 0);
          racc_action_table = [9, 9, 36, 37, 3, 9, 9, 21, 22, 49, 8, 8, 21, 22, 9, 8, 8, 14, 15, 9, 21, 22, 4, 16, 8, 21, 22, 9, 10, 8, 36, 37, 9, 21, 22, 38, 17, 8, 21, 22, 9, 25, 8, 27, 15, 9, 21, 22, 28, 29, 8, 21, 22, 9, 44, 8, 39, 40, 9, 21, 22, 39, 40, 8, 21, 22, 9, 25, 8, 39, 40, 9, 21, 22, 36, 37, 8, 21, 22, 9, 17, 8, 39, 40, 9, 21, 22, 39, 40, 8, 21, 22, 9, nil, 8, 39, 40, nil, 21, 22, 39, 40, 8, 58, 56, 57, 59, 36, 37];
          racc_action_check = [2, 8, 34, 34, 0, 17, 14, 8, 8, 34, 2, 8, 14, 14, 15, 17, 14, 5, 5, 16, 15, 15, 1, 5, 15, 16, 16, 21, 4, 16, 18, 18, 22, 21, 21, 18, 7, 21, 22, 22, 25, 11, 22, 12, 12, 27, 25, 25, 13, 13, 25, 27, 27, 28, 24, 27, 19, 19, 29, 28, 28, 30, 30, 28, 29, 29, 36, 26, 29, 33, 33, 37, 36, 36, 45, 45, 36, 37, 37, 39, 32, 37, 47, 47, 40, 39, 39, 48, 48, 39, 40, 40, 44, nil, 40, 50, 50, nil, 44, 44, 51, 51, 44, 53, 53, 53, 53, 54, 54];
          racc_action_pointer = [-3, 22, -2, nil, 28, 9, nil, 32, -1, nil, nil, 20, 35, 40, 4, 12, 17, 3, 22, 46, nil, 25, 30, nil, 34, 38, 46, 43, 51, 56, 51, nil, 76, 59, -6, nil, 64, 69, nil, 77, 82, nil, nil, nil, 90, 66, nil, 72, 77, nil, 85, 90, nil, 100, 99, nil, nil, nil, nil, nil];
          racc_action_default = [-4, -35, -35, -5, -35, -6, -17, -35, -35, -34, 60, -12, -6, -7, -35, -35, -35, -35, -35, -21, -24, -35, -35, -32, -1, -35, -12, -35, -35, -35, -8, -16, -32, -9, -35, -18, -35, -35, -33, -35, -35, -30, -31, -3, -35, -13, -2, -10, -11, -14, -19, -20, -22, -25, -15, -23, -26, -27, -28, -29];
          racc_goto_table = [18, 30, 33, 41, 42, 24, 6, 1, 34, 2, 5, 12, 11, 7, 30, 47, 48, 45, 31, 26, 46, 52, 53, 50, 51, 32, 43, 55, 35, nil, nil, nil, nil, nil, nil, nil, 54];
          racc_goto_check = [10, 9, 9, 13, 13, 5, 11, 1, 10, 2, 3, 6, 4, 12, 9, 9, 9, 10, 11, 4, 5, 13, 13, 9, 9, 12, 7, 14, 12, nil, nil, nil, nil, nil, nil, nil, 10];
          racc_goto_pointer = [nil, 7, 9, 8, 7, -6, 6, 2, nil, -13, -8, 4, 11, -18, -26];
          racc_goto_default = [nil, nil, nil, nil, nil, nil, nil, nil, 13, 19, nil, nil, 23, 20, nil];
          racc_reduce_table = [0, 0, "racc_error", 4, 23, "_reduce_1", 5, 23, "_reduce_2", 5, 23, "_reduce_3", 0, 24, "_reduce_4", 1, 24, "_reduce_5", 0, 26, "_reduce_6", 1, 26, "_reduce_7", 2, 30, "_reduce_8", 2, 30, "_reduce_9", 3, 30, "_reduce_10", 3, 30, "_reduce_11", 0, 27, "_reduce_12", 2, 27, "_reduce_13", 3, 28, "_reduce_14", 2, 29, "_reduce_15", 3, 25, "_reduce_16", 1, 25, "_reduce_17", 3, 33, "_reduce_18", 3, 32, "_reduce_19", 3, 32, "_reduce_20", 1, 32, "_reduce_none", 3, 31, "_reduce_22", 4, 31, "_reduce_23", 1, 31, "_reduce_none", 0, 36, "_reduce_25", 1, 36, "_reduce_26", 1, 36, "_reduce_27", 1, 36, "_reduce_28", 1, 36, "_reduce_29", 2, 35, "_reduce_30", 2, 35, "_reduce_31", 1, 35, "_reduce_none", 3, 34, "_reduce_33", 1, 34, "_reduce_34"];
          racc_reduce_n = 35;
          racc_shift_n = 60;
          racc_token_table = $hash(false, 0, "error", 1, "NUMBER", 2, "R", 3, "U", 4, "C", 5, "F", 6, "S", 7, "PLUS", 8, "MINUS", 9, "ASTERISK", 10, "SLASH", 11, "PARENL", 12, "PARENR", 13, "BRACKETL", 14, "BRACKETR", 15, "LESS", 16, "GREATER", 17, "EQUAL", 18, "NOT", 19, "AT", 20, "CMP_OP", 21);
          racc_nt_base = 22;
          racc_use_result_var = true;
          Opal.const_set($nesting[0], 'Racc_arg', [racc_action_table, racc_action_check, racc_action_default, racc_action_pointer, racc_goto_table, racc_goto_check, racc_goto_default, racc_goto_pointer, racc_nt_base, racc_reduce_table, racc_token_table, racc_shift_n, racc_reduce_n, racc_use_result_var]);
          Opal.const_set($nesting[0], 'Racc_token_to_s_table', ["$end", "error", "NUMBER", "R", "U", "C", "F", "S", "PLUS", "MINUS", "ASTERISK", "SLASH", "PARENL", "PARENR", "BRACKETL", "BRACKETR", "LESS", "GREATER", "EQUAL", "NOT", "AT", "CMP_OP", "$start", "expr", "secret", "notations", "modifier", "target", "bracket", "at", "modifier_expr", "mul", "add", "dice", "term", "unary", "round_type"]);
          Opal.const_set($nesting[0], 'Racc_debug_parser', false);
          
          Opal.def(self, '$_reduce_1', $Parser__reduce_1$4 = function $$_reduce_1(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'UpperDice'), 'Node'), 'Command').$new($hash2(["secret", "notations", "modifier", "cmp_op", "target_number"], {"secret": val['$[]'](0), "notations": val['$[]'](1), "modifier": val['$[]'](2), "cmp_op": val['$[]'](3)['$[]']("cmp_op"), "target_number": val['$[]'](3)['$[]']("target")}));
            return result;
          }, $Parser__reduce_1$4.$$arity = 3);
          
          Opal.def(self, '$_reduce_2', $Parser__reduce_2$5 = function $$_reduce_2(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'UpperDice'), 'Node'), 'Command').$new($hash2(["secret", "notations", "modifier", "cmp_op", "target_number", "reroll_threshold"], {"secret": val['$[]'](0), "notations": val['$[]'](1), "modifier": val['$[]'](3), "cmp_op": val['$[]'](4)['$[]']("cmp_op"), "target_number": val['$[]'](4)['$[]']("target"), "reroll_threshold": val['$[]'](2)}));
            return result;
          }, $Parser__reduce_2$5.$$arity = 3);
          
          Opal.def(self, '$_reduce_3', $Parser__reduce_3$6 = function $$_reduce_3(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'UpperDice'), 'Node'), 'Command').$new($hash2(["secret", "notations", "modifier", "cmp_op", "target_number", "reroll_threshold"], {"secret": val['$[]'](0), "notations": val['$[]'](1), "modifier": val['$[]'](2), "cmp_op": val['$[]'](3)['$[]']("cmp_op"), "target_number": val['$[]'](3)['$[]']("target"), "reroll_threshold": val['$[]'](4)}));
            return result;
          }, $Parser__reduce_3$6.$$arity = 3);
          
          Opal.def(self, '$_reduce_4', $Parser__reduce_4$7 = function $$_reduce_4(val, _values, result) {
            var self = this;

            
            result = false;
            return result;
          }, $Parser__reduce_4$7.$$arity = 3);
          
          Opal.def(self, '$_reduce_5', $Parser__reduce_5$8 = function $$_reduce_5(val, _values, result) {
            var self = this;

            
            result = true;
            return result;
          }, $Parser__reduce_5$8.$$arity = 3);
          
          Opal.def(self, '$_reduce_6', $Parser__reduce_6$9 = function $$_reduce_6(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Number').$new(0);
            return result;
          }, $Parser__reduce_6$9.$$arity = 3);
          
          Opal.def(self, '$_reduce_7', $Parser__reduce_7$10 = function $$_reduce_7(val, _values, result) {
            var self = this;

            
            result = val['$[]'](0);
            return result;
          }, $Parser__reduce_7$10.$$arity = 3);
          
          Opal.def(self, '$_reduce_8', $Parser__reduce_8$11 = function $$_reduce_8(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_8$11.$$arity = 3);
          
          Opal.def(self, '$_reduce_9', $Parser__reduce_9$12 = function $$_reduce_9(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Negative').$new(val['$[]'](1));
            return result;
          }, $Parser__reduce_9$12.$$arity = 3);
          
          Opal.def(self, '$_reduce_10', $Parser__reduce_10$13 = function $$_reduce_10(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "+", val['$[]'](2));
            return result;
          }, $Parser__reduce_10$13.$$arity = 3);
          
          Opal.def(self, '$_reduce_11', $Parser__reduce_11$14 = function $$_reduce_11(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "-", val['$[]'](2));
            return result;
          }, $Parser__reduce_11$14.$$arity = 3);
          
          Opal.def(self, '$_reduce_12', $Parser__reduce_12$15 = function $$_reduce_12(val, _values, result) {
            var self = this;

            
            result = $hash2([], {});
            return result;
          }, $Parser__reduce_12$15.$$arity = 3);
          
          Opal.def(self, '$_reduce_13', $Parser__reduce_13$16 = function $$_reduce_13(val, _values, result) {
            var $a, $b, self = this, cmp_op = nil, target = nil;

            
            $b = val, $a = Opal.to_ary($b), (cmp_op = ($a[0] == null ? nil : $a[0])), (target = ($a[1] == null ? nil : $a[1])), $b;
            if ($truthy(cmp_op)) {
            } else {
              self.$raise($$($nesting, 'ParseError'))
            };
            result = $hash2(["cmp_op", "target"], {"cmp_op": cmp_op, "target": target});
            return result;
          }, $Parser__reduce_13$16.$$arity = 3);
          
          Opal.def(self, '$_reduce_14', $Parser__reduce_14$17 = function $$_reduce_14(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_14$17.$$arity = 3);
          
          Opal.def(self, '$_reduce_15', $Parser__reduce_15$18 = function $$_reduce_15(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_15$18.$$arity = 3);
          
          Opal.def(self, '$_reduce_16', $Parser__reduce_16$19 = function $$_reduce_16(val, _values, result) {
            var self = this, notations = nil;

            
            notations = val['$[]'](0);
            notations.$push(val['$[]'](2));
            result = notations;
            return result;
          }, $Parser__reduce_16$19.$$arity = 3);
          
          Opal.def(self, '$_reduce_17', $Parser__reduce_17$20 = function $$_reduce_17(val, _values, result) {
            var self = this;

            
            result = [val['$[]'](0)];
            return result;
          }, $Parser__reduce_17$20.$$arity = 3);
          
          Opal.def(self, '$_reduce_18', $Parser__reduce_18$21 = function $$_reduce_18(val, _values, result) {
            var self = this, times = nil, sides = nil;

            
            times = val['$[]'](0);
            sides = val['$[]'](2);
            result = $$$($$$($$($nesting, 'UpperDice'), 'Node'), 'Notation').$new(times, sides);
            return result;
          }, $Parser__reduce_18$21.$$arity = 3);
          
          Opal.def(self, '$_reduce_19', $Parser__reduce_19$22 = function $$_reduce_19(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "+", val['$[]'](2));
            return result;
          }, $Parser__reduce_19$22.$$arity = 3);
          
          Opal.def(self, '$_reduce_20', $Parser__reduce_20$23 = function $$_reduce_20(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "-", val['$[]'](2));
            return result;
          }, $Parser__reduce_20$23.$$arity = 3);
          
          Opal.def(self, '$_reduce_22', $Parser__reduce_22$24 = function $$_reduce_22(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'BinaryOp').$new(val['$[]'](0), "*", val['$[]'](2));
            return result;
          }, $Parser__reduce_22$24.$$arity = 3);
          
          Opal.def(self, '$_reduce_23', $Parser__reduce_23$25 = function $$_reduce_23(val, _values, result) {
            var self = this, divied_class = nil;

            
            divied_class = val['$[]'](3);
            result = divied_class.$new(val['$[]'](0), val['$[]'](2));
            return result;
          }, $Parser__reduce_23$25.$$arity = 3);
          
          Opal.def(self, '$_reduce_25', $Parser__reduce_25$26 = function $$_reduce_25(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithGameSystemDefault');
            return result;
          }, $Parser__reduce_25$26.$$arity = 3);
          
          Opal.def(self, '$_reduce_26', $Parser__reduce_26$27 = function $$_reduce_26(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
            return result;
          }, $Parser__reduce_26$27.$$arity = 3);
          
          Opal.def(self, '$_reduce_27', $Parser__reduce_27$28 = function $$_reduce_27(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithCeil');
            return result;
          }, $Parser__reduce_27$28.$$arity = 3);
          
          Opal.def(self, '$_reduce_28', $Parser__reduce_28$29 = function $$_reduce_28(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithRound');
            return result;
          }, $Parser__reduce_28$29.$$arity = 3);
          
          Opal.def(self, '$_reduce_29', $Parser__reduce_29$30 = function $$_reduce_29(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'DivideWithFloor');
            return result;
          }, $Parser__reduce_29$30.$$arity = 3);
          
          Opal.def(self, '$_reduce_30', $Parser__reduce_30$31 = function $$_reduce_30(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_30$31.$$arity = 3);
          
          Opal.def(self, '$_reduce_31', $Parser__reduce_31$32 = function $$_reduce_31(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Negative').$new(val['$[]'](1));
            return result;
          }, $Parser__reduce_31$32.$$arity = 3);
          
          Opal.def(self, '$_reduce_33', $Parser__reduce_33$33 = function $$_reduce_33(val, _values, result) {
            var self = this;

            
            result = val['$[]'](1);
            return result;
          }, $Parser__reduce_33$33.$$arity = 3);
          
          Opal.def(self, '$_reduce_34', $Parser__reduce_34$34 = function $$_reduce_34(val, _values, result) {
            var self = this;

            
            result = $$$($$$($$($nesting, 'Arithmetic'), 'Node'), 'Number').$new(val['$[]'](0));
            return result;
          }, $Parser__reduce_34$34.$$arity = 3);
          return (Opal.def(self, '$_reduce_none', $Parser__reduce_none$35 = function $$_reduce_none(val, _values, result) {
            var self = this;

            return val['$[]'](0)
          }, $Parser__reduce_none$35.$$arity = 3), nil) && '_reduce_none';
        })($nesting[0], $$$($$($nesting, 'Racc'), 'Parser'), $nesting)
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/upper_dice"] = function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $send = Opal.send;

  
  self.$require("bcdice/common_command/upper_dice/parser");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'UpperDice');

        var $nesting = [self].concat($parent_nesting);

        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /\d+U\d+/.$freeze());
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1;

          return (Opal.def(self, '$eval', $eval$1 = function(command, game_system, randomizer) {
            var $a, self = this, cmd = nil;

            
            cmd = $$($nesting, 'Parser').$parse(command);
            return ($a = cmd, ($a === nil || $a == null) ? nil : $send($a, 'eval', [game_system, randomizer]));
          }, $eval$1.$$arity = 3), nil) && 'eval'
        })(Opal.get_singleton_class(self), $nesting);
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
};

/* Generated by Opal 1.1.1 */
Opal.modules["bcdice/common_command/version"] = function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module, $truthy = Opal.truthy, $send = Opal.send;

  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      (function($base, $parent_nesting) {
        var self = $module($base, 'Version');

        var $nesting = [self].concat($parent_nesting);

        
        Opal.const_set($nesting[0], 'PREFIX_PATTERN', /BCDiceVersion/.$freeze());
        (function(self, $parent_nesting) {
          var $nesting = [self].concat($parent_nesting), $eval$1;

          return (Opal.def(self, '$eval', $eval$1 = function(command, _game_system, _randomizer) {
            var $$2, self = this;

            
            command = command.$split(" ", 2).$first();
            if ($truthy(command['$match?'](/^BCDiceVersion$/i))) {
              return $send($$($nesting, 'Result').$new(), 'tap', [], ($$2 = function(r){var self = $$2.$$s == null ? this : $$2.$$s, $writer = nil;

              
                
                if (r == null) {
                  r = nil;
                };
                $writer = ["" + "BCDice " + ($$$($$($nesting, 'BCDice'), 'VERSION'))];
                $send(r, 'text=', Opal.to_a($writer));
                return $writer[$rb_minus($writer["length"], 1)];}, $$2.$$s = self, $$2.$$arity = 1, $$2))
            } else {
              return nil
            };
          }, $eval$1.$$arity = 3), nil) && 'eval'
        })(Opal.get_singleton_class(self), $nesting);
      })($nesting[0], $nesting)
    })($nesting[0], $nesting)
  })($nesting[0], $nesting)
};

/* Generated by Opal 1.1.1 */
(function(Opal) {
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.$$$, $$ = Opal.$$, $module = Opal.module;

  
  self.$require("bcdice/common_command/add_dice");
  self.$require("bcdice/common_command/barabara_dice");
  self.$require("bcdice/common_command/calc");
  self.$require("bcdice/common_command/choice");
  self.$require("bcdice/common_command/d66_dice");
  self.$require("bcdice/common_command/repeat");
  self.$require("bcdice/common_command/reroll_dice");
  self.$require("bcdice/common_command/upper_dice");
  self.$require("bcdice/common_command/version");
  return (function($base, $parent_nesting) {
    var self = $module($base, 'BCDice');

    var $nesting = [self].concat($parent_nesting);

    (function($base, $parent_nesting) {
      var self = $module($base, 'CommonCommand');

      var $nesting = [self].concat($parent_nesting);

      Opal.const_set($nesting[0], 'COMMANDS', [$$($nesting, 'AddDice'), $$($nesting, 'BarabaraDice'), $$($nesting, 'Calc'), $$($nesting, 'Choice'), $$($nesting, 'D66Dice'), $$($nesting, 'Repeat'), $$($nesting, 'RerollDice'), $$($nesting, 'UpperDice'), $$($nesting, 'Version')].$freeze())
    })($nesting[0], $nesting)
  })($nesting[0], $nesting);
})(Opal);
